
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("mxO8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b6ab09e14a5b279$export$2e2bcd8739ae039);
/* view-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $1RDZV = parcelRequire("1RDZV");

var $3cMgR = parcelRequire("3cMgR");

var $ix0Ab = parcelRequire("ix0Ab");

var $bfW07 = parcelRequire("bfW07");

var $dV1IY = parcelRequire("dV1IY");

var $cAbbc = parcelRequire("cAbbc");

var $i2Hw2 = parcelRequire("i2Hw2");

var $cakbO = parcelRequire("cakbO");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");


var $6xDqp = parcelRequire("6xDqp");

var $l7iSF = parcelRequire("l7iSF");

var $dk7W5 = parcelRequire("dk7W5");

var $g90z9 = parcelRequire("g90z9");

var $16sa1 = parcelRequire("16sa1");

var $c5gEr = parcelRequire("c5gEr");

var $iTHAq = parcelRequire("iTHAq");
// eslint-disable-next-line jira/react/no-class-components
class $6b6ab09e14a5b279$var$RendererOld extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'Renderer';
    }
    static{
        this.defaultProps = {
            adf: undefined,
            placeholder: undefined
        };
    }
    constructor(props){
        super(props), this.onInlineCardClicked = (e, url)=>{
            const { linkActions: linkActions } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const event = e || window.event;
            event.preventDefault();
            if ((0, $l7iSF.isExternalLink)(url)) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(url, '_blank', 'noopener,noreferrer');
                return;
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const mouseEvent = event;
            const shouldOpenInNewTab = (0, $6xDqp.isCmdOrCtrlClick)(mouseEvent) || (0, $6xDqp.isMiddleClick)(mouseEvent);
            (0, $i2Hw2.default)(url, shouldOpenInNewTab, linkActions.push);
        }, this.onContentSelected = (e)=>{
            if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            !(e.target instanceof window.Element) || (0, $cAbbc.default)(e.target, e.currentTarget) || this.checkForMedia(e.target, e.currentTarget) || this.checkForTaskItem(e.target, e.currentTarget)) // This is to avoid entering edit mode when clicking on a link, task item, or video.
            e.stopPropagation();
        }, this.checkForMedia = (currentElement, topElement)=>{
            // If we reach the original div, we didn't find a video.
            if (!currentElement || currentElement === topElement) return false;
            // TODO: These checks are unsafe. Use the method outlined in
            // https://jdog.jira-dev.com/browse/BENTO-6367
            if (currentElement.className.includes?.('rich-media-item') || currentElement.className.includes?.('media-file-card-view') || currentElement.className.includes?.('media-viewer-popup') || currentElement.getAttribute('data-testId')?.includes('mediaAbuseModal')) return true;
            // Continue walking up the DOM tree looking for a video.
            return this.checkForMedia(currentElement.parentElement, topElement);
        }, // Can be refactored as an event handler
        // See platform/packages/editor/renderer/src/ui/Renderer/index.tsx
        // and `EventHandlers` from platform/packages/editor/editor-common/src/ui/EventHandlers/index.tsz
        this.checkForTaskItem = (currentElement, topElement, checkboxElement)=>{
            let foundCheckboxElement = checkboxElement;
            // Only consider the checkbox click as the valid event
            // i.e., clicking task item content should still open the edit-view
            if (currentElement?.getAttribute('type') === 'checkbox') foundCheckboxElement = currentElement;
            // If we reach the original element, we didn't find a task item.
            if (!currentElement || currentElement === topElement) return false;
            // Ensure it's an Atlaskit task item by checking `data-task-local-id`
            // See `platform/packages/elements/task-decision/src/components/TaskList.tsx`
            if (currentElement.getAttribute('data-task-local-id') != null && foundCheckboxElement != null) return true;
            // Continue walking up the DOM tree looking for a task item.
            return this.checkForTaskItem(currentElement.parentElement, topElement, foundCheckboxElement);
        }, this.spotlightTargetedOnExtensionNode = false, this.isEmpty = ()=>this.isAdfValueEmpty(), this.isAdfValueEmpty = ()=>{
            const { adf: adf } = this.props;
            // We should change this to an empty ADF object after this ticket is done: https://product-fabric.atlassian.net/browse/CS-235
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return !adf || (0, $dk7W5.isOnlyWhitespaceAdf)(adf);
        }, this.setNodeRef = (element)=>{
            this.node = element;
        };
        const { contextIdentifier: contextIdentifier, mediaProvider: mediaProvider, mentionProvider: mentionProvider, profileCardProvider: profileCardProvider, taskDecisionProvider: taskDecisionProvider } = this.props;
        this.node = null;
        this.dataProviders = new (0, $1RDZV.default)();
        this.dataProviders.setProvider('mediaProvider', mediaProvider);
        this.dataProviders.setProvider('mentionProvider', Promise.resolve(mentionProvider));
        if (!false) {
            let fetchAtStart = false;
            if (this.props.adf != null && typeof this.props.adf !== 'string') try {
                fetchAtStart = (0, $dk7W5.hasEmojiNode)(this.props.adf);
            } catch (_) {
                fetchAtStart = false;
            }
            this.dataProviders.setProvider('emojiProvider', (0, $dV1IY.getEmojiProviderWithCustomEmoji)(this.props.cloudId, this.props.loggedInUserAccountId, fetchAtStart));
        }
        if (contextIdentifier) this.dataProviders.setProvider('contextIdentifierProvider', Promise.resolve(contextIdentifier));
        this.dataProviders.setProvider('profilecardProvider', profileCardProvider);
        this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(taskDecisionProvider));
        this.eventHandlers = {
            smartCard: {
                onClick: this.onInlineCardClicked
            },
            link: {
                onClick: this.onInlineCardClicked
            }
        };
        this.extensionHandlers = {};
        if ((0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view')) this.extensionHandlers = (0, $g90z9.getRedactionExtensionHandler)(()=>{
            if (!this.spotlightTargetedOnExtensionNode) {
                this.spotlightTargetedOnExtensionNode = true;
                return props.fieldId || null;
            }
            return null;
        });
        if ((0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false)) (0, $bfW07.setupEditorExperiments)('jira');
        this.rendererNodeComponentOverrides = (0, $iTHAq.getSyncRendererNodeOverrides)();
    }
    componentDidUpdate(prevProps) {
        if ((0, $7jTnu.fg)('thor_resolve_description_field_jac')) {
            if (prevProps.taskDecisionProvider !== this.props.taskDecisionProvider) this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(this.props.taskDecisionProvider));
        }
    }
    render() {
        const { adf: adf, disableActions: disableActions, placeholder: placeholder } = this.props;
        if (this.isEmpty()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "color.text.subtlest"
        }, placeholder);
        this.spotlightTargetedOnExtensionNode = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "issue-view-media-renderer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            role: "presentation",
            onClick: this.onContentSelected,
            onKeyPress: this.onContentSelected,
            ref: this.setNodeRef,
            className: (0, $hcewu.default)([
                (0, $7jTnu.fg)('platform_editor_initial_width_change') && "_1bsb1osq _7cca15wb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default), {
            appearance: "comment",
            schema: (0, $8DB98.defaultSchema),
            document: (0, $dk7W5.removeCollectionFromAdf)(adf),
            dataProviders: this.dataProviders,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            allowAltTextOnImages: true,
            allowWrapCodeBlock: true,
            allowCopyToClipboard: true,
            media: {
                allowLinking: true,
                featureFlags: (0, $c5gEr.mediaFeatureFlags)()
            },
            portal: this.node,
            disableHeadingIDs: true,
            disableActions: disableActions,
            analyticsEventSeverityTracking: {
                enabled: true,
                severityDegradedThreshold: (0, $fc6bc8f8b3f07886$export$bd6f44214f84c29a),
                severityNormalThreshold: (0, $fc6bc8f8b3f07886$export$aa53f670803b96e)
            },
            unsupportedContentLevelsTracking: (0, $cakbO.getUnsupportedContentLevelsTracking)(),
            useSpecBasedValidator: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $7jTnu.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            smartLinks: {
                hideHoverPreview: false,
                ...(0, $l7iSF.smartLinksDefault)
            },
            UNSTABLE_allowTableResizing: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            UNSTABLE_allowTableAlignment: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            nodeComponents: this.rendererNodeComponentOverrides
        })));
    }
}
const $6b6ab09e14a5b279$var$rendererStyles = null;
var $6b6ab09e14a5b279$export$2e2bcd8739ae039 = $6b6ab09e14a5b279$var$RendererOld;

});
const $fc6bc8f8b3f07886$export$bd6f44214f84c29a = 4102;
const $fc6bc8f8b3f07886$export$aa53f670803b96e = 3165;

parcelRegister("g90z9", function(module, exports) {

$parcel$export(module.exports, "getRedactionExtensionHandler", () => $e6a3ee86ab11edfa$export$fd010a581322717b);
$parcel$export(module.exports, "getRedactionExtension", () => $e6a3ee86ab11edfa$export$12bebc06194b8864);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $95gWV = parcelRequire("95gWV");
const $e6a3ee86ab11edfa$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $e6a3ee86ab11edfa$export$fd010a581322717b = (getSpotlightKey)=>({
        [$e6a3ee86ab11edfa$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
                    name: `redaction-marker-${key}`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {})
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {});
        }
    });

const $e6a3ee86ab11edfa$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $e6a3ee86ab11edfa$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("9lAvQ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $95gWV.RedactionMarker)
                }
            }
        }
    };
};

});
parcelRegister("95gWV", function(module, exports) {

$parcel$export(module.exports, "RedactionMarker", () => $78de67c3958b6156$export$5d1828a8b51af09e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5gWbO = parcelRequire("5gWbO");
const $78de67c3958b6156$var$redactionBarStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative'
});
function $78de67c3958b6156$export$5d1828a8b51af09e() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $eGOwo.fg)('jira-redaction-accessibility-followup')) return /*#__PURE__*/ (0, $gt9Am.jsx)($78de67c3958b6156$var$RedactionBar, {
        "aria-label": formatMessage((0, $5gWbO.default).redactionMarker)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "span",
        xcss: $78de67c3958b6156$var$redactionBarStyles
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $78de67c3958b6156$var$RedactionBar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_16fwhxg": (0, $awdRS.default)(CSS.supports('height', '1lh') ? '1lh' : '1.5em')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _1h1t1q25 _4t3immhw _bfhk1fxt _s7n4nkob _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5gWbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2401d645cf77231$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b2401d645cf77231$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    redactionMarker: {
        id: 'editor-extensions.redaction-extension.redaction-marker-aria-label',
        defaultMessage: 'Redacted content. Your organization has removed sensitive data.',
        description: 'Aria label for redaction marker.'
    }
});

});


parcelRegister("9lAvQ", function(module, exports) {

let $6ce265e0bc3ec318$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ce265e0bc3ec318$var$load("2w0Qi").then(()=>parcelRequire('aUqM7'));

});


parcelRegister("c5gEr", function(module, exports) {

$parcel$export(module.exports, "mediaFeatureFlags", () => $4eb4ae00e7515f1b$export$250985d9ea13242f);
/**
 * Feature flags should be defined individually in './feature-flags.js'
 * There is processing on that file to automate analytics discovery.
 * We import them here so they can be exported as one value and given to
 * Editor/Renderer/Media components.
 *
 * NOTE: The use of functions vs raw values is intentional. You must use
 * `mediaFeatureFlags()` vs `mediaFeatureFlags` due to the fact that these
 * flags won't be available immediately. This relates to SST and launchdarkly.
 * Otherwise the getters would be executed immediately and blank values
 * will be passed.
 */ const $4eb4ae00e7515f1b$export$250985d9ea13242f = ()=>({
        mediaInline: true,
        // TODO: remove after media team clean up securedClipboard: https://product-fabric.atlassian.net/browse/CXP-2664
        securedClipboard: true
    });

});

parcelRegister("iTHAq", function(module, exports) {

$parcel$export(module.exports, "getSyncRendererNodeOverrides", () => $b41b2562099174f2$export$137bebfd245dfe15);

var $LFmXM = parcelRequire("LFmXM");

var $gJPuF = parcelRequire("gJPuF");

var $fNJLN = parcelRequire("fNJLN");

var $7esWo = parcelRequire("7esWo");
const $b41b2562099174f2$export$137bebfd245dfe15 = (0, $LFmXM.default)(()=>({
        ...(0, $gJPuF.default),
        ...(0, $fNJLN.default),
        ...(0, $7esWo.default)
    }));

});
parcelRegister("gJPuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b94e3cd05b38822$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9ug1Y = parcelRequire("9ug1Y");

var $1C1WZ = parcelRequire("1C1WZ");

var $hGXwD = parcelRequire("hGXwD");
/**
 * Synchronous renderer node mapping for card nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $4b94e3cd05b38822$var$nodeToReact = {
    blockCard: (0, $9ug1Y.default),
    embedCard: (0, $1C1WZ.default),
    inlineCard: (0, $hGXwD.default)
};
var $4b94e3cd05b38822$export$2e2bcd8739ae039 = $4b94e3cd05b38822$var$nodeToReact;

});
parcelRegister("9ug1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6209c8e9dcebd53a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $4cFYC = parcelRequire("4cFYC");

var $93FVZ = parcelRequire("93FVZ");
var $dfCRV = parcelRequire("dfCRV");
var $2bEPZ = parcelRequire("2bEPZ");

var $81LfQ = parcelRequire("81LfQ");

var $kL4gV = parcelRequire("kL4gV");

var $hGXwD = parcelRequire("hGXwD");

var $e2B2h = parcelRequire("e2B2h");

var $8KOSq = parcelRequire("8KOSq");

var $8YHJ2 = parcelRequire("8YHJ2");

var $eGOwo = parcelRequire("eGOwo");


var $bnh3n = parcelRequire("bnh3n");
var $7WlTe = parcelRequire("7WlTe");

var $jWNZR = parcelRequire("jWNZR");
const $6209c8e9dcebd53a$var$datasourceContainerStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: `${"var(--ds-border-radius-200, 8px)"}`,
    border: `1px solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`}`,
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    marginBottom: `${"var(--ds-space-150, 0.75rem)"}`,
    transform: 'translateX(-50%)'
});
function $6209c8e9dcebd53a$export$2e2bcd8739ae039(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, isNodeNested: isNodeNested } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const { actionOptions: actionOptions } = smartLinks || {};
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const platform = 'web';
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal,
        isDatasource: !!props.datasource,
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    if (props.datasource) {
        const views = props.datasource.views;
        const tableView = views.find((view)=>view.type === 'table');
        const shouldRenderDatasource = tableView && (0, $7WlTe.canRenderDatasource)(props.datasource.id);
        if (shouldRenderDatasource) {
            const columns = tableView.properties?.columns;
            const visibleColumnKeys = columns?.map(({ key: key })=>key);
            const columnCustomSizesEntries = columns?.filter((c)=>!!c.width).map(({ key: key, width: width })=>[
                    key,
                    width
                ]);
            const columnCustomSizes = columnCustomSizesEntries?.length ? Object.fromEntries(columnCustomSizesEntries) : undefined;
            const wrappedColumnKeys = columns?.filter((c)=>c.isWrapped).map((c)=>c.key);
            const { datasource: datasource, layout: layout } = props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
                unsupportedComponent: (0, $dfCRV.default),
                datasourceId: props.datasource.id,
                ...cardProps
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                    css: $6209c8e9dcebd53a$var$datasourceContainerStyle,
                    "data-testid": "renderer-datasource-table",
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        width: isNodeNested ? '100%' : (0, $bnh3n.calcBreakoutWidth)(layout, width)
                    }
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8KOSq.default), {
                    datasourceId: datasource.id,
                    parameters: datasource.parameters,
                    visibleColumnKeys: visibleColumnKeys,
                    columnCustomSizes: columnCustomSizes,
                    wrappedColumnKeys: wrappedColumnKeys && wrappedColumnKeys.length > 0 ? wrappedColumnKeys : undefined,
                    url: url
                })))));
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hGXwD.default), {
            data: data,
            url: url
        });
    }
    let cardComponent;
    if (smartLinks?.ssr && url && (0, $eGOwo.fg)('platform_ssr_smartlink_cards')) cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        url: url,
        onError: onError,
        hideIconLoadingSkeleton: (0, $eGOwo.fg)('platform_fix_block_card_img_icon_vc')
    });
    else cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        onError: onError
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "blockCardView-content-wrap",
        "data-block-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
        unsupportedComponent: (0, $93FVZ.default),
        ...cardProps
    }, cardComponent)));
}

});
parcelRegister("4cFYC", function(module, exports) {

$parcel$export(module.exports, "Card", () => $67163b0d69104250$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $b43DQ = parcelRequire("b43DQ");

var $8BtgY = parcelRequire("8BtgY");
class $67163b0d69104250$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BtgY.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: content
        });
    }
}
const $67163b0d69104250$export$60332b2344f7fe41 = (0, $dUaMU.default)((0, $b43DQ.context))((0, $4J0ad.default)()((0, $6YFG2.default)($67163b0d69104250$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("8BtgY", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $6c611c6f38b38dd4$export$e00a7788e30dc998);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $FoFt2 = parcelRequire("FoFt2");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $k9P6L = parcelRequire("k9P6L");

const $6c611c6f38b38dd4$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(0, $FoFt2.importWithRetry)(()=>(parcelRequire("cXd9T"))));
function $6c611c6f38b38dd4$export$e00a7788e30dc998(props) {
    (0, $gRw8I.di)($6c611c6f38b38dd4$export$a7690c318cd6a95e);
    const [id] = (0, $eJOHy.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $2QXr6.clearMarks)(id);
            (0, $2QXr6.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt } = props;
    const isFlexibleUi = (0, $1YI3f.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $eJOHy.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($6c611c6f38b38dd4$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("bmWcp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("1mLfK", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("9iIu4", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a5bd41df052e3fc6$export$ac1cddfee07ba6ac);

var $jJiQE = parcelRequire("jJiQE");

var $2pMzV = parcelRequire("2pMzV");
class $a5bd41df052e3fc6$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $2pMzV.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $jJiQE.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("jJiQE", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("2pMzV", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("ccWvh", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("g0oDq", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8OSL8", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("aRnO1", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});





parcelRegister("FoFt2", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("jGI3w"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2l32C"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("kM5eD"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ipZFl"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("gy68w"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("eDFE1")))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>Promise.resolve((parcelRequire("8UJE5"))),
            large: ()=>Promise.resolve((parcelRequire("8ALRN")))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("3ypIZ")),
            large: ()=>Promise.resolve((parcelRequire("gAsmN")))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("2N4kX")),
            large: ()=>Promise.resolve((parcelRequire("2Pj0H")))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("54Irl")),
            large: ()=>Promise.resolve((parcelRequire("iqmbF")))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("5JIMH")),
            large: ()=>Promise.resolve((parcelRequire("hLw8T")))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("b7X9d")),
            large: ()=>Promise.resolve((parcelRequire("jpYYq")))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("2uY1f")),
            large: ()=>Promise.resolve((parcelRequire("4SXVP")))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8S5KR")),
            large: ()=>Promise.resolve((parcelRequire("91IX3")))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("7lDFg")),
            large: ()=>Promise.resolve((parcelRequire("jb8ZN")))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("9IKYh")),
            large: ()=>Promise.resolve((parcelRequire("4w1Xx")))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("hEMIE")),
            large: ()=>Promise.resolve((parcelRequire("6OBnQ")))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("dE7I7")),
            large: ()=>Promise.resolve((parcelRequire("heBKY")))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("7gFcl"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("ij46p"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("2aQhi"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("5fclM"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("f9TV4"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("iFMZJ"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("feyrR"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>Promise.resolve((parcelRequire("eHIwa")))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("gbfzG"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("5M4VY"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("jc5UC"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("gDPso"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("f65Of"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("9Iwo3")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("5Ak2H")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>Promise.resolve((parcelRequire("4KX56")))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("3Y0kU")))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("6n9v8"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("amxqt")))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("dtTJ9")))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("6b4Xr")))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("eIsTj"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("f1B8s"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("cmEXk"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("bTWmL"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("iSMal"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("jRdgC"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("kRp0o"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("KywEn"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("fHwpk"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("BSiun"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("8l50I"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("5S862"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>Promise.resolve((parcelRequire("ka71P")))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>Promise.resolve((parcelRequire("kmi1F")))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("5NtHI", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("dyU3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});

parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});

parcelRegister("cPcks", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("1WryD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a874af77e003e$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $6d5a874af77e003e$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $6d5a874af77e003e$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $6d5a874af77e003e$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $6d5a874af77e003e$var$iconTileStyles = null;
function $6d5a874af77e003e$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $6d5a874af77e003e$var$appearanceMap[appearance],
            $6d5a874af77e003e$var$sizeMap[size],
            $6d5a874af77e003e$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});



parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {

$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $eGOwo = parcelRequire("eGOwo");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
        label: label,
        testId: testId
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("37A7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $eGOwo = parcelRequire("eGOwo");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
        label: label,
        testId: testId
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("4HJXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});



parcelRegister("jGI3w", function(module, exports) {

let $e5541d223003f966$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5541d223003f966$var$load("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2l32C", function(module, exports) {

let $1b3fe6d6c1117eb4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1b3fe6d6c1117eb4$var$load("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("kM5eD", function(module, exports) {

let $f1fc59e4d78436bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1fc59e4d78436bf$var$load("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ipZFl", function(module, exports) {

let $d68a655378e7bfd3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d68a655378e7bfd3$var$load("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("gy68w", function(module, exports) {

let $c0c494e4ef1a9465$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c0c494e4ef1a9465$var$load("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("3ypIZ", function(module, exports) {

let $29688079c4b0ee96$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29688079c4b0ee96$var$load("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("2N4kX", function(module, exports) {

let $2083859e6f9dfb04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2083859e6f9dfb04$var$load("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("54Irl", function(module, exports) {

let $3b1fcc5c895af309$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b1fcc5c895af309$var$load("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("5JIMH", function(module, exports) {

let $42d3e4f963bcfa12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42d3e4f963bcfa12$var$load("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("b7X9d", function(module, exports) {

let $819e3aa5538bdbce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $819e3aa5538bdbce$var$load("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("2uY1f", function(module, exports) {

let $1d1cf0ab40960c11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d1cf0ab40960c11$var$load("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("8S5KR", function(module, exports) {

let $6757d4ae8dcfc90d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6757d4ae8dcfc90d$var$load("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("7lDFg", function(module, exports) {

let $55994325bd6a89db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55994325bd6a89db$var$load("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("9IKYh", function(module, exports) {

let $713ca8a214b25950$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $713ca8a214b25950$var$load("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("hEMIE", function(module, exports) {

let $cdabf6baf903c352$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cdabf6baf903c352$var$load("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("dE7I7", function(module, exports) {

let $9ef4fdf58b078442$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ef4fdf58b078442$var$load("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("7gFcl", function(module, exports) {

let $54a9fc1f3aecb61f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54a9fc1f3aecb61f$var$load("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("ij46p", function(module, exports) {

let $d53d2eff9115be5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d53d2eff9115be5f$var$load("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("2aQhi", function(module, exports) {

let $1955113bec4b7083$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1955113bec4b7083$var$load("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("5fclM", function(module, exports) {

let $3d17eef5d89f84ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d17eef5d89f84ca$var$load("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("f9TV4", function(module, exports) {

let $b09312b6a3314853$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b09312b6a3314853$var$load("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("iFMZJ", function(module, exports) {

let $d9820fa67dfab31f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9820fa67dfab31f$var$load("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("feyrR", function(module, exports) {

let $b172e28d8f60e9da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b172e28d8f60e9da$var$load("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("gbfzG", function(module, exports) {

let $bc79c1329eafb9ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc79c1329eafb9ee$var$load("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("5M4VY", function(module, exports) {

let $434543426cb0a6c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $434543426cb0a6c3$var$load("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("jc5UC", function(module, exports) {

let $df93b95e4085ac34$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df93b95e4085ac34$var$load("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("gDPso", function(module, exports) {

let $c1d8341f0ee2b765$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1d8341f0ee2b765$var$load("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("f65Of", function(module, exports) {

let $afdbec3699fb9e2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $afdbec3699fb9e2d$var$load("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $eGOwo = parcelRequire("eGOwo");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
        label: label,
        testId: testId
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("7KbsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $eGOwo = parcelRequire("eGOwo");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
        label: label,
        testId: testId
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("kZFQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("9Iwo3", function(module, exports) {

let $7131587aee457d5d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7131587aee457d5d$var$load("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("5Ak2H", function(module, exports) {

let $410fdc8d94fecfa7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $410fdc8d94fecfa7$var$load("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("6n9v8", function(module, exports) {

let $4a3c42c5d50247c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4a3c42c5d50247c1$var$load("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("eIsTj", function(module, exports) {

let $ab6b95f1105dbf9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab6b95f1105dbf9f$var$load("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("f1B8s", function(module, exports) {

let $af03c14f83944172$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af03c14f83944172$var$load("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("cmEXk", function(module, exports) {

let $90074f15857f3006$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90074f15857f3006$var$load("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("bTWmL", function(module, exports) {

let $8aa21b1448097f6c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8aa21b1448097f6c$var$load("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("iSMal", function(module, exports) {

let $dbf2a1df4bf98f13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dbf2a1df4bf98f13$var$load("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("jRdgC", function(module, exports) {

let $e74d4222aaf1447b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e74d4222aaf1447b$var$load("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("kRp0o", function(module, exports) {

let $f2fc277294405d0e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2fc277294405d0e$var$load("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("KywEn", function(module, exports) {

let $08bf140fab0acedd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $08bf140fab0acedd$var$load("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("fHwpk", function(module, exports) {

let $b6e4029ff0dd119f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6e4029ff0dd119f$var$load("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("BSiun", function(module, exports) {

let $071d931c65cacbd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $071d931c65cacbd8$var$load("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("8l50I", function(module, exports) {

let $61242be4982e6a7b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61242be4982e6a7b$var$load("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("5S862", function(module, exports) {

let $446846ad0fad738a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $446846ad0fad738a$var$load("ffQaD"),
    $446846ad0fad738a$var$load("kvRbA"),
    $446846ad0fad738a$var$load("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});


parcelRegister("44bDi", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("4g7cp", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $09aa029e7109943c$export$b70265791d2079d4);
const $09aa029e7109943c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $09aa029e7109943c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $09aa029e7109943c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("6jgT3", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("9kfy2", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $fc76586a45127857$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $fc76586a45127857$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $fc76586a45127857$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $fc76586a45127857$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $fc76586a45127857$export$2a29ca11e08dc129);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $fc76586a45127857$export$156b523e63b4f63a = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $fc76586a45127857$export$e1d190b530cf0ee9() {
    const context = (0, $eJOHy.useContext)($fc76586a45127857$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $fc76586a45127857$export$10e9cca30e50f657 = ()=>$fc76586a45127857$var$useContextMemoized($fc76586a45127857$export$156b523e63b4f63a);
const $fc76586a45127857$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
function $fc76586a45127857$var$useContextMemoized(reactContext) {
    const value = (0, $eJOHy.useContext)(reactContext);
    const context = (0, $eJOHy.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $fc76586a45127857$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $fc76586a45127857$export$2e2bcd8739ae039 = $fc76586a45127857$export$156b523e63b4f63a;

});

parcelRegister("9NiLY", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ab3ef581aa51838e$export$94df0e59ebebf4a7);
const $ab3ef581aa51838e$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("5TXKo", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});


parcelRegister("1YI3f", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("5FRJ8", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("3pcXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("9020Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $eGOwo = parcelRequire("eGOwo");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko14q2"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton && (0, $eGOwo.fg)('platform_fix_block_card_img_icon_vc')) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fQH39", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("brTAh", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("4RG9i", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});
parcelRegister("38cBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eGOwo = parcelRequire("eGOwo");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && (0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: formattedContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("41Mwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {

$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$stylesOld = null;
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            !(0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') && $672b014d8429d73d$var$stylesMap[size],
            (0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') ? "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf" : "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("lVTJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && (0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("6O4ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("hhFie", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $3c4f8f7f5313e518$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $3c4f8f7f5313e518$export$b5fe3f66a567bec0);
const $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $3c4f8f7f5313e518$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $3c4f8f7f5313e518$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $3c4f8f7f5313e518$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("5CgrK", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("a5MXk", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $b154de42c200dbd4$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $b154de42c200dbd4$export$dc37652c1696f231);
const $b154de42c200dbd4$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $b154de42c200dbd4$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $b154de42c200dbd4$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $b154de42c200dbd4$export$e2b040f052407032 = {
    dev: $b154de42c200dbd4$var$devBaseUrl,
    development: $b154de42c200dbd4$var$devBaseUrl,
    stg: $b154de42c200dbd4$var$stgBaseUrl,
    staging: $b154de42c200dbd4$var$stgBaseUrl,
    prd: $b154de42c200dbd4$var$prodBaseUrl,
    prod: $b154de42c200dbd4$var$prodBaseUrl,
    production: $b154de42c200dbd4$var$prodBaseUrl
};
const $b154de42c200dbd4$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $b154de42c200dbd4$export$e2b040f052407032 ? $b154de42c200dbd4$export$e2b040f052407032[envKey] : $b154de42c200dbd4$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $b154de42c200dbd4$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $b154de42c200dbd4$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $b154de42c200dbd4$export$2e2bcd8739ae039 = $b154de42c200dbd4$export$e2b040f052407032;

});




parcelRegister("d0InI", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("kbv8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("3jSKi", function(module, exports) {

$parcel$export(module.exports, "extractEntity", () => $315a3a5639bc1399$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $315a3a5639bc1399$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $315a3a5639bc1399$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $315a3a5639bc1399$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $315a3a5639bc1399$export$19346520e937a99f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

const $315a3a5639bc1399$export$8beff7405d020ddf = (response)=>(0, $eGOwo.fg)('smart_links_noun_support') ? response?.entityData : undefined;
const $315a3a5639bc1399$export$c7168210b81d9383 = (response)=>Boolean($315a3a5639bc1399$export$8beff7405d020ddf(response));
const $315a3a5639bc1399$export$f97663ee76ac5b24 = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $315a3a5639bc1399$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $9f5235d88a87be7c$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $9f5235d88a87be7c$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $315a3a5639bc1399$export$19346520e937a99f = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : (0, $eGOwo.fg)('smart_links_noun_support') ? response?.meta.generator?.icon?.url : undefined;
    return {
        url: url,
        label: entity?.displayName
    };
};

});
const $9f5235d88a87be7c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9f5235d88a87be7c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9f5235d88a87be7c$export$84a73a0383f58180 = 'JiraTask';
const $9f5235d88a87be7c$export$c6c83963a9378a67 = 'JiraSubTask';
const $9f5235d88a87be7c$export$58af3c426c111a6d = 'JiraStory';
const $9f5235d88a87be7c$export$ac9898a63417219e = 'JiraBug';
const $9f5235d88a87be7c$export$54db5e3fb12e39cd = 'JiraEpic';
const $9f5235d88a87be7c$export$2f54a5a217202c85 = 'JiraIncident';
const $9f5235d88a87be7c$export$d097371052bfc411 = 'JiraServiceRequest';
const $9f5235d88a87be7c$export$efd9452ad16c6676 = 'JiraChange';
const $9f5235d88a87be7c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9f5235d88a87be7c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("99QxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("ggoTr", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $614f754b0a09058a$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $614f754b0a09058a$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $614f754b0a09058a$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $614f754b0a09058a$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $614f754b0a09058a$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $614f754b0a09058a$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $614f754b0a09058a$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $614f754b0a09058a$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $614f754b0a09058a$export$6e470aad5ba8952e = 'pending';
const $614f754b0a09058a$export$9a6a932a0a39498e = 'resolving';
const $614f754b0a09058a$export$63ec8bc7a8a75482 = 'resolved';
const $614f754b0a09058a$export$b8cfaa842c9ab487 = 'reloading';
const $614f754b0a09058a$export$6d8ed3f9433dd372 = 'errored';
const $614f754b0a09058a$export$cfbbb7126bc8a0c6 = 'fallback';
const $614f754b0a09058a$export$76b5c1aca20759c6 = 'preload';
const $614f754b0a09058a$export$2c5edb971b673330 = 'metadata';
const $614f754b0a09058a$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4pUJe", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $d6704a2e786f0169$export$3e5b797e39668f84);
class $d6704a2e786f0169$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("gA511", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("CpyFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$contentStyles = null;
const $1bafe1b037124149$var$linkStyles = null;
const $1bafe1b037124149$var$textStylesBase = null;
const $1bafe1b037124149$var$dropdownItemGroupStyles = null;
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("7xssH", function(module, exports) {

$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});
parcelRegister("2QXr6", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("4dVhH", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = $8d29b99195ec403c$var$LozengeActionTrigger;

});




parcelRegister("kB4Nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});
parcelRegister("8ygPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            $adbc5d7a57662063$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});


parcelRegister("1FNi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') ? (0, $19nmp.messages)[textPrefix] : (0, $19nmp.messages).owned_by, context?.ownedBy) : null;
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("7Byzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});


parcelRegister("5kUaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("f7w3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});

parcelRegister("6Po2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("i6ktq", function(module, exports) {

$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});

parcelRegister("iQvIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$baseStyle = null;
const $7e868f1df007f5c9$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(x);
const $7e868f1df007f5c9$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $7e868f1df007f5c9$var$maxLinesCss = null;
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    if ($7e868f1df007f5c9$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $7e868f1df007f5c9$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ]),
        children: contentForAccessType
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {

$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});


parcelRegister("k8J0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});


parcelRegister("a86OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});
parcelRegister("lHA6U", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6J9k6 = parcelRequire("6J9k6");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.Name = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a21fb2aec03ab384$var$_edit = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $a21fb2aec03ab384$var$_edit.default
    }));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.Name = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8a2815b0aa140afa$var$_download = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("5Mb5i")));
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $8a2815b0aa140afa$var$_download.default
    }));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});



parcelRegister("lSW97", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("59ZsC")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("b7Rzw")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $19nmp.messages).follow_project : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $19nmp.messages).follow_project_description : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("1rn8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("59ZsC", function(module, exports) {

let $3c1d77d2dd928a94$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3c1d77d2dd928a94$var$load("ffQaD"),
    $3c1d77d2dd928a94$var$load("kvRbA"),
    $3c1d77d2dd928a94$var$load("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("b7Rzw", function(module, exports) {

let $8199e76ea14b9640$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8199e76ea14b9640$var$load("ffQaD"),
    $8199e76ea14b9640$var$load("kvRbA"),
    $8199e76ea14b9640$var$load("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1f036d580202d537$var$_growDiagonal = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("XhTSt")));
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1f036d580202d537$var$_growDiagonal.default
    }));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});



parcelRegister("b1dbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $6qaBj.cx)($8c33132973d68a83$var$styles.message, hasPadding && $8c33132973d68a83$var$styles.padding),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("2LycE", function(module, exports) {

$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("9R3Jd", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $8b174f4749aef8f6$export$be18a6294fd426ec);
const $8b174f4749aef8f6$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("3seWH", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $6f5194fe1d549fab$export$63f54cf4c5883620);

var $jo2Je = parcelRequire("jo2Je");
const $6f5194fe1d549fab$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $jo2Je.extractUrlFromLinkJsonLd)(url);
    }
};

});
parcelRegister("jo2Je", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $9fd708127ba15a99$export$396ba4ef2e37dc65);
const $9fd708127ba15a99$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $9fd708127ba15a99$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("5sknP", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $eGOwo = parcelRequire("eGOwo");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT : 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, path);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                } : undefined
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? chunk.message.content : chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4N9mw", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $jeUcl = parcelRequire("jeUcl");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $jeUcl.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("jeUcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f62baba7cd68ce1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $9f62baba7cd68ce1$var$AiIcon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $9f62baba7cd68ce1$export$2e2bcd8739ae039 = $9f62baba7cd68ce1$var$AiIcon;

});

parcelRegister("4XsCU", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {

$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.Name = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("lGr6J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc928c338a001a7a$var$_react = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc928c338a001a7a$var$_baseNew = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fc928c338a001a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc928c338a001a7a$var$CopyIcon = (props)=>/*#__PURE__*/ $fc928c338a001a7a$var$_react.default.createElement($fc928c338a001a7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc928c338a001a7a$var$CopyIcon.displayName = 'CopyIcon';
var $fc928c338a001a7a$var$_default = module.exports.default = $fc928c338a001a7a$var$CopyIcon;

});

parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d19c65e3fa3f02f9$var$_copy = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("lGr6J")));
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $d19c65e3fa3f02f9$var$_copy.default
    }));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQZ7P")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $7b6d8602f75ebf94$var$styles = null;
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onClick: onClick,
        className: (0, $hcewu.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aQZ7P", function(module, exports) {

let $7e6e2cee59393130$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e6e2cee59393130$var$load("kNFvF"),
    $7e6e2cee59393130$var$load("ffQaD"),
    $7e6e2cee59393130$var$load("kvRbA"),
    $7e6e2cee59393130$var$load("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9EkqU")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).related_links_view_related_links
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");
const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});

parcelRegister("9EkqU", function(module, exports) {

let $7067b308d3e627fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7067b308d3e627fa$var$load("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {

$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});




parcelRegister("bIdM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});



parcelRegister("gKsxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $eJOHy.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});


parcelRegister("5gb8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiContext)() : undefined;
    const renderers = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5MmSu.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("fqBfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("gjoE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("2qnEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("4zxv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {

$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $jeUcl = parcelRequire("jeUcl");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $jeUcl.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("bB163", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("klVDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});





parcelRegister("4cjOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("1dIgp", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("k9P6L", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("kj3Kk", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});



const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("cXd9T", function(module, exports) {

let $96e533b7ac04a55f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96e533b7ac04a55f$var$load("6nRbC").then(()=>parcelRequire('kzwZ8'));

});



parcelRegister("81LfQ", function(module, exports) {

$parcel$export(module.exports, "CardErrorBoundary", () => $6d47cca45f4926d8$export$7f923465a27f725b);

var $gt9Am = parcelRequire("gt9Am");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $eJOHy = parcelRequire("eJOHy");

var $lOeyo = parcelRequire("lOeyo");

var $iKozC = parcelRequire("iKozC");

var $d2DmH = parcelRequire("d2DmH");
class $6d47cca45f4926d8$export$7f923465a27f725b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    render() {
        if (this.state.isError) {
            const { url: url, isDatasource: isDatasource, unsupportedComponent: UnsupportedComponent, datasourceId: datasourceId } = this.props;
            if (url) {
                const fallback = (0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__editor') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: url,
                    onClick: this.onClickFallback,
                    children: url
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                    href: url,
                    onClick: this.onClickFallback,
                    children: url
                });
                if (isDatasource) {
                    if ((0, $iKozC.isSafeUrl)(url)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                        datasourceId: datasourceId,
                        error: this.state.error,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOeyo.InlineCard), {
                            ...this.props
                        })
                    });
                    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                        datasourceId: datasourceId,
                        error: this.state.error,
                        children: fallback
                    });
                } else return fallback;
            } else return /*#__PURE__*/ (0, $gt9Am.jsx)(UnsupportedComponent, {});
        }
        return this.props.children;
    }
    componentDidCatch(_error) {
        this.setState({
            isError: true,
            error: _error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isError: false,
            error: null
        }, this.onClickFallback = (e)=>{
            const { onClick: onClick, url: url } = this.props;
            e.preventDefault();
            if (onClick) onClick(e, url);
        };
    }
}

});
parcelRegister("d2DmH", function(module, exports) {

$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $e573d4ac9205d05d$export$f386473e8f104bcb);

var $eJOHy = parcelRequire("eJOHy");

const $e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("fOdOZ")));
const $e573d4ac9205d05d$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));

});
parcelRegister("fOdOZ", function(module, exports) {

let $b8263f288b161b65$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8263f288b161b65$var$load("jQLsm").then(()=>parcelRequire('kpPKM'));

});



parcelRegister("kL4gV", function(module, exports) {

$parcel$export(module.exports, "getCardClickHandler", () => $c69b503f8fa01e3e$export$c168b9c5078297ed);

var $g9wjI = parcelRequire("g9wjI");
const $c69b503f8fa01e3e$export$c168b9c5078297ed = (eventHandlers, url)=>{
    const handler = (0, $g9wjI.getEventHandler)(eventHandlers, 'smartCard');
    return handler ? (e)=>handler(e, url) : undefined;
};

});

parcelRegister("hGXwD", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f260d63f3a536e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $9kfy2 = parcelRequire("9kfy2");

var $4cFYC = parcelRequire("4cFYC");
var $03JM4 = parcelRequire("03JM4");

var $8YHJ2 = parcelRequire("8YHJ2");

var $etjvQ = parcelRequire("etjvQ");
var $dfCRV = parcelRequire("dfCRV");

var $eGOwo = parcelRequire("eGOwo");

var $e2B2h = parcelRequire("e2B2h");

var $AIyOt = parcelRequire("AIyOt");

var $81LfQ = parcelRequire("81LfQ");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $kL4gV = parcelRequire("kL4gV");

var $8KqmO = parcelRequire("8KqmO");

var $jWNZR = parcelRequire("jWNZR");
const $71f260d63f3a536e$var$HoverLinkOverlayNoop = (props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, props.children);
const $71f260d63f3a536e$var$HoverLinkOverlayWithCondition = (0, $AIyOt.componentWithCondition)(()=>(0, $eGOwo.fg)('platform_editor_preview_panel_linking'), (0, $etjvQ.default), $71f260d63f3a536e$var$HoverLinkOverlayNoop);
const $71f260d63f3a536e$var$InlineCard = (props)=>{
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, rendererAppearance: rendererAppearance } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const cardContext = (0, $9kfy2.useSmartCardContext)();
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $eJOHy.useState)(false);
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal
    };
    const { hideHoverPreview: hideHoverPreview, actionOptions: actionOptions, ssr: ssr } = smartLinks || {};
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    const CompetitorPrompt = smartLinks?.CompetitorPrompt;
    const CompetitorPromptComponent = CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $1NIU8.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    if (ssr && url) {
        if (// eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            "data-inline-card": true,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            ...inlineAnnotationProps
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick
        })));
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick
        }));
    }
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    const cardState = cardContext?.value?.store?.getState()[url || ''];
    const ari = (0, $03JM4.getObjectAri)(cardState?.details);
    const name = (0, $03JM4.getObjectName)(cardState?.details);
    const iconUrl = (0, $03JM4.getObjectIconUrl)(cardState?.details);
    const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
        ari: ari
    });
    const openPreviewPanel = cardContext?.value?.openPreviewPanel;
    const handleOpenGlancePanelClick = (event)=>{
        if (openPreviewPanel && isPanelAvailable) {
            // Prevent anchor default behaviour(click to open the anchor link)
            // When glance panel is available, let openPreviewPanel handle it
            event.preventDefault();
            openPreviewPanel({
                url: url || '',
                ari: ari,
                name: name || '',
                iconUrl: iconUrl
            });
        }
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "data-inline-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url,
        ...inlineAnnotationProps
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
        unsupportedComponent: (0, $dfCRV.default),
        ...cardProps
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($71f260d63f3a536e$var$HoverLinkOverlayWithCondition, {
        isVisible: isResolvedViewRendered,
        url: url || '',
        compactPadding: rendererAppearance === 'comment',
        showPanelButton: !!isPanelAvailable,
        onClick: handleOpenGlancePanelClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
        appearance: "inline",
        showHoverPreview: !hideHoverPreview,
        actionOptions: actionOptions,
        ...cardProps,
        onResolve: (data)=>{
            if (!data.url || !data.title) return;
            props.smartCardStorage.set(data.url, data.title);
            if (data.title) setIsResolvedViewRendered(true);
        },
        onError: onError
    })), CompetitorPromptComponent)));
};
var $71f260d63f3a536e$export$2e2bcd8739ae039 = (0, $dZ1mQ.withSmartCardStorage)($71f260d63f3a536e$var$InlineCard);

});
parcelRegister("03JM4", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("70skx", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("8YHJ2", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !(0, $eGOwo.fg)('platform_editor_preview_panel_linking')) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details)
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("iT7eO", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {

$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});



parcelRegister("2vJUc", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("3u14o", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("fQuyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dpCTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER,
                ...(0, $eGOwo.fg)('platform_editor_preview_panel_linking') ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGRER_WRAPPER
                } : {},
                ...(0, $eGOwo.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("dpM2S", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $f106af885ce6cc9e$export$2e9ae379995d99e3);
const $f106af885ce6cc9e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});

parcelRegister("1UXt3", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");

var $eGOwo = parcelRequire("eGOwo");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
        }
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
            return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
        }
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('platform-linking-slack-entity-support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    }
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("9JeZK", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $a634170ae128bef4$export$c471ae5fddcf1392);

var $4moW4 = parcelRequire("4moW4");
const $a634170ae128bef4$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $4moW4.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});
parcelRegister("4moW4", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $74d023e64fe83956$export$67f3d92c824fd850);

var $jo2Je = parcelRequire("jo2Je");
const $74d023e64fe83956$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("aHgka", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $537f0d3ea3fbcfb9$export$a66235cba0c9d11a);

var $9JeZK = parcelRequire("9JeZK");
const $537f0d3ea3fbcfb9$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("3a3fF", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("hdxEk", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0);

var $9JeZK = parcelRequire("9JeZK");
const $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
};

});



parcelRegister("2bxQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {

$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13lipd34 _qrwqpd34 _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("hy9OT", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkTitle", () => $27694d81d2f2dfcb$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $27694d81d2f2dfcb$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $27694d81d2f2dfcb$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $27694d81d2f2dfcb$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $27694d81d2f2dfcb$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $27694d81d2f2dfcb$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $27694d81d2f2dfcb$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $27694d81d2f2dfcb$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $27694d81d2f2dfcb$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $27694d81d2f2dfcb$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $27694d81d2f2dfcb$export$96ed4c1b14ac210a);

var $eGOwo = parcelRequire("eGOwo");

var $9R3Jd = parcelRequire("9R3Jd");
var $1IwHM = parcelRequire("1IwHM");
var $9T6dQ = parcelRequire("9T6dQ");
var $3seWH = parcelRequire("3seWH");
var $aHgka = parcelRequire("aHgka");
var $hdxEk = parcelRequire("hdxEk");
var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");

var $6OR2o = parcelRequire("6OR2o");

var $3jSKi = parcelRequire("3jSKi");
const $27694d81d2f2dfcb$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.displayName;
    }
    return (0, $8T839.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $27694d81d2f2dfcb$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.url;
    }
    return (0, $3seWH.extractLink)(response?.data);
};
const $27694d81d2f2dfcb$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.ari || (0, $3jSKi.extractEntity)(response)?.thirdPartyAri;
    }
    const data = response?.data;
    return (0, $9R3Jd.extractAri)(data);
};
const $27694d81d2f2dfcb$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            // TODO: Missing iframeUrlType
            const embedUrl = (0, $3jSKi.extractEntityEmbedUrl)(response);
            return embedUrl ? {
                src: embedUrl
            } : undefined;
        }
    }
    return (0, $6OR2o.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $27694d81d2f2dfcb$export$ff753ed519e96e9e = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    }
    return response?.data && (0, $9Thyx.extractProvider)(response?.data);
};
const $27694d81d2f2dfcb$export$7a685df468cbf38f = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    }
    return response?.data && (0, $1IwHM.extractDateCreated)(response.data);
};
const $27694d81d2f2dfcb$export$75047940e157fd1f = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedAt;
    }
    return response?.data && (0, $9T6dQ.extractDateUpdated)(response.data);
};
const $27694d81d2f2dfcb$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdBy?.displayName;
    }
    const persons = (0, $aHgka.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $27694d81d2f2dfcb$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            const owners = entity?.owners;
            if (owners) return owners.map((owner)=>({
                    name: owner.displayName,
                    src: owner.picture
                })).filter((item)=>!!item);
        }
    }
    return (0, $aHgka.extractPersonCreatedBy)(response.data);
};
const $27694d81d2f2dfcb$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedBy?.displayName;
    }
    const person = (0, $hdxEk.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $27694d81d2f2dfcb$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) {
            const entity = (0, $3jSKi.extractEntity)(response);
            return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
        }
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("1IwHM", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $9bce2094467d007a$export$e1226a5e0bbbf862);
const $9bce2094467d007a$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("9T6dQ", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7);
const $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("9Thyx", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $af479a3c34473181$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $af479a3c34473181$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $af479a3c34473181$export$38df542ff03a4183);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");


var $4moW4 = parcelRequire("4moW4");
var $jo2Je = parcelRequire("jo2Je");
const $af479a3c34473181$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $af479a3c34473181$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $af479a3c34473181$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $af479a3c34473181$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $9f5235d88a87be7c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $4moW4.extractUrlFromIconJsonLd)(icon);
};
const $af479a3c34473181$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};
const $af479a3c34473181$export$38df542ff03a4183 = (id)=>{
    return id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66);
};

});

parcelRegister("8T839", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $8cab052601305f86$export$b05803156e5015b6);

var $inXgt = parcelRequire("inXgt");

var $dpM2S = parcelRequire("dpM2S");
const $8cab052601305f86$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $inXgt.extractContext)(jsonLd);
    const type = (0, $dpM2S.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("inXgt", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $1424377282a92e98$export$efdbd45f3e77a161);

var $dpM2S = parcelRequire("dpM2S");

var $4moW4 = parcelRequire("4moW4");
const $1424377282a92e98$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $4moW4.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $dpM2S.extractType)(context)
            };
        }
    }
};

});


parcelRegister("6OR2o", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115);

var $dToaf = parcelRequire("dToaf");

var $jo2Je = parcelRequire("jo2Je");
const $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $dToaf.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("dToaf", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $74d23019aa5430ff$export$3e8ad908070b68b2);
const $74d23019aa5430ff$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});



parcelRegister("7r0tl", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {

$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url && !(0, $eGOwo.fg)('smart_links_noun_support')) {
            const provider = (0, $3jSKi.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("1klMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                ...(0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') ? {
                    meta: {
                        accessType: response?.meta?.requestAccess?.accessType
                    }
                } : undefined
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        ...(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1UXt3.extractMetaObjectId)(meta),
                resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
                tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
            }
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");

var $eGOwo = parcelRequire("eGOwo");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    }
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("18DG7", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("glHkX", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $3seWH = parcelRequire("3seWH");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : (0, $3seWH.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");

var $37QDL = parcelRequire("37QDL");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkDownloadUrl)(response) : (0, $37QDL.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("37QDL", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $5db269b02f6f1ef1$export$9682e3ac9d184e95);
const $5db269b02f6f1ef1$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("7xgpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $5O37S.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $3seWH = parcelRequire("3seWH");
var $6OR2o = parcelRequire("6OR2o");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $8T839 = parcelRequire("8T839");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $3seWH.extractLink)(data);
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $aNEbu.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                    isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                    linkIcon: (0, $8z78z.extractLinkIcon)(response),
                    providerName: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkProvider)(response)?.text : (0, $9Thyx.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response)?.src : src,
                    title: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkTitle)(response) : (0, $8T839.extractTitle)(data),
                    url: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $5NtHI.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("aNEbu", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("4M5bk"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("4M5bk", function(module, exports) {

let $379faa16a2da8ae6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $379faa16a2da8ae6$var$load("ffQaD"),
    $379faa16a2da8ae6$var$load("kvRbA"),
    $379faa16a2da8ae6$var$load("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $9R3Jd = parcelRequire("9R3Jd");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkAri)(response) : (0, $9R3Jd.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("13x9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e523377710580c71$var$_lockLocked = $e523377710580c71$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $e523377710580c71$var$_lockLocked.default
    }));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $6OR2o.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType) : $bddb5ab530f782ff$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd5a8d264ca7a1e79e3d50d476094729>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $awZZu = parcelRequire("awZZu");

var $eGOwo = parcelRequire("eGOwo");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
        label: label,
        testId: testId
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("cBTRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2e0cf5105bbbaa2e318211c53ac326e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $8lO5P = parcelRequire("8lO5P");

var $eGOwo = parcelRequire("eGOwo");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
        label: label,
        testId: testId
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("j8Au4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96efea4cb290db7d8f614246fd62e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $7XCnf = parcelRequire("7XCnf");

var $eGOwo = parcelRequire("eGOwo");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
        label: label,
        testId: testId
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("1OiKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::499dedcb1e659dc62cb0d811acc9f742>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $MUJuW = parcelRequire("MUJuW");

var $eGOwo = parcelRequire("eGOwo");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
        label: label,
        testId: testId
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("3xtgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $bwM92 = parcelRequire("bwM92");

var $eGOwo = parcelRequire("eGOwo");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
        label: label,
        testId: testId
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("dSbyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c93ab4407be6cde9$var$_peopleGroup = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("hxN6p")));
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $c93ab4407be6cde9$var$_peopleGroup.default
    }));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.Name = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $acaed063c693be85$var$_file = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("jvbqF")));
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $acaed063c693be85$var$_file.default
    }));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9UdpB = parcelRequire("9UdpB");

var $eGOwo = parcelRequire("eGOwo");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
        label: label,
        testId: testId
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("ePICl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee9d05b0e18fef4787b81f1748fa21a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $4aDUk = parcelRequire("4aDUk");

var $eGOwo = parcelRequire("eGOwo");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
        label: label,
        testId: testId
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("bqSXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gtN4u = parcelRequire("gtN4u");

var $eGOwo = parcelRequire("eGOwo");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
        label: label,
        testId: testId
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("3zPlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9beea2179909206f90938b1cce486fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $ljmsu = parcelRequire("ljmsu");

var $eGOwo = parcelRequire("eGOwo");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
        label: label,
        testId: testId
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ewxpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $c59mr = parcelRequire("c59mr");

var $eGOwo = parcelRequire("eGOwo");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
        label: label,
        testId: testId
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("28xc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gNXvC = parcelRequire("gNXvC");

var $eGOwo = parcelRequire("eGOwo");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
        label: label,
        testId: testId
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad59de50cbf2d9cd9f6ad629f1ce9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("kFcVs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $hVZow = parcelRequire("hVZow");

var $eGOwo = parcelRequire("eGOwo");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
        label: label,
        testId: testId
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57b828e09f9287500323fc5bcdd6b33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("ayExB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::169a13a2ae270c089103a5ea3de6fc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $d67Vm = parcelRequire("d67Vm");

var $eGOwo = parcelRequire("eGOwo");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
        label: label,
        testId: testId
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("kqL94", function(module, exports) {

$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        if ((0, $eGOwo.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.LozengeWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                testId: "inline-card-resolved-view-lozenge",
                appearance: appearance,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: lozenge.style,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
                children: lozenge.text
            })
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");
const $7e6c0fa079b82f37$var$wrapperStyles = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $5d532ff440b5b275$export$75180efdd3f4d9c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko14q2"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5d532ff440b5b275$var$LozengeWrapperOldVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$75180efdd3f4d9c2 = (props)=>{
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LozengeWrapperOldVisualRefresh, {
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {

$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mj1crf _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {

$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko14q2"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square' })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square'
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type
    ]);
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});

parcelRegister("RCgNH", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("iUsXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("6kw7n", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    iconWrapper: "_2hwx1i6y _1e0cbu77",
    actionButtonLozengeStyleOld: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    actionButtonLozengeStyleNew: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) {
            if ((0, $eGOwo.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyleNew,
                onClick: handleRetry,
                style: {
                    font: `inherit`
                },
                testId: "button-connect-other-account",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                    appearance: "moved",
                    ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                        isBold: true
                    } : undefined,
                    children: renderForbiddenAccessMessage()
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.LozengeWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                    xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyleOld,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                        appearance: "moved",
                        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
        }
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f1c01b17c1604b90$var$_lockLocked = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $f1c01b17c1604b90$var$_lockLocked.default
    }));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {

$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});




parcelRegister("etjvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7997b7b805f50047$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $3lIcL = parcelRequire("3lIcL");

var $9itkV = parcelRequire("9itkV");

var $f4WMd = parcelRequire("f4WMd");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $97Qim = parcelRequire("97Qim");
var $bMFKb = parcelRequire("bMFKb");

var $6dRXt = parcelRequire("6dRXt");
function $7997b7b805f50047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7997b7b805f50047$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $7997b7b805f50047$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $7997b7b805f50047$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $7997b7b805f50047$var$linkStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    left: 'space.025',
    top: '-1px',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $7997b7b805f50047$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $7997b7b805f50047$var$ICON_WIDTH = 16;
const $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $7997b7b805f50047$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $7997b7b805f50047$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = showPanelButton ? formatMessage((0, $6dRXt.messages).panelButtonTitle) : formatMessage((0, $6dRXt.messages).openButtonTitle);
    const containerRef = (0, $eJOHy.useRef)(null);
    const hoverLinkButtonRef = (0, $eJOHy.useRef)(null);
    const hiddenTextRef = (0, $eJOHy.useRef)(null);
    const [showLabel, setShowLabel] = (0, $eJOHy.useState)(true);
    const [isHovered, setHovered] = (0, $eJOHy.useState)(false);
    const openTextWidthRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH;
        const canShowLabel = cardWidth - openTextWidth > $7997b7b805f50047$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $7997b7b805f50047$var$ICON_WIDTH;
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $7997b7b805f50047$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).BUTTON);
    };
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: containerRef,
        css: $7997b7b805f50047$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $7997b7b805f50047$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lL4G9.default), {
        ref: hoverLinkButtonRef,
        xcss: $7997b7b805f50047$var$linkStyles,
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $7997b7b805f50047$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height"
    }, showPanelButton ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))), {
        label: ""
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
        label: ""
    })), showLabel && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, label))));
};
var $7997b7b805f50047$export$2e2bcd8739ae039 = $7997b7b805f50047$var$HoverLinkOverlay;

});
parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b10c2aaa76d32294bc7ed1c0a1888df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});

parcelRegister("97Qim", function(module, exports) {

$parcel$export(module.exports, "buildEditLinkPayload", () => $7d7b4d8beeabc390$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $7d7b4d8beeabc390$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildVisitedNonHyperLinkPayload", () => $7d7b4d8beeabc390$export$4c5e2a0406e7eae8);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $7d7b4d8beeabc390$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $7d7b4d8beeabc390$export$aab75a08bdd88be4);

var $bMFKb = parcelRequire("bMFKb");
const $7d7b4d8beeabc390$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $bMFKb.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $7d7b4d8beeabc390$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload() : $7d7b4d8beeabc390$export$4c5e2a0406e7eae8(type, (0, $bMFKb.INPUT_METHOD).TOOLBAR);
};
const $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$4c5e2a0406e7eae8 = (type, inputMethod)=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
            display: $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).UNLINK,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};

});


parcelRegister("8KqmO", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $2bda144e58b3ea3a$export$11564cda945bb3c9);

var $eGOwo = parcelRequire("eGOwo");

var $e2m7L = parcelRequire("e2m7L");
function $2bda144e58b3ea3a$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});


parcelRegister("8KOSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fcd2e2af5104151$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $2fcd2e2af5104151$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i0y3d")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fcd2e2af5104151$var$LazyDatasourceTableView, props));
};
var $2fcd2e2af5104151$export$2e2bcd8739ae039 = $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers;

});
parcelRegister("i0y3d", function(module, exports) {

let $d1c2a3dd7d3a29a0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d1c2a3dd7d3a29a0$var$load("kNFvF"),
    $d1c2a3dd7d3a29a0$var$load("76n7a"),
    $d1c2a3dd7d3a29a0$var$load("l253H"),
    $d1c2a3dd7d3a29a0$var$load("ffQaD"),
    $d1c2a3dd7d3a29a0$var$load("kvRbA"),
    $d1c2a3dd7d3a29a0$var$load("exQGw")
]).then(()=>parcelRequire('hadck'));

});


parcelRegister("7WlTe", function(module, exports) {

$parcel$export(module.exports, "getDatasourceType", () => $735e61d500130c4c$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $735e61d500130c4c$export$1974047c293dd52e);

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $eGOwo = parcelRequire("eGOwo");
const $735e61d500130c4c$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $735e61d500130c4c$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $735e61d500130c4c$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $eGOwo.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("k9y0J", function(module, exports) {

$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $16f3892d5aa02916$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $16f3892d5aa02916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $16f3892d5aa02916$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $16f3892d5aa02916$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kacac")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $16f3892d5aa02916$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f3892d5aa02916$var$LazyAssetsConfigModal, props));
};
var $16f3892d5aa02916$export$2e2bcd8739ae039 = $16f3892d5aa02916$var$AssetsConfigModalWithWrappers;

});
parcelRegister("kacac", function(module, exports) {

let $eade2d3ba2053832$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $eade2d3ba2053832$var$load("fliVL"),
    $eade2d3ba2053832$var$load("kNFvF"),
    $eade2d3ba2053832$var$load("76n7a"),
    $eade2d3ba2053832$var$load("l253H"),
    $eade2d3ba2053832$var$load("ffQaD"),
    $eade2d3ba2053832$var$load("kvRbA"),
    $eade2d3ba2053832$var$load("gxPBZ")
]).then(()=>parcelRequire('i1bWW'));

});


parcelRegister("7BBxG", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $aaf2311a623c98ee$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $aaf2311a623c98ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $aaf2311a623c98ee$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQLyR")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal, props));
};
var $aaf2311a623c98ee$export$2e2bcd8739ae039 = $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("aQLyR", function(module, exports) {

let $7e63a767a7765e04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e63a767a7765e04$var$load("fliVL"),
    $7e63a767a7765e04$var$load("kNFvF"),
    $7e63a767a7765e04$var$load("76n7a"),
    $7e63a767a7765e04$var$load("l253H"),
    $7e63a767a7765e04$var$load("ffQaD"),
    $7e63a767a7765e04$var$load("kvRbA"),
    $7e63a767a7765e04$var$load("lLdNy")
]).then(()=>parcelRequire('a1XeP'));

});


parcelRegister("7KhEE", function(module, exports) {

$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $b6adaf62d6e1c249$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $b6adaf62d6e1c249$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b6adaf62d6e1c249$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4XMdj")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal, props));
};
var $b6adaf62d6e1c249$export$2e2bcd8739ae039 = $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("4XMdj", function(module, exports) {

let $39d21256ddeb6106$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $39d21256ddeb6106$var$load("fliVL"),
    $39d21256ddeb6106$var$load("kNFvF"),
    $39d21256ddeb6106$var$load("76n7a"),
    $39d21256ddeb6106$var$load("l253H"),
    $39d21256ddeb6106$var$load("ffQaD"),
    $39d21256ddeb6106$var$load("kvRbA"),
    $39d21256ddeb6106$var$load("7FotB")
]).then(()=>parcelRequire('fjaM1'));

});




parcelRegister("1C1WZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $94b650125906c273$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $4cFYC = parcelRequire("4cFYC");
var $6PcbG = parcelRequire("6PcbG");

var $8YHJ2 = parcelRequire("8YHJ2");

var $9kfy2 = parcelRequire("9kfy2");

var $jYx9G = parcelRequire("jYx9G");
var $93FVZ = parcelRequire("93FVZ");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $81LfQ = parcelRequire("81LfQ");


var $kL4gV = parcelRequire("kL4gV");

var $e2B2h = parcelRequire("e2B2h");

var $jWNZR = parcelRequire("jWNZR");

var $9ug1Y = parcelRequire("9ug1Y");
function $94b650125906c273$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94b650125906c273$var$embedCardWrapperStyles = {
    name: "yjftov",
    styles: "width:100%;height:100%;> div{height:100%;}.loader-wrapper{height:100%;}margin:0 auto"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $94b650125906c273$var$uIMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
function $94b650125906c273$var$EmbedCardInternal(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, layout: layout, width: width, isInsideOfBlockNode: isInsideOfBlockNode, rendererAppearance: rendererAppearance, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const embedIframeRef = (0, $eJOHy.useRef)(null);
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const { actionOptions: actionOptions } = smartLinks || {};
    const platform = 'web';
    const cardProps = {
        url: url,
        onClick: onClick,
        container: portal,
        platform: platform,
        frameStyle: smartLinks?.frameStyle ?? 'show',
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const [liveHeight, setLiveHeight] = (0, $eJOHy.useState)(null);
    const [aspectRatio, setAspectRatio] = (0, $eJOHy.useState)();
    const height = liveHeight || props.originalHeight;
    // We start with height and width defined with default values
    let originalHeight = (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT);
    let originalWidth = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH);
    // Then can override height and width with values from ADF if available
    if (props.originalHeight && props.originalWidth) {
        originalHeight = props.originalHeight;
        originalWidth = props.originalWidth;
    }
    // Then we can override it with aspectRatio that is comming from iframely via `resolve()`
    if (aspectRatio) {
        originalHeight = 1;
        originalWidth = aspectRatio;
    }
    // And finally if iframe sends live `height` events we use that as most precise measure.
    const isHeightOnlyMode = !(props.originalHeight && props.originalWidth) || liveHeight;
    if (height && isHeightOnlyMode) {
        originalHeight = height;
        originalWidth = undefined;
    }
    const padding = rendererAppearance === 'full-page' ? (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : 0;
    const [hasPreview, setPreviewAvailableState] = (0, $eJOHy.useState)(true);
    const cardContext = (0, $eJOHy.useContext)((0, $9kfy2.SmartCardContext));
    const onResolve = ({ aspectRatio: resolvedAspectRatio })=>{
        const hasPreviewOnResolve = !!(cardContext && url && cardContext.extractors.getPreview(url, platform));
        if (!hasPreviewOnResolve) setPreviewAvailableState(false);
        setAspectRatio(resolvedAspectRatio);
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: documentWidth })=>{
        const isFullWidth = rendererAppearance === 'full-width';
        let containerWidth = documentWidth;
        if (smartLinks?.ssr && !containerWidth) // EDM-8114: When we are rendering on SSR, we have no idea what the width is.
        containerWidth = isFullWidth ? (0, $7yBx7.akEditorFullWidthLayoutWidth) : (0, $7yBx7.akEditorDefaultLayoutWidth);
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7yBx7.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7yBx7.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const lineLength = isFullWidth ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), containerWidth - padding) : nonFullWidthSize;
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? $94b650125906c273$var$uIMediaSingleLayoutStyles : '';
        const onError = ({ err: err })=>{
            if (err) throw err;
        };
        let cardComponent;
        if (smartLinks?.ssr && url && (0, $eGOwo.fg)('platform_ssr_smartlink_embeds')) {
            const ssrCardProps = {
                url: url,
                onClick: onClick,
                container: portal,
                platform: platform,
                frameStyle: smartLinks?.frameStyle ?? 'show',
                actionOptions: actionOptions
            };
            cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
                appearance: "embed",
                ...ssrCardProps,
                onResolve: onResolve,
                inheritDimensions: true,
                embedIframeRef: embedIframeRef,
                onError: onError
            });
        } else cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
            appearance: "embed",
            ...cardProps,
            onResolve: onResolve,
            inheritDimensions: true,
            embedIframeRef: embedIframeRef,
            onError: onError
        });
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
            unsupportedComponent: (0, $93FVZ.default),
            ...cardProps
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6PcbG.EmbedResizeMessageListener), {
            embedIframeRef: embedIframeRef,
            onHeightUpdate: setLiveHeight
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYx9G.default), {
            css: uiMediaSingleStyles,
            layout: layout,
            width: originalWidth,
            containerWidth: containerWidth,
            pctWidth: width,
            height: originalHeight,
            fullWidthMode: isFullWidth,
            nodeType: "embedCard",
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            hasFallbackContainer: hasPreview,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $94b650125906c273$var$embedCardWrapperStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "embedCardView-content-wrap",
            "data-embed-card": true,
            "data-layout": layout,
            "data-width": width,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            "data-card-original-height": originalHeight
        }, cardComponent))))));
    }));
}
const $94b650125906c273$export$1135f3b0aac4c4ec = ({ url: url, data: data, eventHandlers: eventHandlers, portal: portal, originalHeight: originalHeight, originalWidth: originalWidth, width: embedWidth, layout: layout, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension })=>{
    const { width: width } = (0, $eJOHy.useContext)((0, $2bEPZ.WidthContext));
    const viewAsBlockCard = width && width <= (0, $7yBx7.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9ug1Y.default), {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        layout: layout,
        rendererAppearance: rendererAppearance,
        smartLinks: smartLinks
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)($94b650125906c273$var$EmbedCardInternal, {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        width: embedWidth,
        layout: layout,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        smartLinks: smartLinks,
        isInsideOfInlineExtension: isInsideOfInlineExtension
    });
};
const $94b650125906c273$var$EmbedCardWithCondition = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_preview_panel_responsiveness', 'isEnabled', true), $94b650125906c273$export$1135f3b0aac4c4ec, $94b650125906c273$var$EmbedCardInternal);
var $94b650125906c273$export$2e2bcd8739ae039 = $94b650125906c273$var$EmbedCardWithCondition;

});
parcelRegister("6PcbG", function(module, exports) {

$parcel$export(module.exports, "EmbedResizeMessageListener", () => $70e409de76fcb943$export$3482036c37e627f4);

var $eJOHy = parcelRequire("eJOHy");

var $65oSX = parcelRequire("65oSX");
class $70e409de76fcb943$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $65oSX.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("jYx9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $209fa0d68bd3a102$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $1I3aa = parcelRequire("1I3aa");

var $2zJxT = parcelRequire("2zJxT");

var $19zEl = parcelRequire("19zEl");

var $jhKIq = parcelRequire("jhKIq");
function $209fa0d68bd3a102$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $19zEl.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $2zJxT.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jhKIq.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            nodeType: nodeType
        }),
        ...(0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $jgJtD.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("1I3aa", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $63e3275bb42d0987$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $63e3275bb42d0987$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $63e3275bb42d0987$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $63e3275bb42d0987$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $63e3275bb42d0987$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $63e3275bb42d0987$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $63e3275bb42d0987$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $63e3275bb42d0987$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $63e3275bb42d0987$export$b4b560efd3c61856);
const $63e3275bb42d0987$export$5937600f4cc784f0 = 24;
const $63e3275bb42d0987$export$71d660e8ca5b8f73 = 320;
const $63e3275bb42d0987$export$cd11d7d46412c89b = 3;
const $63e3275bb42d0987$export$71482734bb54ac3 = 10;
const $63e3275bb42d0987$export$fd2b09475ada41cc = 12;
const $63e3275bb42d0987$export$8c5ac0b0c62a3d21 = 8;
const $63e3275bb42d0987$export$68d0abe4f03863fb = $63e3275bb42d0987$export$fd2b09475ada41cc * 2;
const $63e3275bb42d0987$export$d722b7527b1834a8 = 250;
const $63e3275bb42d0987$export$da894f7669b4e67c = 200;
const $63e3275bb42d0987$export$e13825c38da2ce1 = 100;
var $63e3275bb42d0987$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $63e3275bb42d0987$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $63e3275bb42d0987$export$4d41d008e9cd4f34 = 0.5;
const $63e3275bb42d0987$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("2zJxT", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $80b986ec0541becf$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $80b986ec0541becf$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $80b986ec0541becf$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $80b986ec0541becf$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $80b986ec0541becf$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $80b986ec0541becf$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $80b986ec0541becf$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $80b986ec0541becf$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $80b986ec0541becf$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $80b986ec0541becf$export$22e4c8c04f58169d);

var $3lIcL = parcelRequire("3lIcL");

var $7yBx7 = parcelRequire("7yBx7");

var $cbSL1 = parcelRequire("cbSL1");

var $19zEl = parcelRequire("19zEl");

var $1I3aa = parcelRequire("1I3aa");
function $80b986ec0541becf$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $80b986ec0541becf$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $80b986ec0541becf$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $80b986ec0541becf$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $1I3aa.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $80b986ec0541becf$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $80b986ec0541becf$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $7yBx7.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $80b986ec0541becf$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $7yBx7.akEditorFullPageNarrowBreakout) && (0, $cbSL1.expValEquals)('platform_editor_preview_panel_responsiveness', 'isEnabled', true) ? (0, $7yBx7.akEditorGutterPaddingReduced) : (0, $7yBx7.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $7yBx7.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7yBx7.akEditorFullWidthLayoutWidth));
};
const $80b986ec0541becf$export$4ab195f543459515 = (origWidth = (0, $1I3aa.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $7yBx7.akEditorDefaultLayoutWidth), minWidth = (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $80b986ec0541becf$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $80b986ec0541becf$export$f72673597dacfcfa = (value, interval = (0, $1I3aa.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $80b986ec0541becf$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $1I3aa.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $80b986ec0541becf$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $19zEl.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $80b986ec0541becf$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $80b986ec0541becf$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $80b986ec0541becf$export$7cc71489edfd26f8($pos, view) : $80b986ec0541becf$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $80b986ec0541becf$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $19zEl.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $80b986ec0541becf$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $80b986ec0541becf$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $3lIcL.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});
parcelRegister("19zEl", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $b3204125fc08effb$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $b3204125fc08effb$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $b3204125fc08effb$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $b3204125fc08effb$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $b3204125fc08effb$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $b3204125fc08effb$export$de65085e667b4bf1);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $24wSW = parcelRequire("24wSW");
const $b3204125fc08effb$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $24wSW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $b3204125fc08effb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $b3204125fc08effb$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $b3204125fc08effb$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $b3204125fc08effb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $b3204125fc08effb$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $b3204125fc08effb$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $24wSW.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $24wSW.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("24wSW", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $41c0bcab9a8da41b$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $41c0bcab9a8da41b$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $41c0bcab9a8da41b$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $41c0bcab9a8da41b$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $41c0bcab9a8da41b$export$5e51fc02b9ada5af);

var $7yBx7 = parcelRequire("7yBx7");

var $1I3aa = parcelRequire("1I3aa");
const $41c0bcab9a8da41b$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $41c0bcab9a8da41b$export$adfc02948d64a4f2 = (layout)=>$41c0bcab9a8da41b$var$validWidthModes.indexOf(layout) > -1;
function $41c0bcab9a8da41b$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $41c0bcab9a8da41b$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $41c0bcab9a8da41b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $41c0bcab9a8da41b$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($41c0bcab9a8da41b$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $41c0bcab9a8da41b$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7yBx7.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $41c0bcab9a8da41b$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $41c0bcab9a8da41b$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($41c0bcab9a8da41b$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $41c0bcab9a8da41b$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});



parcelRegister("jhKIq", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $4e85bca9ec1dc949$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $4e85bca9ec1dc949$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $4e85bca9ec1dc949$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $fNh22 = parcelRequire("fNh22");

var $19zEl = parcelRequire("19zEl");

var $bnh3n = parcelRequire("bnh3n");
function $4e85bca9ec1dc949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $4e85bca9ec1dc949$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $4e85bca9ec1dc949$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $4e85bca9ec1dc949$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $4e85bca9ec1dc949$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $4e85bca9ec1dc949$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $4e85bca9ec1dc949$var$_ref = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $4e85bca9ec1dc949$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $4e85bca9ec1dc949$var$_ref, "max-width:", (0, $fNh22.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $4e85bca9ec1dc949$var$float(layout), ";margin:", $4e85bca9ec1dc949$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $4e85bca9ec1dc949$var$isImageAligned(layout), ";");
};
const $4e85bca9ec1dc949$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $1NIU8.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("position:relative;", $4e85bca9ec1dc949$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $4e85bca9ec1dc949$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6(rest)
    }, children);
$4e85bca9ec1dc949$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $4e85bca9ec1dc949$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});


const $9a762f515f769003$export$12fd658e5eef0d79 = 32;
const $9a762f515f769003$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';



parcelRegister("fNJLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $183325db1cca8eeb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6Tw9l = parcelRequire("6Tw9l");

var $2FwjZ = parcelRequire("2FwjZ");

var $dHHKP = parcelRequire("dHHKP");

var $5KYHN = parcelRequire("5KYHN");
/**
 * Synchronous renderer node mapping for media nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $183325db1cca8eeb$var$nodeToReact = {
    media: (0, $6Tw9l.default),
    mediaGroup: (0, $2FwjZ.default),
    mediaInline: (0, $dHHKP.default),
    mediaSingle: (0, $5KYHN.default)
};
var $183325db1cca8eeb$export$2e2bcd8739ae039 = $183325db1cca8eeb$var$nodeToReact;

});
parcelRegister("6Tw9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7f1ffdadcf9370$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $e2B2h = parcelRequire("e2B2h");

var $eUaD0 = parcelRequire("eUaD0");

var $4sxxB = parcelRequire("4sxxB");

var $jhKIq = parcelRequire("jhKIq");

var $jMtSb = parcelRequire("jMtSb");

var $jxPcD = parcelRequire("jxPcD");

var $9Ybet = parcelRequire("9Ybet");

var $g9wjI = parcelRequire("g9wjI");

var $bMFKb = parcelRequire("bMFKb");
var $9XXFf = parcelRequire("9XXFf");

var $eGOwo = parcelRequire("eGOwo");

var $7ueoK = parcelRequire("7ueoK");

var $fpMtm = parcelRequire("fpMtm");

var $11jfh = parcelRequire("11jfh");
var $a61Rj = parcelRequire("a61Rj");
var $avOy4 = parcelRequire("avOy4");
var $88noB = parcelRequire("88noB");

var $6YFG2 = parcelRequire("6YFG2");

var $8QIFO = parcelRequire("8QIFO");

var $eq5No = parcelRequire("eq5No");

var $4Fc33 = parcelRequire("4Fc33");

var $e2m7L = parcelRequire("e2m7L");
function $cb7f1ffdadcf9370$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb7f1ffdadcf9370$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $cb7f1ffdadcf9370$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $cb7f1ffdadcf9370$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $1NIU8.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $cb7f1ffdadcf9370$var$linkStyle
    }, children));
};
const $cb7f1ffdadcf9370$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fpMtm.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $cb7f1ffdadcf9370$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children)));
};
const $cb7f1ffdadcf9370$var$CommentBadge = (0, $6YFG2.default)((0, $11jfh.CommentBadge));
const $cb7f1ffdadcf9370$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadge, {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        ...rest
    });
};
const $cb7f1ffdadcf9370$var$CommentBadgeNextWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $a61Rj.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $cb7f1ffdadcf9370$var$Media extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
                data: {
                    [(0, $eUaD0.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, (0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $88noB.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, visible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avOy4.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeNextWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), !(0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeWrapper, {
                marks: annotationMarks,
                mediaSingleElement: mediaSingleElement,
                width: width,
                height: height,
                isDrafting: isDrafting
            }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jMtSb.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        }, this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VISITED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $g9wjI.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
}
const $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $eJOHy.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $eJOHy.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $cb7f1ffdadcf9370$export$2e2bcd8739ae039 = $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation;

});
parcelRegister("jMtSb", function(module, exports) {

$parcel$export(module.exports, "mediaIdentifierMap", () => $82c3186f94959555$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $82c3186f94959555$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $82c3186f94959555$export$a6543a2e3828db2c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fpoq4 = parcelRequire("fpoq4");

var $dcbV5 = parcelRequire("dcbV5");
var $5Ittp = parcelRequire("5Ittp");
var $bmpmu = parcelRequire("bmpmu");

var $93R6D = parcelRequire("93R6D");

var $5s6bt = parcelRequire("5s6bt");
const $82c3186f94959555$export$7da2d00ddd5627a6 = new Map();
const $82c3186f94959555$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $fpoq4.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $82c3186f94959555$export$cfff5eb155a82d30 extends (0, $eJOHy.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $82c3186f94959555$export$7da2d00ddd5627a6.has(id) || url && $82c3186f94959555$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $82c3186f94959555$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $82c3186f94959555$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $82c3186f94959555$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcbV5.default), {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Ittp.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...$82c3186f94959555$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcbV5.default), {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $82c3186f94959555$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $82c3186f94959555$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)($82c3186f94959555$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $82c3186f94959555$export$a6543a2e3828db2c = (0, $5s6bt.withImageLoader)($82c3186f94959555$export$fae4803d1ca121c8);

});
parcelRegister("fpoq4", function(module, exports) {

$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("dcbV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $440702c4dbb2b839$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $bmpmu = parcelRequire("bmpmu");

var $6FOAB = parcelRequire("6FOAB");
const $440702c4dbb2b839$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
const $440702c4dbb2b839$var$CardLoadingWithContext = ()=>{
    const props = (0, $eJOHy.useContext)($440702c4dbb2b839$var$MediaCardContext);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $440702c4dbb2b839$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bEb6t")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$CardLoadingWithContext, {})
});
const $440702c4dbb2b839$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$440702c4dbb2b839$var$CardLoader.preload = ()=>$440702c4dbb2b839$var$MediaCardWithMediaClientProvider.preload();
var $440702c4dbb2b839$export$2e2bcd8739ae039 = $440702c4dbb2b839$var$CardLoader;

});
parcelRegister("bmpmu", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $db1ec8ca7bffe853$export$5d25853fd6bdf402);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $28sr0 = parcelRequire("28sr0");

var $lWr6W = parcelRequire("lWr6W");

var $7ep4S = parcelRequire("7ep4S");
class $db1ec8ca7bffe853$export$5d25853fd6bdf402 extends (0, $eJOHy.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("28sr0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $61071ab5121234d6$export$36acad525b1fb57b);
const $61071ab5121234d6$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("lWr6W", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $e9eebb219ee337c1$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $5Jy1o = parcelRequire("5Jy1o");
const $e9eebb219ee337c1$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $5Jy1o.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("5Jy1o", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $f348d9bfdd9d67d9$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iYfp4 = parcelRequire("iYfp4");

const $f348d9bfdd9d67d9$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.center), {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("iYfp4", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $63bf6031dd7cc765$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $63bf6031dd7cc765$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $63bf6031dd7cc765$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $63bf6031dd7cc765$export$7a57f79000377ca2);

var $IW7jS = parcelRequire("IW7jS");
const $63bf6031dd7cc765$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $63bf6031dd7cc765$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $63bf6031dd7cc765$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $63bf6031dd7cc765$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $63bf6031dd7cc765$export$7a57f79000377ca2 = `
  border-radius: ${(0, $IW7jS.borderRadius)()}px;
`;
const $63bf6031dd7cc765$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $IW7jS.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $IW7jS.borderRadius)()}px;
`;
const $63bf6031dd7cc765$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("bEb6t", function(module, exports) {

let $87ac0b0ffd163c7e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $87ac0b0ffd163c7e$var$load("76n7a"),
    $87ac0b0ffd163c7e$var$load("l253H"),
    $87ac0b0ffd163c7e$var$load("ffQaD"),
    $87ac0b0ffd163c7e$var$load("kvRbA"),
    $87ac0b0ffd163c7e$var$load("7Kgk2")
]).then(()=>parcelRequire('a7bVf'));

});


parcelRegister("5Ittp", function(module, exports) {

$parcel$export(module.exports, "CardError", () => $ab93af2b85cbe70e$export$f7f7efdefcc02999);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $s1DYz = parcelRequire("s1DYz");

var $lWr6W = parcelRequire("lWr6W");

var $28sr0 = parcelRequire("28sr0");
class $ab93af2b85cbe70e$export$f7f7efdefcc02999 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $s1DYz.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("s1DYz", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", () => $1bf51cf07c3bbe77$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $88oIq = parcelRequire("88oIq");

var $fetIp = parcelRequire("fetIp");
class $1bf51cf07c3bbe77$export$19bc16ee58e19b3d extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $fetIp.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("88oIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::468397db8b621d0b872ec4fdf86e27df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ec23e149a3635ad$var$_react = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5ec23e149a3635ad$var$_statusWarning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("d8UFE")));

var $5ec23e149a3635ad$var$_warning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("78Hx3")));
function $5ec23e149a3635ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec23e149a3635ad$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $5ec23e149a3635ad$var$_react.default.createElement($5ec23e149a3635ad$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $5ec23e149a3635ad$var$_warning.default
    }, props));
$5ec23e149a3635ad$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $5ec23e149a3635ad$var$_default = module.exports.default = $5ec23e149a3635ad$var$StatusWarningIcon;

});
parcelRegister("78Hx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532b0c56cbaaba87$var$_react = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $532b0c56cbaaba87$var$_statusWarning = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("d8UFE")));
function $532b0c56cbaaba87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532b0c56cbaaba87$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $532b0c56cbaaba87$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $532b0c56cbaaba87$var$_statusWarning.default
    }));
$532b0c56cbaaba87$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $532b0c56cbaaba87$var$_default = module.exports.default = $532b0c56cbaaba87$var$EditorWarningIcon;

});


parcelRegister("fetIp", function(module, exports) {

$parcel$export(module.exports, "errorIconWrapperStyles", () => $0802496f61d134d4$export$8dcf6b831a37de79);
function $0802496f61d134d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0802496f61d134d4$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("5s6bt", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $e51a33182b24142b$export$9b0f795b2e33f057);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e51a33182b24142b$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $e51a33182b24142b$var$withImageLoaderNew(Wrapped);
};

});


parcelRegister("9Ybet", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $0340e326d8501f19$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $0340e326d8501f19$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $0340e326d8501f19$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $0340e326d8501f19$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});

parcelRegister("9XXFf", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $b3cdb4a4cbb698e4$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $b3cdb4a4cbb698e4$export$9cf3651d97128b9c);
var $b3cdb4a4cbb698e4$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $b3cdb4a4cbb698e4$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("11jfh", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $5ce53efbf51888c4$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $abjs4 = parcelRequire("abjs4");

var $7yBx7 = parcelRequire("7yBx7");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $5ce53efbf51888c4$var$commentBadgeWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $7yBx7.akEditorUnitZIndex) * 10
});
const $5ce53efbf51888c4$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $5ce53efbf51888c4$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $5ce53efbf51888c4$export$ef88b752358da42 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $eJOHy.useState)($5ce53efbf51888c4$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($5ce53efbf51888c4$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $5ce53efbf51888c4$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5ce53efbf51888c4$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $5ce53efbf51888c4$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
        })
    })));
});

});
parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $00e7a599837ddc3e$var$_comment = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("gDKBr")));
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $00e7a599837ddc3e$var$_comment.default
    }));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});

parcelRegister("kH7By", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $a53c9034f68ab7f9$export$4c0d145df60cfb04);

var $7qGN1 = parcelRequire("7qGN1");
const $a53c9034f68ab7f9$export$4c0d145df60cfb04 = (0, $7qGN1.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("a61Rj", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $3d21c0f76897116c$export$d5da84b0136a0cc4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $3d21c0f76897116c$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius'
});
const $3d21c0f76897116c$var$mediumBadgeStyles = (0, $1DXK0.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $3d21c0f76897116c$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $lRq8t.default)();
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            xcss: [
                $3d21c0f76897116c$var$baseStyles,
                $3d21c0f76897116c$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
            })
        })
    });
};

});

parcelRegister("avOy4", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $fc1bed99f2b44345$export$66bf2ed7a5d4691f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $i4Iw4 = parcelRequire("i4Iw4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $aGtA3 = parcelRequire("aGtA3");
const $fc1bed99f2b44345$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $fc1bed99f2b44345$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $fc1bed99f2b44345$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $lRq8t.default)();
    const message = intl.formatMessage((0, $aGtA3.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $fc1bed99f2b44345$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $fc1bed99f2b44345$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("aGtA3", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $6d685c4974759cb5$export$8e36294abfabe45e);

var $7qGN1 = parcelRequire("7qGN1");
const $6d685c4974759cb5$export$8e36294abfabe45e = (0, $7qGN1.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("88noB", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $e2b99d7830d902d4$export$6a31fc38737d0e58);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $e2b99d7830d902d4$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $e2b99d7830d902d4$var$hackedZIndexStyles = (0, $1DXK0.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $e2b99d7830d902d4$var$resizeOffsetStyles = (0, $1DXK0.xcss)({
    right: 'space.150'
});
const $e2b99d7830d902d4$var$getBadgeVisible = (width, height)=>{
    return width && width < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $e2b99d7830d902d4$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $eJOHy.useState)($e2b99d7830d902d4$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($e2b99d7830d902d4$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $e2b99d7830d902d4$var$containerStyles,
            useMinimumZIndex && $e2b99d7830d902d4$var$hackedZIndexStyles,
            extendedResizeOffset && $e2b99d7830d902d4$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("2FwjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85dfa6ab83027e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1n5AE = parcelRequire("1n5AE");

var $8TCRV = parcelRequire("8TCRV");

var $jgJtD = parcelRequire("jgJtD");

var $eGOwo = parcelRequire("eGOwo");
class $85dfa6ab83027e14$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(this.props.children);
        let content;
        const mediaGroupProps = (0, $eGOwo.fg)('platform_editor_fix_vc90_bug_with_files') ? (0, $jgJtD.VcMediaWrapperProps) : {};
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: "MediaGroup",
                ...mediaGroupProps,
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            resizeMode: 'stretchy-fit',
            cardDimensions: (0, $1n5AE.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCRV.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args), this.state = {
            animate: false,
            offset: 0
        }, this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            }), this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            }), this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}

});
parcelRegister("1n5AE", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $c1e5df8e84d43a31$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $c1e5df8e84d43a31$export$ed7b8a4728e9c63);
const $c1e5df8e84d43a31$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $c1e5df8e84d43a31$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $c1e5df8e84d43a31$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $c1e5df8e84d43a31$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $c1e5df8e84d43a31$export$d87a47989c00f322;
    if (appearance === 'square') return $c1e5df8e84d43a31$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $c1e5df8e84d43a31$export$aeb48196afcd236a;
    return $c1e5df8e84d43a31$export$d87a47989c00f322;
};

});

parcelRegister("8TCRV", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $51e2bdb89be2a557$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $51e2bdb89be2a557$export$817db220b90d8024);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6whbE = parcelRequire("6whbE");

var $fpMeu = parcelRequire("fpMeu");
const $51e2bdb89be2a557$var$DURATION_MIN = 0.5;
const $51e2bdb89be2a557$var$DURATION_MAX = 1.0;
const $51e2bdb89be2a557$var$EXTRA_PADDING = 4;
const $51e2bdb89be2a557$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $51e2bdb89be2a557$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $51e2bdb89be2a557$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            animate: false,
            offset: 0
        };
    }
    constructor(props){
        super(props), this.previousOffset = 0, this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        }, this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        }, this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        }, this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        }, this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        }, this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        }, this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        }, this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        }, this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($6whbE)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
	 * The furthest we can scroll, where the end of the buffer is just in view
	 */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $51e2bdb89be2a557$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $51e2bdb89be2a557$var$DURATION_MAX - $51e2bdb89be2a557$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $51e2bdb89be2a557$var$DURATION_MAX), $51e2bdb89be2a557$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $51e2bdb89be2a557$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $51e2bdb89be2a557$var$EXTRA_PADDING) return newOffset - $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fpMeu.FilmStripViewWrapper), {
            "data-testid": testId,
            children: [
                this.renderLeftArrow(),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListWrapper), {
                    ref: this.handleWindowElementChange,
                    onWheel: this.handleScroll,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    "data-testid": "filmstrip-list-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripList), {
                        ref: this.handleBufferElementChange,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            transform: transform,
                            transitionProperty: transitionProperty,
                            transitionDuration: transitionDuration
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, $51e2bdb89be2a557$var$mapReactChildToReactNode)
                    })
                }),
                this.renderRightArrow()
            ]
        });
    }
}
function $51e2bdb89be2a557$var$mapReactChildToReactNode(child, index) {
    const key = $51e2bdb89be2a557$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListItem), {
        index: key,
        children: child
    }, key);
}
function $51e2bdb89be2a557$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("6whbE", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $4bf31031c1570027$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$4bf31031c1570027$var$debounce.debounce = $4bf31031c1570027$var$debounce;
module.exports = $4bf31031c1570027$var$debounce;

});

parcelRegister("fpMeu", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $54f9ccb1c3ca850e$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $54f9ccb1c3ca850e$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $54f9ccb1c3ca850e$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $54f9ccb1c3ca850e$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $54f9ccb1c3ca850e$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $54f9ccb1c3ca850e$export$54cfc70c184c0713);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $k1DaH = parcelRequire("k1DaH");

var $1xzHS = parcelRequire("1xzHS");
const $54f9ccb1c3ca850e$export$924abd21043fc000 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowLeftWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowLeftWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$a5ffe38c17bbc0a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ShadowRight), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ShadowRight), {
        ...props
    });
const $54f9ccb1c3ca850e$export$abf07652016c7e56 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowRightWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowRightWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$b39b1b86b48b621f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.LeftArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.LeftArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$6208675820d4cc50 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.RightArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.RightArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$d37eb83491863cbb = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripViewWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripViewWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripList), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripList), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$54cfc70c184c0713 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListItem), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListItem), {
        ...props
    });

});
parcelRegister("k1DaH", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $bcdff6ce7bf895cc$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $bcdff6ce7bf895cc$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $bcdff6ce7bf895cc$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $bcdff6ce7bf895cc$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $bcdff6ce7bf895cc$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $bcdff6ce7bf895cc$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $bcdff6ce7bf895cc$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $bcdff6ce7bf895cc$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");


var $eGOwo = parcelRequire("eGOwo");
function $bcdff6ce7bf895cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bcdff6ce7bf895cc$var$filmStripViewStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $bcdff6ce7bf895cc$var$filmStripListWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $bcdff6ce7bf895cc$var$filmStripListStyles = {
    name: "fsf3or",
    styles: "margin:0;padding:0;transition-property:transform;transition-timing-function:cubic-bezier(0.77, 0, 0.175, 1);white-space:nowrap;display:inline-block"
};
const $bcdff6ce7bf895cc$var$filmStripListPaddingOverride = {
    name: "qc3urb",
    styles: "padding:0 !important"
};
const $bcdff6ce7bf895cc$var$filmStripListItemStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0
});
const $bcdff6ce7bf895cc$var$arrowWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "left:var(--ds-space-100, 8px);svg{padding-right:var(--ds-space-025, 2px);}");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowRightWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "right:var(--ds-space-100, 8px);svg{padding-left:var(--ds-space-025, 2px);}");
const $bcdff6ce7bf895cc$var$shadowStyles = {
    name: "atrqgo",
    styles: "position:absolute;z-index:10;height:100%;top:0;width:2px;background-color:var(--ds-border, rgba(0, 0, 0, 0.2))"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowLeftStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "left:0;");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowRightStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "right:0;");
const $bcdff6ce7bf895cc$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowLeftStyles
    }, children);
const $bcdff6ce7bf895cc$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowRightStyles
    }, children);
const $bcdff6ce7bf895cc$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$var$ShadowLeft, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $bcdff6ce7bf895cc$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $bcdff6ce7bf895cc$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $bcdff6ce7bf895cc$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $bcdff6ce7bf895cc$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("ul", {
        css: [
            $bcdff6ce7bf895cc$var$filmStripListStyles,
            // Feature gate checks can't be inside the css() call. When cleaning up platform_editor_media_group_padding_css_fix merge the filmStripListPaddingOverride into filmStripListStyles.
            (0, $eGOwo.fg)('platform_editor_media_group_padding_css_fix') && $bcdff6ce7bf895cc$var$filmStripListPaddingOverride
        ],
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $bcdff6ce7bf895cc$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $1NIU8.jsx)("li", {
        css: $bcdff6ce7bf895cc$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8TCRV.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});
parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b0338a1f0c13ece$var$_arrowRight = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("ePxSL")));
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $0b0338a1f0c13ece$var$_arrowRight.default
    }));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});



parcelRegister("1xzHS", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $28567b493ea4c8a6$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $28567b493ea4c8a6$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $28567b493ea4c8a6$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $28567b493ea4c8a6$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $28567b493ea4c8a6$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $28567b493ea4c8a6$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $28567b493ea4c8a6$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $28567b493ea4c8a6$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $28567b493ea4c8a6$export$54cfc70c184c0713);
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");

var $eGOwo = parcelRequire("eGOwo");
const $28567b493ea4c8a6$var$filmStripViewStyles = null;
const $28567b493ea4c8a6$var$filmStripListWrapperStyles = null;
const $28567b493ea4c8a6$var$filmStripListStyles = null;
const $28567b493ea4c8a6$var$filmStripListPaddingOverride = null;
const $28567b493ea4c8a6$var$filmStripListItemStyles = null;
const $28567b493ea4c8a6$var$arrowWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowLeftWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowRightWrapperStyles = null;
const $28567b493ea4c8a6$var$shadowStyles = null;
const $28567b493ea4c8a6$var$shadowLeftStyles = null;
const $28567b493ea4c8a6$var$shadowRightStyles = null;
const $28567b493ea4c8a6$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1ltvidpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1xi2idpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$var$ShadowLeft, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$924abd21043fc000, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
                color: "currentColor",
                spacing: "spacious",
                label: "left"
            })
        })
    });
const $28567b493ea4c8a6$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$a5ffe38c17bbc0a1, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$abf07652016c7e56, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
                color: "currentColor",
                spacing: "spacious",
                label: "right"
            })
        })
    });
const $28567b493ea4c8a6$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_2rko1l7b _kqswh2mm _ca0q1ysw _u5f3idpf _n3td1ysw _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f31ysw _n3tdv77o _19bv1ysw"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l",
            (0, $eGOwo.fg)('platform_editor_media_group_padding_css_fix') && "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $8TCRV.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        children: children
    }, index);

});




parcelRegister("dHHKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $307e48cc7be010e9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $jSAy9 = parcelRequire("jSAy9");

var $6Ramj = parcelRequire("6Ramj");

var $gAeD7 = parcelRequire("gAeD7");

var $aRuva = parcelRequire("aRuva");
var $93R6D = parcelRequire("93R6D");

var $1dILD = parcelRequire("1dILD");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $jMtSb = parcelRequire("jMtSb");

var $ftN6c = parcelRequire("ftN6c");

var $7DXmb = parcelRequire("7DXmb");

var $ex5uO = parcelRequire("ex5uO");

var $bMFKb = parcelRequire("bMFKb");
const $307e48cc7be010e9$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $eJOHy.useState)();
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const contextIdentifierProvider = (0, $6Ramj.useProvider)('contextIdentifierProvider');
    (0, $eJOHy.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $eJOHy.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $jMtSb.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $jMtSb.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $jMtSb.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
	 * Only show the loading view if the media client is not ready
	 * prevents calling the media API before the provider is ready
	 */ if (!mediaClient) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $jMtSb.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gAeD7.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $jMtSb.mediaIdentifierMap).values())
        })
    }));
};
const $307e48cc7be010e9$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DXmb.ErrorBoundary), {
            component: (0, $ex5uO.ACTION_SUBJECT).RENDERER,
            componentId: (0, $bMFKb.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jSAy9.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $aRuva.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($307e48cc7be010e9$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $307e48cc7be010e9$export$2e2bcd8739ae039 = (0, $6YFG2.default)($307e48cc7be010e9$var$MediaInline);

});
parcelRegister("jSAy9", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $1ce01a8e27c54526$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
var $6YFG2 = parcelRequire("6YFG2");

var $ftN6c = parcelRequire("ftN6c");

var $fhbkk = parcelRequire("fhbkk");
var $1yWtS = parcelRequire("1yWtS");

var $iPHIU = parcelRequire("iPHIU");

var $93R6D = parcelRequire("93R6D");

var $52iZC = parcelRequire("52iZC");

var $92xoS = parcelRequire("92xoS");

var $2u6SE = parcelRequire("2u6SE");

var $hgI1e = parcelRequire("hgI1e");

var $7FDta = parcelRequire("7FDta");

var $cXjeN = parcelRequire("cXjeN");

var $71iJ2 = parcelRequire("71iJ2");

var $jOuuz = parcelRequire("jOuuz");
const $1ce01a8e27c54526$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const [subscribeError, setSubscribeError] = (0, $eJOHy.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $eJOHy.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $eJOHy.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $4nehu.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $fhbkk.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $fhbkk.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $2u6SE.messages).failedToUpload : (0, $2u6SE.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('metadata-fetch', new (0, $iPHIU.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $93R6D.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7FDta.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $eJOHy.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $eJOHy.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $hgI1e.referenceHeights)['h1']),
            height: (0, $hgI1e.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $eJOHy.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $eJOHy.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $eJOHy.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $eJOHy.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $1NIU8.jsx)((0, $52iZC.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cXjeN.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $1ce01a8e27c54526$export$fca833ae4278270f = (0, $6YFG2.default)($1ce01a8e27c54526$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("fhbkk", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $fc8abd8d5aaead0b$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $fc8abd8d5aaead0b$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $fc8abd8d5aaead0b$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $fc8abd8d5aaead0b$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $fc8abd8d5aaead0b$export$3bc90882cb04fda4);

var $dUG6w = parcelRequire("dUG6w");

var $1yWtS = parcelRequire("1yWtS");
const $fc8abd8d5aaead0b$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc8abd8d5aaead0b$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $dUG6w.extractErrorInfo)(error)
        }
    };
};
const $fc8abd8d5aaead0b$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc8abd8d5aaead0b$export$d66a74eca3334206 = (fileState, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc8abd8d5aaead0b$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc8abd8d5aaead0b$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc8abd8d5aaead0b$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc8abd8d5aaead0b$export$95e48cf5f4b392a4(fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("dUG6w", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $7a3cd0208599350b$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $7a3cd0208599350b$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $7a3cd0208599350b$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $7a3cd0208599350b$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $7a3cd0208599350b$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $7a3cd0208599350b$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $7a3cd0208599350b$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $7a3cd0208599350b$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $7a3cd0208599350b$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $7a3cd0208599350b$export$4d33ada3618f7626);

var $4rKJa = parcelRequire("4rKJa");

var $1Z1Pq = parcelRequire("1Z1Pq");

var $5fWw9 = parcelRequire("5fWw9");
const $7a3cd0208599350b$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $7a3cd0208599350b$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $7a3cd0208599350b$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $7a3cd0208599350b$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $7a3cd0208599350b$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $7a3cd0208599350b$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $7a3cd0208599350b$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $7a3cd0208599350b$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $7a3cd0208599350b$export$4af9d71992e89714(error),
        error: $7a3cd0208599350b$export$88c61dcad53762da(error),
        errorDetail: $7a3cd0208599350b$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $7a3cd0208599350b$export$29aa614726672b2e(error)
    };
};
const $7a3cd0208599350b$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $7a3cd0208599350b$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $7a3cd0208599350b$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $1f17110950ea8e13$export$ec1779cb96554e1));
    }
}
const $7a3cd0208599350b$export$4d33ada3618f7626 = (payload)=>{
    return (0, $5fWw9.default)((0, $1f17110950ea8e13$export$ec1779cb96554e1))((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
};

});
const $1f17110950ea8e13$export$ec1779cb96554e1 = 'media';

parcelRegister("1Z1Pq", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $20926ab34ea0b90c$export$e24d38cbdf73bc1a);

var $eaj78 = parcelRequire("eaj78");

var $K2rwM = parcelRequire("K2rwM");
const $20926ab34ea0b90c$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $20926ab34ea0b90c$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $20926ab34ea0b90c$export$e24d38cbdf73bc1a = (payload)=>$20926ab34ea0b90c$var$hasFileAttributesWithFileId(payload) ? (0, $K2rwM.produce)(payload, $20926ab34ea0b90c$var$sanitiseFileId) : payload;

});


parcelRegister("1yWtS", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $f1bbe05207027c63$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $f1bbe05207027c63$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $f1bbe05207027c63$export$11f9f5835c5b9a04);
class $f1bbe05207027c63$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $f1bbe05207027c63$export$2c035820a31723e extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$10ab445310d30114 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$18e89b7e50818288 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $f1bbe05207027c63$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $f1bbe05207027c63$export$d0a45ab59b4606b extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(source){
        super($f1bbe05207027c63$export$921ab4548acefaa4(source));
    }
}
function $f1bbe05207027c63$export$36b43e3dd9a92(err) {
    return err instanceof $f1bbe05207027c63$export$ec8d022824f41295;
}
const $f1bbe05207027c63$export$b380593ba3516c6f = (err)=>err instanceof $f1bbe05207027c63$export$2c035820a31723e;
const $f1bbe05207027c63$export$e1d87830b3784f94 = (err)=>err instanceof $f1bbe05207027c63$export$10ab445310d30114;
const $f1bbe05207027c63$export$443aeb298d35d79d = (err)=>$f1bbe05207027c63$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $f1bbe05207027c63$export$f00bb5a138da22e1(err) {
    return err instanceof $f1bbe05207027c63$export$d0a45ab59b4606b;
}
const $f1bbe05207027c63$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($f1bbe05207027c63$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error);
};
const $f1bbe05207027c63$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});


parcelRegister("52iZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0820605509642c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8uE0z = parcelRequire("8uE0z");

var $3ilWa = parcelRequire("3ilWa");

const $a0820605509642c1$var$MediaViewer = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k9lR4")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a0820605509642c1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uE0z.default), {}),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3ilWa.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($a0820605509642c1$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("8uE0z", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $acef3481867ac96c$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $acef3481867ac96c$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cydC6 = parcelRequire("cydC6");

var $58yRG = parcelRequire("58yRG");
const $acef3481867ac96c$export$442b7be89436c101 = '#101214';
const $acef3481867ac96c$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cydC6.default), {
        blankedColor: $acef3481867ac96c$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $acef3481867ac96c$export$2e2bcd8739ae039 = $acef3481867ac96c$var$ModalSpinner;

});
parcelRegister("cydC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $de987251ba68b050$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hsRKd = parcelRequire("hsRKd");

var $6TR4y = parcelRequire("6TR4y");

var $eGOwo = parcelRequire("eGOwo");
const $de987251ba68b050$var$ModalSpinner = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6TR4y.default), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hsRKd.default), {
        ...props
    });
var $de987251ba68b050$export$2e2bcd8739ae039 = $de987251ba68b050$var$ModalSpinner;

});
parcelRegister("hsRKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $602a58390d6d877a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $7ep4S = parcelRequire("7ep4S");

var $aWILV = parcelRequire("aWILV");
function $602a58390d6d877a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $602a58390d6d877a$var$overlayZindex = (0, $IW7jS.layers).modal() + 10;
const $602a58390d6d877a$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $602a58390d6d877a$var$overlayZindex
});
$602a58390d6d877a$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $602a58390d6d877a$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$602a58390d6d877a$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $602a58390d6d877a$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $602a58390d6d877a$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $602a58390d6d877a$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $602a58390d6d877a$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("6TR4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5a6db7c09246b1$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $7c5a6db7c09246b1$var$blanketStyles = null;
const $7c5a6db7c09246b1$var$spinnerStyles = null;
const $7c5a6db7c09246b1$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $7c5a6db7c09246b1$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $7c5a6db7c09246b1$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hcewu.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $7c5a6db7c09246b1$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("3ilWa", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $a84a2d0c9c47ded9$export$51aee4c01b17acde);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");
const $a84a2d0c9c47ded9$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("k9lR4", function(module, exports) {

let $eab599dda55180d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $eab599dda55180d7$var$load("76n7a"),
    $eab599dda55180d7$var$load("l253H"),
    $eab599dda55180d7$var$load("7uCGO")
]).then(()=>parcelRequire('fnhCF'));

});


parcelRegister("2u6SE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6a633f8f2ba076f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6a633f8f2ba076f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("7FDta", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $2153b1d1e8a88e8e$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3xaEP = parcelRequire("3xaEP");

var $iN7PZ = parcelRequire("iN7PZ");

var $eJ3rj = parcelRequire("eJ3rj");

var $jOuuz = parcelRequire("jOuuz");
const $2153b1d1e8a88e8e$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $eJOHy.useMemo)(()=>({
            traceId: (0, $3xaEP.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJ3rj.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $1NIU8.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("iN7PZ", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $k9eRE.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("9JMwr"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9JMwr", function(module, exports) {

let $716df486413b4273$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $716df486413b4273$var$load("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("dopkG"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("dopkG", function(module, exports) {

let $9c012ac78e0c2259$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c012ac78e0c2259$var$load("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("eJ3rj", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $ae3b633856a58a58$export$1f97dc1e9d072692);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $2gvG4 = parcelRequire("2gvG4");

var $7meaC = parcelRequire("7meaC");

var $kHzU5 = parcelRequire("kHzU5");

var $82KGI = parcelRequire("82KGI");
const $ae3b633856a58a58$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $eJOHy.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $eJOHy.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $eJOHy.useState)(false);
    const imgRef = (0, $eJOHy.useRef)(null);
    const imageRef = (0, $eJOHy.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $82KGI.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $kHzU5.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $kHzU5.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            (0, $eGOwo.fg)('platform_media_add_ufo_custom_data') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gvG4.default), {
                data: {
                    hasMediaComponent: true
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7meaC.ImageComponent), {
                loading: loading,
                "data-testid": "media-image",
                "data-vc": "media-image",
                draggable: false,
                alt: alt,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onLoad: imageLoadHandler,
                onError: onImageError,
                imageRef: mergedRef,
                src: dataURI,
                crossOrigin: crossOrigin,
                ...(0, $jgJtD.VcMediaWrapperProps)
            })
        ]
    });
});

});
parcelRegister("2gvG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfbe10f2ed80f4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $bbfbe10f2ed80f4c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $2QO3b.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $2QO3b.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("7meaC", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $decf1876772446e6$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $decf1876772446e6$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $decf1876772446e6$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$decf1876772446e6$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("jOuuz", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $e52ee95dd819f1f5$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7ep4S = parcelRequire("7ep4S");


var $gs8y9 = parcelRequire("gs8y9");
const $e52ee95dd819f1f5$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
        size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $4cc10c9d7cf0f335$export$88e3664eef60c981 = 24;

parcelRegister("gs8y9", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $749039277bbba6eb$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $h2bfU = parcelRequire("h2bfU");
const $749039277bbba6eb$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $h2bfU.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("h2bfU", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $fc77b29b684fca05$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $fc77b29b684fca05$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("cXjeN", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $d4bafcc76de9e7c0$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $9Ybet = parcelRequire("9Ybet");

var $dA9km = parcelRequire("dA9km");
function $d4bafcc76de9e7c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $d4bafcc76de9e7c0$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $d4bafcc76de9e7c0$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $dA9km.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $dA9km.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $dA9km.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dA9km.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $dA9km.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $dA9km.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d4bafcc76de9e7c0$var$sizeWrapperStyle
    }, children)));
};

});

parcelRegister("71iJ2", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $0e978e36eb47184d$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");


var $gs8y9 = parcelRequire("gs8y9");

var $8wscQ = parcelRequire("8wscQ");
const $0e978e36eb47184d$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8wscQ.IconWrapper), null, icon || /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: "error",
        LEGACY_size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("8wscQ", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $dd51a983eed3d150$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $dd51a983eed3d150$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd51a983eed3d150$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $dd51a983eed3d150$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $dd51a983eed3d150$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("gAeD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7756ce5e045a8803$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1dILD = parcelRequire("1dILD");

var $e2B2h = parcelRequire("e2B2h");



class $7756ce5e045a8803$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9aJ0Y")),
                (parcelRequire("lKx1C")),
                (parcelRequire("iK7g4"))
            ]);
            $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("1dILD", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $d9d101fa7192f9b2$export$4449fcbb2ad61ad1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gPm7N = parcelRequire("gPm7N");

var $7ep4S = parcelRequire("7ep4S");

var $l31fP = parcelRequire("l31fP");

var $5ciG6 = parcelRequire("5ciG6");

var $j2rnC = parcelRequire("j2rnC");
class $d9d101fa7192f9b2$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l31fP.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("gPm7N", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $6c704da71263c31c$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Qiyl = parcelRequire("6Qiyl");
class $6c704da71263c31c$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Qiyl.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("6Qiyl", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $4d86fdfdcd037721$export$e6dfd72ab29f8598);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $f2zWK = parcelRequire("f2zWK");

var $kH9TH = parcelRequire("kH9TH");

var $eGOwo = parcelRequire("eGOwo");
const $4d86fdfdcd037721$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kH9TH.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f2zWK.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("f2zWK", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $2d6ca48d8599c26d$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $2d6ca48d8599c26d$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $2d6ca48d8599c26d$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $2d6ca48d8599c26d$var$selected;
    else return 'user-select: text';
};
const $2d6ca48d8599c26d$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$2d6ca48d8599c26d$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isError && {
        backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`,
        cursor: 'default',
        '&:hover': {
            backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`
        }
    });

});

parcelRegister("kH9TH", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $4a20dcc0fc7797ca$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4a20dcc0fc7797ca$var$selectedStyles = null;
const $4a20dcc0fc7797ca$var$notSelectedStyles = null;
const $4a20dcc0fc7797ca$var$errorStyles = null;
const $4a20dcc0fc7797ca$var$wrapperStyles = null;
const $4a20dcc0fc7797ca$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, isError: isError, children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $hcewu.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazj3m3 _bfhk155y _1rkwglyw _80omtlke _irr3u9me",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs1s9b _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhktaeo _80om73ad _irr3taeo"
        ]),
        children: children
    });

});



parcelRegister("l31fP", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $4a09982d44befcac$export$d34be4d513116847);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $aAlzy = parcelRequire("aAlzy");

var $j2rnC = parcelRequire("j2rnC");

var $av9Of = parcelRequire("av9Of");
class $4a09982d44befcac$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aAlzy.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("aAlzy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $96d4786aad5cbd79$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $96d4786aad5cbd79$export$a201b065fc2e76a1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $YR3FN = parcelRequire("YR3FN");

var $gbQOq = parcelRequire("gbQOq");

var $eGOwo = parcelRequire("eGOwo");
const $96d4786aad5cbd79$export$f04a61298a47a40f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.Icon), {
        ...props
    });
const $96d4786aad5cbd79$export$a201b065fc2e76a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.AKIconWrapper), {
        ...props
    });

});
parcelRegister("YR3FN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b89f5ef283d8dda8$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $b89f5ef283d8dda8$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $b89f5ef283d8dda8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b89f5ef283d8dda8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $aWILV.default)("img", {
    target: "ebf58rv1"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$b89f5ef283d8dda8$export$f04a61298a47a40f.defaultProps = {
    alt: 'icon'
};
const $b89f5ef283d8dda8$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ebf58rv0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("gbQOq", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $c1a7d8f879d0ef13$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $c1a7d8f879d0ef13$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c1a7d8f879d0ef13$var$iconStyles = null;
const $c1a7d8f879d0ef13$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    });
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $c1a7d8f879d0ef13$var$akIconWrapperStyles = null;
const $c1a7d8f879d0ef13$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("j2rnC", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $886d47d94cf849e3$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $886d47d94cf849e3$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $886d47d94cf849e3$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $886d47d94cf849e3$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $886d47d94cf849e3$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $886d47d94cf849e3$export$ddce81e032b0736e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fgqnC = parcelRequire("fgqnC");

var $fJTWk = parcelRequire("fJTWk");

var $eGOwo = parcelRequire("eGOwo");
const $886d47d94cf849e3$export$be58b4326e23250f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$e31a6cc0a4c97f0e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.EmojiWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$c73a53738ef9e3f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconTitleWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$75180efdd3f4d9c2 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$a16269f205a2f280 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeBlockWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$91b164375b8037b5 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.RightIconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$7291f9f954790243 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$ddce81e032b0736e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("fgqnC", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $074dc70059ec90b0$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $074dc70059ec90b0$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $074dc70059ec90b0$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $074dc70059ec90b0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $074dc70059ec90b0$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $074dc70059ec90b0$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $074dc70059ec90b0$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $074dc70059ec90b0$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $074dc70059ec90b0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $074dc70059ec90b0$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$be58b4326e23250f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts57"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts56"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts55"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $074dc70059ec90b0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts54"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$a16269f205a2f280 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts53"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$91b164375b8037b5 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts52"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$7291f9f954790243 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts51"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$ddce81e032b0736e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts50"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});

parcelRegister("fJTWk", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $fc17436d07b7b030$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fc17436d07b7b030$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fc17436d07b7b030$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fc17436d07b7b030$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $fc17436d07b7b030$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fc17436d07b7b030$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fc17436d07b7b030$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fc17436d07b7b030$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fc17436d07b7b030$var$iconObjectOverrideStyles = null;
// TODO: remove this override behaviour for @atlaskit/icon
const $fc17436d07b7b030$var$iconOverrideStyles = null;
const $fc17436d07b7b030$var$iconWrapperStyles = null;
const $fc17436d07b7b030$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$emojiWrapperStyles = null;
const $fc17436d07b7b030$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconTitleWrapperStyles = null;
const $fc17436d07b7b030$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeWrapperStyles = null;
const $fc17436d07b7b030$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeBlockWrapperStyles = null;
const $fc17436d07b7b030$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$rightIconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconEmptyWrapperStyles = null;
const $fc17436d07b7b030$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("5ciG6", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $50909b30725a64a2$export$52b4dfd89a6b3a1b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4pVLY = parcelRequire("4pVLY");

var $46TX0 = parcelRequire("46TX0");

var $eGOwo = parcelRequire("eGOwo");
const $50909b30725a64a2$export$52b4dfd89a6b3a1b = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46TX0.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4pVLY.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("4pVLY", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fgqnC = parcelRequire("fgqnC");

var $aWILV = parcelRequire("aWILV");
function $cbdd9d686d2b8174$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)((0, $fgqnC.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});

parcelRegister("46TX0", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f3d89c2e8c2ae7e2$var$spinnerWrapperStyles = null;
const $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("9aJ0Y", function(module, exports) {

let $6ad7f73c1d418af0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ad7f73c1d418af0$var$load("lrf77").then(()=>parcelRequire('bJDDe'));

});

parcelRegister("lKx1C", function(module, exports) {

let $fd5782f9c54fb147$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fd5782f9c54fb147$var$load("dxftE").then(()=>parcelRequire('1I6Li'));

});

parcelRegister("iK7g4", function(module, exports) {

let $da52273070a91008$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da52273070a91008$var$load("8WIWL").then(()=>parcelRequire('04V4O'));

});



parcelRegister("5KYHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1056964a4a2008d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $jYx9G = parcelRequire("jYx9G");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $fNh22 = parcelRequire("fNh22");

var $eGOwo = parcelRequire("eGOwo");


var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");
function $1056964a4a2008d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1056964a4a2008d5$var$DEFAULT_WIDTH = 250;
const $1056964a4a2008d5$var$DEFAULT_HEIGHT = 200;
const $1056964a4a2008d5$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $1056964a4a2008d5$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $1056964a4a2008d5$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $1056964a4a2008d5$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$1056964a4a2008d5$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $1056964a4a2008d5$var$checkForMediaElement(media.props.children);
    return media;
};
const $1056964a4a2008d5$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $7yBx7.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return 0, $7yBx7.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $1056964a4a2008d5$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $1056964a4a2008d5$var$DEFAULT_WIDTH, height: height = $1056964a4a2008d5$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $1056964a4a2008d5$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $1056964a4a2008d5$var$DEFAULT_WIDTH;
        height = $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : 0;
    const calcDimensions = (0, $eJOHy.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(mediaContainerWidth, layout);
        const maxWidth = (0, $fNh22.isSSR)() && widthAttr && typeof widthAttr === 'number' && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(widthAttr, containerWidth) : containerWidth;
        const maxHeight = height / width * maxWidth;
        const cardDimensions = {
            width: `${maxWidth}px`,
            height: `${maxHeight}px`
        };
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7yBx7.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7yBx7.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr
    ]);
    const originalDimensions = (0, $eJOHy.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $8dxEE.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $eJOHy.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $eJOHy.useContext)((0, $2bEPZ.WidthContext));
    const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $eJOHy.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles,
            $1056964a4a2008d5$var$uiMediaSingleLayoutStyles
        ] : [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYx9G.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $1056964a4a2008d5$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    if (!$1056964a4a2008d5$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $1056964a4a2008d5$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)($1056964a4a2008d5$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
var $1056964a4a2008d5$export$2e2bcd8739ae039 = (0, $6YFG2.default)($1056964a4a2008d5$var$MediaSingle);

});


parcelRegister("7esWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e21e95329b61c77$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ioMWp = parcelRequire("ioMWp");

var $aEpcu = parcelRequire("aEpcu");

var $8nyI6 = parcelRequire("8nyI6");

var $2XJ8t = parcelRequire("2XJ8t");

var $6L7mA = parcelRequire("6L7mA");

var $glEdp = parcelRequire("glEdp");

var $7naaD = parcelRequire("7naaD");

var $LiaMl = parcelRequire("LiaMl");

var $MUFrj = parcelRequire("MUFrj");

var $lu3aG = parcelRequire("lu3aG");

var $dF4iL = parcelRequire("dF4iL");
/**
 * Synchronous renderer node mapping for "small" / simple nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $2e21e95329b61c77$var$nodeToReact = {
    codeBlock: (0, $ioMWp.default),
    date: (0, $aEpcu.default),
    decisionList: (0, $8nyI6.default),
    decisionItem: (0, $2XJ8t.default),
    emoji: (0, $6L7mA.default),
    mention: (0, $glEdp.default),
    panel: (0, $7naaD.default),
    status: (0, $LiaMl.default),
    taskItem: (0, $MUFrj.default),
    taskList: (0, $lu3aG.default),
    expand: (0, $dF4iL.default)
};
var $2e21e95329b61c77$export$2e2bcd8739ae039 = $2e21e95329b61c77$var$nodeToReact;

});
parcelRegister("ioMWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b61bebfdfa14986$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $gBkUB = parcelRequire("gBkUB");

var $JQPCf = parcelRequire("JQPCf");

var $brgNx = parcelRequire("brgNx");

var $393V9 = parcelRequire("393V9");
function $4b61bebfdfa14986$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled } = props;
    const codeBidiWarningLabel = props.intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    const className = [
        (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $393V9.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $JQPCf.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines
    }));
}
var $4b61bebfdfa14986$export$2e2bcd8739ae039 = (0, $6YFG2.default)($4b61bebfdfa14986$var$CodeBlock);

});
parcelRegister("JQPCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d29b310f5adcbb7$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $1wVTG = parcelRequire("1wVTG");

var $gvE0s = parcelRequire("gvE0s");

var $2qMvj = parcelRequire("2qMvj");

var $9LvmA = parcelRequire("9LvmA");
const $9d29b310f5adcbb7$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9d29b310f5adcbb7$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $gvE0s.getLineNumWidth)(numLines) : 0;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $1wVTG.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $2qMvj.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LvmA.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            $9d29b310f5adcbb7$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9d29b310f5adcbb7$var$getCodeBlockStyles.shouldWrapLongLines : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $9d29b310f5adcbb7$var$getCodeBlockStyles.showLineNumbers : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9d29b310f5adcbb7$export$2e2bcd8739ae039 = $9d29b310f5adcbb7$var$CodeBlock;

});
parcelRegister("1wVTG", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $118a07406fdcc42b$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $118a07406fdcc42b$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $118a07406fdcc42b$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gvE0s", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $505da49d0d7d5a0b$export$cb7aec0206b595d2);
const $505da49d0d7d5a0b$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("2qMvj", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $aca27a94c0d64a9d$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $236Qa = parcelRequire("236Qa");
const $aca27a94c0d64a9d$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $236Qa.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("236Qa", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("9LvmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdbe531236814ef$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $2Csjy = parcelRequire("2Csjy");
var $5cdbe531236814ef$export$2e2bcd8739ae039 = (0, $2Csjy.default);

});
parcelRegister("2Csjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a371b7eb48e23c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9JmNq = parcelRequire("9JmNq");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $1a371b7eb48e23c4$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $9JmNq.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $1a371b7eb48e23c4$var$asyncGenerator = $1a371b7eb48e23c4$var$generator({
    loader: ()=>(parcelRequire("5vjXJ")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $1a371b7eb48e23c4$export$2e2bcd8739ae039 = $1a371b7eb48e23c4$var$asyncGenerator;

});
parcelRegister("9JmNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3e56997f5681d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $31Mrt = parcelRequire("31Mrt");

var $aRMho = parcelRequire("aRMho");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $bb3e56997f5681d6$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $31Mrt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $aRMho.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $bb3e56997f5681d6$export$2e2bcd8739ae039 = $bb3e56997f5681d6$var$Highlight;

});
parcelRegister("31Mrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9006a9331ecad2$export$2e2bcd8739ae039);

var $iWzFr = parcelRequire("iWzFr");

var $8RUxU = parcelRequire("8RUxU");

var $26DGa = parcelRequire("26DGa");

var $f2iL7 = parcelRequire("f2iL7");
const $ad9006a9331ecad2$var$newLineRegex = /\n/g;
function $ad9006a9331ecad2$var$getNewLines(str) {
    return str.match($ad9006a9331ecad2$var$newLineRegex);
}
function $ad9006a9331ecad2$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $f2iL7.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iWzFr.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $26DGa.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $ad9006a9331ecad2$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $8RUxU.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $8RUxU.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iWzFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4195943504268cef$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");

var $cyPrZ = parcelRequire("cyPrZ");
function $4195943504268cef$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $8RUxU.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $cyPrZ.default)(lineNumber));
            return children;
        }
    };
}
var $4195943504268cef$export$2e2bcd8739ae039 = $4195943504268cef$var$createLineGenerator;

});
parcelRegister("8RUxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $20548ef38714ae82$export$2e2bcd8739ae039);

var $cyPrZ = parcelRequire("cyPrZ");
function $20548ef38714ae82$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("cyPrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d9e4c0cc14d81b$export$2e2bcd8739ae039);
function $03d9e4c0cc14d81b$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("26DGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $380a054e11b3c43e$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");
function $380a054e11b3c43e$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $8RUxU.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $380a054e11b3c43e$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("f2iL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a951287c386786be$export$2e2bcd8739ae039);
function $a951287c386786be$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("aRMho", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec570abb3fe649d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JWUl7 = parcelRequire("JWUl7");
function $9ec570abb3fe649d$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $JWUl7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("JWUl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed639690821efdab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");

var $a4ixf = parcelRequire("a4ixf");
function $ed639690821efdab$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $ed639690821efdab$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $2E9Su.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $a4ixf.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $ed639690821efdab$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("a4ixf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ac4ebb91026fe6$export$2e2bcd8739ae039);

var $JWUl7 = parcelRequire("JWUl7");
function $e0ac4ebb91026fe6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $JWUl7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("5vjXJ", function(module, exports) {

let $401f551c179f054d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $401f551c179f054d$var$load("5sFLQ").then(()=>parcelRequire('5eKjD'));

});




parcelRegister("393V9", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e5f697e9fa7fb8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $gBkUB = parcelRequire("gBkUB");

var $lPhtO = parcelRequire("lPhtO");
const $92e5f697e9fa7fb8$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $1NIU8.css)({
    tabSize: 4,
    backgroundColor: `var(--ds-surface-raised, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $gBkUB.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $92e5f697e9fa7fb8$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: $92e5f697e9fa7fb8$var$codeBlockStyleOverrides
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lPhtO.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $92e5f697e9fa7fb8$export$2e2bcd8739ae039 = $92e5f697e9fa7fb8$var$CodeBlockContainer;

});
parcelRegister("lPhtO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a7be88d7acaf4d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iCiOj = parcelRequire("iCiOj");

var $aI5uR = parcelRequire("aI5uR");

const $c6a7be88d7acaf4d$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'sticky',
    top: '0px',
    background: `${`var(--ds-surface, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`}`
});
const $c6a7be88d7acaf4d$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `2px solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`}`,
        borderRadius: '4px',
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${`var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`}`,
        color: `${"var(--ds-icon, rgb(66, 82, 110))"}`,
        '&:hover': {
            borderWidth: '2px',
            backgroundColor: `${`var(--ds-surface-overlay-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${`var(--ds-background-neutral-bold-pressed, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`}`,
            borderRadius: '4px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${`var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`} !important`
        }
    }
});
const $c6a7be88d7acaf4d$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $c6a7be88d7acaf4d$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $c6a7be88d7acaf4d$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aI5uR.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iCiOj.default), {
        content: text
    })));
};
var $c6a7be88d7acaf4d$export$2e2bcd8739ae039 = $c6a7be88d7acaf4d$var$CodeBlockButtonContainer;

});
parcelRegister("iCiOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b33990a57461daa1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $abjs4 = parcelRequire("abjs4");

var $ehejR = parcelRequire("ehejR");

var $4TA31 = parcelRequire("4TA31");

var $k71qx = parcelRequire("k71qx");

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $bdjbf = parcelRequire("bdjbf");

var $ex5uO = parcelRequire("ex5uO");

var $hhRpb = parcelRequire("hhRpb");
const $b33990a57461daa1$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $eJOHy.useState)(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $eJOHy.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
                label: tooltip
            }),
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $ex5uO.ACTION).CLICKED,
                    actionSubject: (0, $ex5uO.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $ex5uO.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $ex5uO.EVENT_TYPE).UI
                });
                (0, $hhRpb.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
var $b33990a57461daa1$export$2e2bcd8739ae039 = (0, $6YFG2.default)($b33990a57461daa1$var$CopyButton);

});

parcelRegister("aI5uR", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c99907faa2d78c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $abjs4 = parcelRequire("abjs4");

var $ehejR = parcelRequire("ehejR");

var $fL0In = parcelRequire("fL0In");

var $k71qx = parcelRequire("k71qx");

var $bdjbf = parcelRequire("bdjbf");

var $ex5uO = parcelRequire("ex5uO");
const $96c99907faa2d78c$var$WrapIcon = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
};
const $96c99907faa2d78c$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $ehejR.codeBlockButtonMessages).unwrapCode : (0, $ehejR.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fL0In.default), {
                glyph: $96c99907faa2d78c$var$WrapIcon,
                label: ""
            }),
            isSelected: wrapLongLines,
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $ex5uO.ACTION).CLICKED,
                    actionSubject: (0, $ex5uO.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $ex5uO.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $ex5uO.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
var $96c99907faa2d78c$export$2e2bcd8739ae039 = (0, $6YFG2.default)($96c99907faa2d78c$var$CodeBlockWrapButton);

});




parcelRegister("aEpcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf37206f694b28ff$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fDsDd = parcelRequire("fDsDd");

var $dZ5Iy = parcelRequire("dZ5Iy");

var $6YFG2 = parcelRequire("6YFG2");

var $51MtK = parcelRequire("51MtK");

var $8KqmO = parcelRequire("8KqmO");
const $bf37206f694b28ff$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const className = !!parentIsIncompleteTask && (0, $dZ5Iy.isPastDate)(timestamp) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $dZ5Iy.timestampToTaskContext)(timestamp, intl) : (0, $dZ5Iy.timestampToString)(timestamp, intl)
        })
    });
});
const $bf37206f694b28ff$export$19285a5b05c4ea7c = (0, $6YFG2.default)($bf37206f694b28ff$var$Date);
function $bf37206f694b28ff$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $51MtK.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bf37206f694b28ff$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $bf37206f694b28ff$export$2e2bcd8739ae039 = $bf37206f694b28ff$var$DateWithFormatContext;

});
parcelRegister("dZ5Iy", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $588f444e520afb69$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $588f444e520afb69$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $588f444e520afb69$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $588f444e520afb69$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $588f444e520afb69$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $588f444e520afb69$export$fbc04a9e57b04a80);

var $btz6U = parcelRequire("btz6U");

var $bf0oy = parcelRequire("bf0oy");
var $588f444e520afb69$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($588f444e520afb69$var$FORMATS || {});
const $588f444e520afb69$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $588f444e520afb69$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $588f444e520afb69$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $588f444e520afb69$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $588f444e520afb69$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $588f444e520afb69$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $588f444e520afb69$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$588f444e520afb69$var$addLeadingZero(date.getUTCMonth() + 1)}-${$588f444e520afb69$var$addLeadingZero(date.getUTCDate())}`;
};
const $588f444e520afb69$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $bf0oy.default)(new Date(Number(timestamp)), new Date(Number($588f444e520afb69$export$6297728405c48562())));
};
const $588f444e520afb69$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($588f444e520afb69$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $btz6U.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $588f444e520afb69$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $588f444e520afb69$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("51MtK", function(module, exports) {

$parcel$export(module.exports, "TaskItemsFormatProvider", () => $fe0ad539e8418b69$export$1ca88acfa8fef6b0);
$parcel$export(module.exports, "useTaskItemsFormatContext", () => $fe0ad539e8418b69$export$617439880b48c653);
$parcel$export(module.exports, "TaskItemsFormatConsumer", () => $fe0ad539e8418b69$export$be32c078f3ebeea0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $fe0ad539e8418b69$var$defaultValue = [
    undefined,
    ()=>{}
];
const $fe0ad539e8418b69$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($fe0ad539e8418b69$var$defaultValue);
const $fe0ad539e8418b69$var$reducer = (_state, action)=>{
    return action;
};
function $fe0ad539e8418b69$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useReducer($fe0ad539e8418b69$var$reducer, undefined);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fe0ad539e8418b69$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $fe0ad539e8418b69$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($fe0ad539e8418b69$var$TaskItemsFormatContext);
}
function $fe0ad539e8418b69$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fe0ad539e8418b69$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}

});


parcelRegister("8nyI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7272273f0a960bf1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $69E4k = parcelRequire("69E4k");
class $7272273f0a960bf1$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $eJOHy.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $69E4k.default), {
            children: children
        });
    }
}

});
parcelRegister("69E4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d953788856e0e4a9$export$2e2bcd8739ae039);
/* DecisionList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
/*
	Increasing specificity with double ampersand to ensure these rules take
	priority over the global styles applied to 'ol' elements.
*/ const $d953788856e0e4a9$var$listStyles = null;
class $d953788856e0e4a9$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $hcewu.default)([
                "_1braglyw _1yxxidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                    "data-decision-local-id": localId || '',
                    "data-decision-state": "DECIDED",
                    children: child
                }, idx);
            })
        });
    }
}

});


parcelRegister("2XJ8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $930079dcdcf2ddcb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $CEjVk = parcelRequire("CEjVk");
function $930079dcdcf2ddcb$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEjVk.default), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});
parcelRegister("CEjVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea95daa1bdf24abb$export$2e2bcd8739ae039);
/* DecisionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $luDPF = parcelRequire("luDPF");

var $6BQTj = parcelRequire("6BQTj");
const $ea95daa1bdf24abb$var$iconStyles = null;
const $ea95daa1bdf24abb$var$iconStylesWithPlaceholder = null;
const $ea95daa1bdf24abb$var$DecisionItem = ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const icon = /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        contentEditable: false,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dlexct _4t3i7vkz _1bsb7vkz _19pk1b66 _2hwxutpp _otyridpf _18u0idpf _syaz1yjp _1e0c1txw _4cvr1h6o _1bah1h6o",
            showPlaceholder && "_syaz1oju"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($luDPF))), {
            label: "Decision",
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: "large"
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BQTj.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes,
        children: children
    });
};
var $ea95daa1bdf24abb$export$2e2bcd8739ae039 = $ea95daa1bdf24abb$var$DecisionItem;

});
parcelRegister("luDPF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5b4c2ffbdf39ba$var$_react = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fa5b4c2ffbdf39ba$var$_decision = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("kXFxs")));

var $fa5b4c2ffbdf39ba$var$_decision2 = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("fvh9f")));
function $fa5b4c2ffbdf39ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5b4c2ffbdf39ba$var$DecisionIcon = (props)=>/*#__PURE__*/ $fa5b4c2ffbdf39ba$var$_react.default.createElement($fa5b4c2ffbdf39ba$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $fa5b4c2ffbdf39ba$var$_decision2.default
    }, props));
$fa5b4c2ffbdf39ba$var$DecisionIcon.Name = 'DecisionIconMigration';
var $fa5b4c2ffbdf39ba$var$_default = module.exports.default = $fa5b4c2ffbdf39ba$var$DecisionIcon;

});
parcelRegister("kXFxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4298a06d23defad$var$_react = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f4298a06d23defad$var$_baseNew = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f4298a06d23defad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4298a06d23defad$var$DecisionIcon = (props)=>/*#__PURE__*/ $f4298a06d23defad$var$_react.default.createElement($f4298a06d23defad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$f4298a06d23defad$var$DecisionIcon.displayName = 'DecisionIcon';
var $f4298a06d23defad$var$_default = module.exports.default = $f4298a06d23defad$var$DecisionIcon;

});

parcelRegister("fvh9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4970d82e75d8a32$var$_react = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b4970d82e75d8a32$var$_decision = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("kXFxs")));
function $b4970d82e75d8a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4970d82e75d8a32$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b4970d82e75d8a32$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $b4970d82e75d8a32$var$_decision.default
    }));
$b4970d82e75d8a32$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b4970d82e75d8a32$var$_default = module.exports.default = $b4970d82e75d8a32$var$EditorDecisionIcon;

});


parcelRegister("6BQTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d363850cec0944$export$2e2bcd8739ae039);
/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b6d363850cec0944$var$placeholderStyles = null;
const $b6d363850cec0944$var$placeholderTaskStyles = null;
const $b6d363850cec0944$var$decisionStyles = null;
const $b6d363850cec0944$var$contentStyles = null;
const $b6d363850cec0944$var$taskStyles = null;
class $b6d363850cec0944$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0tu8f _1reo15vq _18m915vq _kqswstnw _syaz131l _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza",
                itemType === 'TASK' && "_19pkidpf _2hwxidpf _otyridpf _18u0hwpb"
            ]),
            children: placeholder
        });
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $hcewu.default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $hcewu.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $hcewu.default)([
                "_2rkosqtm _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhkm7j4 _kqswh2mm _14hd1wug"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $hcewu.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}

});



parcelRegister("6L7mA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d256ab20218572b8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $4IKFn = parcelRequire("4IKFn");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $8KqmO = parcelRequire("8KqmO");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d256ab20218572b8$var$EmojiNode extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'EmojiNode';
    }
    static{
        this.defaultProps = {
            showTooltip: true
        };
    }
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": fallback || shortName
            }, fallback || shortName);
            if (!providers.emojiProvider) return null;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4IKFn.default), {
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true,
                onEmojiLoadSuccess: resourceConfig?.onEmojiLoadSuccess,
                onEmojiLoadFail: resourceConfig?.onEmojiLoadFail
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
function $d256ab20218572b8$var$EmojiItem(props) {
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $1NIU8.jsx)($d256ab20218572b8$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $1NIU8.jsx)($d256ab20218572b8$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    });
}
// Working around an issue with pre existing tests using react-test-renderer
// https://github.com/facebook/react/issues/17301#issuecomment-557765213
$d256ab20218572b8$var$EmojiItem.defaultProps = {};
var $d256ab20218572b8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($d256ab20218572b8$var$EmojiItem);

});
parcelRegister("4IKFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $60846143e9fc24cc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $htczl = parcelRequire("htczl");

var $b9cFG = parcelRequire("b9cFG");

var $8B8Wm = parcelRequire("8B8Wm");

var $8iUeU = parcelRequire("8iUeU");
const $60846143e9fc24cc$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9cFG.UfoErrorBoundary), {
        experiences: [
            (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htczl.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $60846143e9fc24cc$export$2e2bcd8739ae039 = $60846143e9fc24cc$var$ResourcedEmoji;

});
parcelRegister("htczl", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $b3a1b7c1097f467f$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $i4Ljn = parcelRequire("i4Ljn");

var $k8ZdJ = parcelRequire("k8ZdJ");

var $8B8Wm = parcelRequire("8B8Wm");

var $4FlMD = parcelRequire("4FlMD");

var $8B8Wm = parcelRequire("8B8Wm");
var $b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $b3a1b7c1097f467f$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $8iUeU.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $eJOHy.useState)();
    const [loaded, setLoaded] = (0, $eJOHy.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $eJOHy.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $eJOHy.useState)();
    const fetchOrGetEmoji = (0, $eJOHy.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_START);
        if ((0, $fqzOa.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $8B8Wm.hasUfoMarked)((0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId), (0, $adGgK.UfoEmojiTimings).FMP_END)) (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $eJOHy.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $eJOHy.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $eJOHy.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $fqzOa.isImageRepresentation)(emoji.representation) || (0, $fqzOa.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    width: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $eJOHy.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $eJOHy.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4FlMD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8ZdJ.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    loading: true,
                    xcss: placeholderXcss
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $b3a1b7c1097f467f$export$2e2bcd8739ae039 = $b3a1b7c1097f467f$export$7bfde52eceb3e2f6;

});
parcelRegister("8iUeU", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $2c4fbc100f789f14$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $2c4fbc100f789f14$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $2c4fbc100f789f14$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $2c4fbc100f789f14$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $2c4fbc100f789f14$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $2c4fbc100f789f14$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $2c4fbc100f789f14$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $2c4fbc100f789f14$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $2c4fbc100f789f14$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $2c4fbc100f789f14$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $2c4fbc100f789f14$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $2c4fbc100f789f14$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $2c4fbc100f789f14$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $2c4fbc100f789f14$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $2c4fbc100f789f14$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $2c4fbc100f789f14$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $2c4fbc100f789f14$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $2c4fbc100f789f14$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $2c4fbc100f789f14$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $2c4fbc100f789f14$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $2c4fbc100f789f14$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $2c4fbc100f789f14$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $2c4fbc100f789f14$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $2c4fbc100f789f14$export$66cabad5e268b05e);
const $2c4fbc100f789f14$export$5e4e3d1c3e43156a = 'CUSTOM';
const $2c4fbc100f789f14$export$78ccdc4be403c468 = 'FREQUENT';
const $2c4fbc100f789f14$export$2c4b04c3aacdf1b3 = 'SITE';
const $2c4fbc100f789f14$export$1b0258512be88334 = 'SEARCH';
const $2c4fbc100f789f14$export$42b510423367f354 = 'USER_CUSTOM';
const $2c4fbc100f789f14$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $2c4fbc100f789f14$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $2c4fbc100f789f14$export$8ac325bfd32359b0 = 'data:';
const $2c4fbc100f789f14$export$a330961542edfe6f = 'delete-emoji';
const $2c4fbc100f789f14$export$1a817f1886276c6d = 100000;
const $2c4fbc100f789f14$export$3f99ac31dc0406db = 20;
const $2c4fbc100f789f14$export$d171dc12fee2b1da = 350;
const $2c4fbc100f789f14$export$c10ac8125a260041 = 80;
const $2c4fbc100f789f14$export$5248fb9e0cccc41f = 'medium';
const $2c4fbc100f789f14$export$94f75d625e7801d3 = 260;
const $2c4fbc100f789f14$export$7ed599d166d65aea = 295;
const $2c4fbc100f789f14$export$7722b8e9522021df = $2c4fbc100f789f14$export$7ed599d166d65aea - 58; // picker height - actions height
const $2c4fbc100f789f14$export$e218e5cb105a0e22 = 54;
const $2c4fbc100f789f14$export$e67f617938b111f1 = $2c4fbc100f789f14$export$7ed599d166d65aea + $2c4fbc100f789f14$export$e218e5cb105a0e22;
const $2c4fbc100f789f14$export$e394a0c530ae5631 = 'fabric.emoji';
const $2c4fbc100f789f14$export$79ee4ef84c545f8f = `${$2c4fbc100f789f14$export$e394a0c530ae5631}.selectedTone`;
const $2c4fbc100f789f14$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $2c4fbc100f789f14$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $2c4fbc100f789f14$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $2c4fbc100f789f14$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $2c4fbc100f789f14$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $2c4fbc100f789f14$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $2c4fbc100f789f14$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $2c4fbc100f789f14$export$4f0ee90b28d6efc5 = 0;
const $2c4fbc100f789f14$export$9f7de4293d27f3aa = 50;
const $2c4fbc100f789f14$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $2c4fbc100f789f14$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $2c4fbc100f789f14$export$2829f3ec323f8ec0 = 8;
const $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2 = 5;
const $2c4fbc100f789f14$export$858e8dc100a97278 = 150;
const $2c4fbc100f789f14$export$83aab2ae64548423 = 20;
const $2c4fbc100f789f14$export$66cabad5e268b05e = 100;

});

parcelRegister("fqzOa", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $23c7073f5fdbdf31$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $23c7073f5fdbdf31$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $23c7073f5fdbdf31$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $23c7073f5fdbdf31$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $23c7073f5fdbdf31$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $23c7073f5fdbdf31$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $23c7073f5fdbdf31$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $23c7073f5fdbdf31$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $23c7073f5fdbdf31$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $23c7073f5fdbdf31$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $23c7073f5fdbdf31$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $23c7073f5fdbdf31$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $23c7073f5fdbdf31$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $23c7073f5fdbdf31$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $23c7073f5fdbdf31$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $23c7073f5fdbdf31$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $23c7073f5fdbdf31$export$4bcbf61cb6832a8e);

var $2lSsS = parcelRequire("2lSsS");

var $8iUeU = parcelRequire("8iUeU");
const $23c7073f5fdbdf31$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $23c7073f5fdbdf31$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $23c7073f5fdbdf31$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $23c7073f5fdbdf31$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $23c7073f5fdbdf31$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $23c7073f5fdbdf31$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $23c7073f5fdbdf31$export$a7e82c67204c73a1 = (emoji)=>$23c7073f5fdbdf31$export$979133dc1df141c6(emoji.representation);
const $23c7073f5fdbdf31$export$7720a4954d6f75f8 = (rep)=>$23c7073f5fdbdf31$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $8iUeU.dataURLPrefix)) === 0;
const $23c7073f5fdbdf31$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $8iUeU.customCategory) && $23c7073f5fdbdf31$export$7720a4954d6f75f8(emoji.representation);
const $23c7073f5fdbdf31$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $23c7073f5fdbdf31$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $23c7073f5fdbdf31$export$dddfba07c16c94d2 = (key)=>key in (0, $2lSsS.messages);
const $23c7073f5fdbdf31$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $23c7073f5fdbdf31$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $23c7073f5fdbdf31$export$8d7d3de6b5b305d1(emoji);
};
const $23c7073f5fdbdf31$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $23c7073f5fdbdf31$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($23c7073f5fdbdf31$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $23c7073f5fdbdf31$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) && !$23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $23c7073f5fdbdf31$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $23c7073f5fdbdf31$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $23c7073f5fdbdf31$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("2lSsS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8dae1054855c684a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8dae1054855c684a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Emoji Atlassian & productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("adGgK", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $a40ac3523e94d0b5$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $a40ac3523e94d0b5$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $a40ac3523e94d0b5$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $a40ac3523e94d0b5$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $a40ac3523e94d0b5$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $a40ac3523e94d0b5$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $a40ac3523e94d0b5$export$482549d945a3723);
var $a40ac3523e94d0b5$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $a40ac3523e94d0b5$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $a40ac3523e94d0b5$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $a40ac3523e94d0b5$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $a40ac3523e94d0b5$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $a40ac3523e94d0b5$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $a40ac3523e94d0b5$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("i4Ljn", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $ce7d8292c0049cae$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $ce7d8292c0049cae$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $cBxa0 = parcelRequire("cBxa0");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $huLzh = parcelRequire("huLzh");

var $01aoY = parcelRequire("01aoY");


var $8B8Wm = parcelRequire("8B8Wm");
var $iVp1F = parcelRequire("iVp1F");

var $3PZQJ = parcelRequire("3PZQJ");

var $lXMGu = parcelRequire("lXMGu");

var $8B8Wm = parcelRequire("8B8Wm");

var $4g9mX = parcelRequire("4g9mX");

var $chAs1 = parcelRequire("chAs1");
const $ce7d8292c0049cae$var$emojiSpriteContainer = null;
const $ce7d8292c0049cae$var$emojiImageContainer = null;
const $ce7d8292c0049cae$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $8iUeU.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $huLzh.leftClick)(event)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleKeyDown = (props, event)=>{
    if (!(0, $8iUeU.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $8iUeU.KeyboardKeys).Enter || event.key === (0, $8iUeU.KeyboardKeys).Space)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $8iUeU.KeyboardKeys).Backspace) $ce7d8292c0049cae$var$handleDelete(props, event);
};
const $ce7d8292c0049cae$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $ce7d8292c0049cae$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $lXMGu.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $eb4c5e773f9bbee2$export$11462c0756c24ab6)} ${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${(0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $eb4c5e773f9bbee2$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $cBxa0.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $fqzOa.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $fqzOa.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $chAs1.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $eJOHy.useCallback)((event)=>{
        $ce7d8292c0049cae$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $eJOHy.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $3PZQJ.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $eJOHy.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $01aoY.default), {
                    onClick: (event)=>$ce7d8292c0049cae$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $ce7d8292c0049cae$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$ce7d8292c0049cae$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $ce7d8292c0049cae$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $ce7d8292c0049cae$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $ce7d8292c0049cae$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $ce7d8292c0049cae$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $iVp1F.useSampledUFOComponentExperience)((0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $eJOHy.useEffect)(()=>{
        const ufoExp = (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $fqzOa.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$99dfeb9d71c11788, {
        ...props
    });
};
var $ce7d8292c0049cae$export$2e2bcd8739ae039 = $ce7d8292c0049cae$export$56cc48506ff790a;

});
parcelRegister("cBxa0", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $37cc264674c90168$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $37cc264674c90168$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $37cc264674c90168$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $37cc264674c90168$export$b7e9058f156d8d19);

var $kp3br = parcelRequire("kp3br");

var $fqzOa = parcelRequire("fqzOa");

var $32Nbx = parcelRequire("32Nbx");
const $37cc264674c90168$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $37cc264674c90168$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $37cc264674c90168$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $kp3br.utils).requestService(serviceConfig, requestOptions);
};
const $37cc264674c90168$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $37cc264674c90168$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $37cc264674c90168$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$37cc264674c90168$var$calculateScale($37cc264674c90168$export$d39ce20a37bba061).altScale];
};
const $37cc264674c90168$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $37cc264674c90168$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $fqzOa.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $fqzOa.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($37cc264674c90168$export$db05e6ae1fd416af(imagePath, meta)) return (0, $fqzOa.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $32Nbx.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $37cc264674c90168$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $37cc264674c90168$export$55077db3efc820aa($37cc264674c90168$export$4a0301d636367e1d(altReps), meta);
};
const $37cc264674c90168$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $37cc264674c90168$export$55077db3efc820aa(representation, meta),
            altRepresentation: $37cc264674c90168$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $37cc264674c90168$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $37cc264674c90168$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $37cc264674c90168$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $37cc264674c90168$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $37cc264674c90168$var$getHeight = (fitToHeight)=>$37cc264674c90168$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $37cc264674c90168$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $37cc264674c90168$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("kp3br", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("7Eo2D")).AbstractResource);

$parcel$export(module.exports, "utils", () => $6d8672354a8f8023$export$eab97d15b1788b8d);
parcelRequire("cVQsv");
parcelRequire("7Eo2D");

var $cT1cs = parcelRequire("cT1cs");

var $dyzJo = parcelRequire("dyzJo");
const $6d8672354a8f8023$export$eab97d15b1788b8d = $cT1cs;
const $6d8672354a8f8023$export$3b4c04cf7dad0e50 = $dyzJo;

});
parcelRegister("cVQsv", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $f9c5af0d8b1f4531$export$2ac26f1ab7eda637);
const $f9c5af0d8b1f4531$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("7Eo2D", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $33168f42924c071f$export$4529f10aed0950d4);
class $33168f42924c071f$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("cT1cs", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $8293192fd096fa7a$export$97bfde5a702aaeca);

var $fiPhB = parcelRequire("fiPhB");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");
const $8293192fd096fa7a$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2Ndb8.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $8293192fd096fa7a$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2Ndb8", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $fdc006ca8b04950a$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $fdc006ca8b04950a$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $fdc006ca8b04950a$export$7d6ed858a91629c3);
const $fdc006ca8b04950a$export$160dbda113bfad3b = {};
const $fdc006ca8b04950a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $fdc006ca8b04950a$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $fdc006ca8b04950a$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $fdc006ca8b04950a$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $fdc006ca8b04950a$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("dyzJo", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $94befa78e14abede$export$8b13532c81e8ac89);

var $hCu6N = parcelRequire("hCu6N");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $fiPhB = parcelRequire("fiPhB");
const $94befa78e14abede$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2Ndb8.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $hCu6N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $94befa78e14abede$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("hCu6N", function(module, exports) {

$parcel$export(module.exports, "meros", () => $cd3d5734723579c0$export$74e0a034be2368c7);
var $cd3d5734723579c0$var$e = new TextDecoder;
async function $cd3d5734723579c0$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cd3d5734723579c0$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("32Nbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aab8f9e1de525a0$export$2e2bcd8739ae039);
let $9aab8f9e1de525a0$var$debugEnabled = false;
let $9aab8f9e1de525a0$var$stacktracesEnabled = false;
function $9aab8f9e1de525a0$export$748ada60eaf985cc(enable) {
    $9aab8f9e1de525a0$var$debugEnabled = enable;
}
function $9aab8f9e1de525a0$export$4f7017086af31c25(enable) {
    $9aab8f9e1de525a0$var$stacktracesEnabled = enable;
}
function $9aab8f9e1de525a0$export$2a858f450a2f66d() {
    if ($9aab8f9e1de525a0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $9aab8f9e1de525a0$export$2e2bcd8739ae039(msg, ...args) {
    if ($9aab8f9e1de525a0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("huLzh", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $730123a1a1d68375$export$34ebdaf2c517ae75);
function $730123a1a1d68375$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $730123a1a1d68375$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $730123a1a1d68375$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("01aoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $485888db4a729b65$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $kXEdL = parcelRequire("kXEdL");


var $8iUeU = parcelRequire("8iUeU");


var $8IeH1 = parcelRequire("8IeH1");
const $485888db4a729b65$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $485888db4a729b65$var$deleteButton = null;
const $485888db4a729b65$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $485888db4a729b65$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $eb4c5e773f9bbee2$export$b11fa39b56a371f6)
        ]),
        "data-testid": $485888db4a729b65$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $485888db4a729b65$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
                    label: (0, $8iUeU.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small",
                    size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $485888db4a729b65$export$2e2bcd8739ae039 = $485888db4a729b65$var$DeleteButton;

});
const $eb4c5e773f9bbee2$export$8633a0edef8e95dd = 'emoji-common-selected';
const $eb4c5e773f9bbee2$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $eb4c5e773f9bbee2$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $eb4c5e773f9bbee2$export$b06c4aab1d012063 = 'emoji-common-node';
const $eb4c5e773f9bbee2$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $eb4c5e773f9bbee2$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $eb4c5e773f9bbee2$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $eb4c5e773f9bbee2$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $eb4c5e773f9bbee2$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $eb4c5e773f9bbee2$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("8B8Wm", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $883d6eb80cdaaaf8$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $883d6eb80cdaaaf8$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $883d6eb80cdaaaf8$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $883d6eb80cdaaaf8$export$1466212a1606133);

var $adGgK = parcelRequire("adGgK");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");

var $jZzVI = parcelRequire("jZzVI");
const $883d6eb80cdaaaf8$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $883d6eb80cdaaaf8$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Experience,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
    };
};
const $883d6eb80cdaaaf8$var$customEmojiTimings = [
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $adGgK.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).METADATA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $adGgK.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_END
    }
];
const $883d6eb80cdaaaf8$export$615f888019c45765 = {
    'emoji-rendered': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $adGgK.UfoComponentName).EMOJI
        },
        type: (0, $aRnO1.ExperienceTypes).Operation,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
        timings: $883d6eb80cdaaaf8$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_PICKER_OPENED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SELECTION_RECORDED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_UPLOADED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SEARCHED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER))
};
const $883d6eb80cdaaaf8$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $883d6eb80cdaaaf8$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $883d6eb80cdaaaf8$export$1466212a1606133 = (providerType)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("jZzVI", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $79a9e98a54aa22fe$export$dc2f0946255b3f89);
const $79a9e98a54aa22fe$export$c7c4959fece2f3ec = {};
const $79a9e98a54aa22fe$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($79a9e98a54aa22fe$export$c7c4959fece2f3ec))delete $79a9e98a54aa22fe$export$c7c4959fece2f3ec[prop];
};
const $79a9e98a54aa22fe$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $79a9e98a54aa22fe$var$hasSampledFromStart = (experience)=>{
    if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $79a9e98a54aa22fe$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id]) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $79a9e98a54aa22fe$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("iVp1F", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $6912adc371031cc9$export$f959821a7419dee1);

var $eJOHy = parcelRequire("eJOHy");

var $jZzVI = parcelRequire("jZzVI");
const $6912adc371031cc9$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $6912adc371031cc9$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            (0, $jZzVI.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6912adc371031cc9$var$useConstructor(()=>{
        (0, $jZzVI.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("3PZQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $99400fbc97a519f7$export$2e2bcd8739ae039);
const $99400fbc97a519f7$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $99400fbc97a519f7$var$result.mac = /Mac/.test(navigator.platform);
    $99400fbc97a519f7$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $99400fbc97a519f7$export$2e2bcd8739ae039 = $99400fbc97a519f7$var$result;

});

parcelRegister("lXMGu", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $3e5fc6b003616943$export$2f62ee6831462844);

var $1fvOh = parcelRequire("1fvOh");

var $3PZQJ = parcelRequire("3PZQJ");
const $3e5fc6b003616943$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $1fvOh.useInView)(options);
    if (!(0, $3PZQJ.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("1fvOh", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $0e8fddefcb6714fc$export$2f62ee6831462844);
$parcel$export(module.exports, "default", () => $0e8fddefcb6714fc$export$a62107ca74432f44);

var $eJOHy = parcelRequire("eJOHy");
function $0e8fddefcb6714fc$var$_extends() {
    $0e8fddefcb6714fc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e8fddefcb6714fc$var$_extends.apply(this, arguments);
}
function $0e8fddefcb6714fc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0e8fddefcb6714fc$var$_setPrototypeOf(subClass, superClass);
}
function $0e8fddefcb6714fc$var$_setPrototypeOf(o, p) {
    $0e8fddefcb6714fc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e8fddefcb6714fc$var$_setPrototypeOf(o, p);
}
function $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e8fddefcb6714fc$var$observerMap = new Map();
var $0e8fddefcb6714fc$var$RootIds = new WeakMap();
var $0e8fddefcb6714fc$var$rootId = 0;
var $0e8fddefcb6714fc$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $0e8fddefcb6714fc$export$2ef3a60ee1f37bec(inView) {
    $0e8fddefcb6714fc$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $0e8fddefcb6714fc$var$getRootId(root) {
    if (!root) return '0';
    if ($0e8fddefcb6714fc$var$RootIds.has(root)) return $0e8fddefcb6714fc$var$RootIds.get(root);
    $0e8fddefcb6714fc$var$rootId += 1;
    $0e8fddefcb6714fc$var$RootIds.set(root, $0e8fddefcb6714fc$var$rootId.toString());
    return $0e8fddefcb6714fc$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $0e8fddefcb6714fc$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $0e8fddefcb6714fc$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $0e8fddefcb6714fc$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $0e8fddefcb6714fc$var$optionsToId(options);
    var instance = $0e8fddefcb6714fc$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $0e8fddefcb6714fc$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $0e8fddefcb6714fc$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $0e8fddefcb6714fc$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $0e8fddefcb6714fc$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $0e8fddefcb6714fc$var$observerMap["delete"](id);
        }
    };
}
var $0e8fddefcb6714fc$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $0e8fddefcb6714fc$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $0e8fddefcb6714fc$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $0e8fddefcb6714fc$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$0e8fddefcb6714fc$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $0e8fddefcb6714fc$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$0e8fddefcb6714fc$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(_this$props2, $0e8fddefcb6714fc$var$_excluded);
        return /*#__PURE__*/ $eJOHy.createElement(as || 'div', $0e8fddefcb6714fc$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($eJOHy.Component);
$0e8fddefcb6714fc$export$a62107ca74432f44.displayName = 'InView';
$0e8fddefcb6714fc$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $0e8fddefcb6714fc$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $eJOHy.useRef();
    var _React$useState = $eJOHy.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $eJOHy.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $0e8fddefcb6714fc$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $eJOHy.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("4g9mX", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $0d652cd35182c73f$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $0d652cd35182c73f$export$d151e4941072147c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $2lSsS = parcelRequire("2lSsS");

var $jA3IN = parcelRequire("jA3IN");

var $cfLrC = parcelRequire("cfLrC");

var $6fs4r = parcelRequire("6fs4r");
const $0d652cd35182c73f$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jA3IN.ToolTipContentWithKeymap), {
        description: formatMessage((0, $2lSsS.messages).deleteEmojiTooltip),
        keymap: (0, $cfLrC.backspace)
    });
};
const $0d652cd35182c73f$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $2lSsS.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("jA3IN", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $e82b8fc1f7abac1c$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cfLrC = parcelRequire("cfLrC");
const $e82b8fc1f7abac1c$var$tooltipShortcutStyle = null;
const $e82b8fc1f7abac1c$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cfLrC.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cfLrC", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $2d3a83954aa08a62$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $2d3a83954aa08a62$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $3PZQJ = parcelRequire("3PZQJ");
const $2d3a83954aa08a62$export$1ea584ca7009bcc1 = $2d3a83954aa08a62$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $2d3a83954aa08a62$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $2d3a83954aa08a62$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $2d3a83954aa08a62$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $3PZQJ.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $2d3a83954aa08a62$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $3PZQJ.default).mac ? '' : '+');
}

});



parcelRegister("chAs1", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $a4876ac4e3ec9e73$export$48d7c418edadb60c);

var $igDjg = parcelRequire("igDjg");
function $a4876ac4e3ec9e73$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $igDjg !== 'undefined' && $igDjg?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("k8ZdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5122c9670f038eb1$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8iUeU = parcelRequire("8iUeU");

const $5122c9670f038eb1$var$placeholderContainer = null;
const $5122c9670f038eb1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $5122c9670f038eb1$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $8iUeU.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": $5122c9670f038eb1$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $eb4c5e773f9bbee2$export$c7187bbd1a7a9244),
                (0, $eGOwo.fg)('platform_reactions_placeholder_custom_background') ? xcss : ''
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $5122c9670f038eb1$export$2e2bcd8739ae039 = $5122c9670f038eb1$var$EmojiPlaceholder;

});

parcelRegister("4FlMD", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $3ad4b3a3694a9c33$export$1120e666998e21b5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qseJ = parcelRequire("7qseJ");
const $3ad4b3a3694a9c33$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qseJ.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: props.children
    });
};

});
parcelRegister("7qseJ", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $e6e58c0a6a6190fa$export$f4a09143833145ed);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $64Cd4 = parcelRequire("64Cd4");

var $32Nbx = parcelRequire("32Nbx");
const $e6e58c0a6a6190fa$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $eJOHy.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $32Nbx.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64Cd4.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("64Cd4", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e);

var $eJOHy = parcelRequire("eJOHy");
const $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e = (0, $eJOHy.createContext)(null);

});




parcelRegister("b9cFG", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $54cade362a3b2ab3$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");
class $54cade362a3b2ab3$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("glEdp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d48ab14c082dbe8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $l2YrF = parcelRequire("l2YrF");

var $eGOwo = parcelRequire("eGOwo");

var $8KqmO = parcelRequire("8KqmO");
var $1d48ab14c082dbe8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2YrF.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            eventHandlers: eventHandlers && eventHandlers.mention
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2YrF.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});

});
parcelRegister("l2YrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad900880cd9dc016$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $4kfHb = parcelRequire("4kfHb");
class $ad900880cd9dc016$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4kfHb.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'mentionProvider',
                'profilecardProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("4kfHb", function(module, exports) {

$parcel$export(module.exports, "MentionWithProviders", () => $c69cef2e68c26109$export$cd21803c89efe790);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dNi7s = parcelRequire("dNi7s");

var $eGOwo = parcelRequire("eGOwo");

var $2C7bh = parcelRequire("2C7bh");
const $c69cef2e68c26109$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $c69cef2e68c26109$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $eJOHy.useState)(null);
    const mountedRef = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $c69cef2e68c26109$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $2C7bh.default) : (0, $dNi7s.default);
    const ssrPlaceholderId = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? `mention-${id}` : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
});

});
parcelRegister("dNi7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4e28c88c9024778$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $231b4 = parcelRequire("231b4");

var $49R7i = parcelRequire("49R7i");

var $8BCOX = parcelRequire("8BCOX");

var $lAjeM = parcelRequire("lAjeM");
class $d4e28c88c9024778$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $231b4.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $49R7i.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $lAjeM.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $49R7i.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $49R7i.MentionNameStatus).SERVICE_ERROR:
            case (0, $49R7i.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $8BCOX.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BCOX.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
}

});
parcelRegister("231b4", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $ccd5ccb172c3212e$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $ccd5ccb172c3212e$export$ae1fce5f69858ef3);

var $kp3br = parcelRequire("kp3br");

var $49R7i = parcelRequire("49R7i");

var $lAjeM = parcelRequire("lAjeM");

var $bPSqT = parcelRequire("bPSqT");

var $3s8bj = parcelRequire("3s8bj");
const $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS = 100;
const $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS = 20;
const $ccd5ccb172c3212e$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $ccd5ccb172c3212e$export$8576ba1ed2760927 extends $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $lAjeM.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $lAjeM.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ccd5ccb172c3212e$export$5a4331e3e1c43553 extends $ccd5ccb172c3212e$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $lAjeM.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $49R7i.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ccd5ccb172c3212e$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $49R7i.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $49R7i.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $ccd5ccb172c3212e$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ccd5ccb172c3212e$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ccd5ccb172c3212e$export$2e2bcd8739ae039 = $ccd5ccb172c3212e$export$5a4331e3e1c43553;

});
parcelRegister("49R7i", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $35dcc6829e4a1d1d$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $35dcc6829e4a1d1d$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $35dcc6829e4a1d1d$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $35dcc6829e4a1d1d$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $35dcc6829e4a1d1d$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $35dcc6829e4a1d1d$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $35dcc6829e4a1d1d$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $35dcc6829e4a1d1d$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $35dcc6829e4a1d1d$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $35dcc6829e4a1d1d$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $35dcc6829e4a1d1d$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $35dcc6829e4a1d1d$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $35dcc6829e4a1d1d$export$4369c812aac99591);
var $35dcc6829e4a1d1d$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $35dcc6829e4a1d1d$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $35dcc6829e4a1d1d$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $35dcc6829e4a1d1d$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $35dcc6829e4a1d1d$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $35dcc6829e4a1d1d$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $35dcc6829e4a1d1d$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $35dcc6829e4a1d1d$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $35dcc6829e4a1d1d$export$81124e6148ca5db0[0];
}
function $35dcc6829e4a1d1d$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[1];
}
function $35dcc6829e4a1d1d$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[2];
}
function $35dcc6829e4a1d1d$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[3];
}
function $35dcc6829e4a1d1d$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $35dcc6829e4a1d1d$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("lAjeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $11dfa2f74f082c3a$export$2e2bcd8739ae039);
let $11dfa2f74f082c3a$var$debugEnabled = false;
let $11dfa2f74f082c3a$var$stacktracesEnabled = false;
function $11dfa2f74f082c3a$export$748ada60eaf985cc(enable) {
    $11dfa2f74f082c3a$var$debugEnabled = enable;
}
function $11dfa2f74f082c3a$export$4f7017086af31c25(enable) {
    $11dfa2f74f082c3a$var$stacktracesEnabled = enable;
}
function $11dfa2f74f082c3a$export$2a858f450a2f66d() {
    if ($11dfa2f74f082c3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $11dfa2f74f082c3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($11dfa2f74f082c3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bPSqT", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $504a08bf167f720e$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $504a08bf167f720e$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $504a08bf167f720e$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $504a08bf167f720e$export$91b2fa6a0fe06408);



var $49R7i = parcelRequire("49R7i");
const $504a08bf167f720e$var$packageName = "platform-pkg";
const $504a08bf167f720e$var$packageVersion = "0.0.0-use.local";
const $504a08bf167f720e$export$245097525aef1262 = 'sli';
const $504a08bf167f720e$export$c724588856bbfbcf = 'smart';
const $504a08bf167f720e$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            attributes: {
                packageName: $504a08bf167f720e$var$packageName,
                packageVersion: $504a08bf167f720e$var$packageVersion,
                componentName: (0, $49R7i.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $49R7i.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        return event;
    };
const $504a08bf167f720e$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $504a08bf167f720e$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
        attributes: {
            packageName: $504a08bf167f720e$var$packageName,
            packageVersion: $504a08bf167f720e$var$packageVersion,
            componentName: (0, $49R7i.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $504a08bf167f720e$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $504a08bf167f720e$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $49R7i.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $ab7a4be2f9c8c36f$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("8BCOX", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $3cb666b6a539664c$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $3cb666b6a539664c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3U4Mr = parcelRequire("3U4Mr");

var $eGOwo = parcelRequire("eGOwo");

var $eQ8jX = parcelRequire("eQ8jX");

var $a9LCE = parcelRequire("a9LCE");

var $21z29 = parcelRequire("21z29");

var $49R7i = parcelRequire("49R7i");

var $bPSqT = parcelRequire("bPSqT");

var $4J0ad = parcelRequire("4J0ad");

var $g0oDq = parcelRequire("g0oDq");

var $9pZhV = parcelRequire("9pZhV");

var $fRHzw = parcelRequire("fRHzw");
const $3cb666b6a539664c$export$7452d7062a4d0634 = 1000;
const $3cb666b6a539664c$export$af8124aa496797f2 = '_|unknown|_';
class $3cb666b6a539664c$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $3cb666b6a539664c$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $49R7i.MentionType).SELF;
            if ((0, $49R7i.isRestricted)(accessLevel)) return (0, $49R7i.MentionType).RESTRICTED;
            return (0, $49R7i.MentionType).DEFAULT;
        };
        (0, $fRHzw.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $fRHzw.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $fRHzw.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $g0oDq.UFOExperienceState)['STARTED'],
            (0, $g0oDq.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9pZhV.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$3cb666b6a539664c$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $49R7i.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3U4Mr.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a9LCE.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fRHzw.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                ...ssrPlaceholderProp,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eQ8jX.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $21z29.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $3cb666b6a539664c$var$MentionWithAnalytics = (0, $4J0ad.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $bPSqT.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $bPSqT.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($3cb666b6a539664c$export$92ab8442e7a15cef);
const $3cb666b6a539664c$var$Mention = $3cb666b6a539664c$var$MentionWithAnalytics;
var $3cb666b6a539664c$export$2e2bcd8739ae039 = $3cb666b6a539664c$var$Mention;

});
parcelRegister("eQ8jX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2080416dc299e9c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $9pZhV = parcelRequire("9pZhV");
const $b2080416dc299e9c$var$EMPTY = {};
const $b2080416dc299e9c$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($b2080416dc299e9c$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($b2080416dc299e9c$var$EMPTY);
        (0, $9pZhV.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $b2080416dc299e9c$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $lRq8t.default)();
    const messages = $b2080416dc299e9c$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $b2080416dc299e9c$export$2e2bcd8739ae039 = $b2080416dc299e9c$var$MessagesIntlProvider;

});
parcelRegister("9pZhV", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $a6i5A = parcelRequire("a6i5A");
const $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).unknownUserError);
const $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessWarning);
const $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessLabel);
const $2f0cb1eb1c5f7ba5$export$4a258ffee7316766 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultHeadline);
const $2f0cb1eb1c5f7ba5$export$702321a50d74536e = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultAdvisedAction);
const $2f0cb1eb1c5f7ba5$export$ed7f16088a93ae9d = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).loginAgain);
const $2f0cb1eb1c5f7ba5$export$3ab158df56460d1c = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).differentText);































const $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("4szku")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("9XDd9")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("gx10p")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("kiqhP")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9APxG")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("k5ES4")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("1FVE8")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bIIAX")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("4gV7R")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("2HZe0")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("4bhkm")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("9Pn8d")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("4Kxe3")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("iC4yX")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4jPuq")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("7PtEj")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kRcpS")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("cWfxa")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("kAXic")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6SNM9")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("g7WOD")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("ixd7L")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("js02x")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("o2tWm")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("kLzEb")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aWxcl")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("1nmV8")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("gb2xf")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("7IMPm")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("3yZRX")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("kiqhP")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("a6i5A", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fdd92d7113791d0a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fdd92d7113791d0a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("4szku", function(module, exports) {

let $33f52ea63eb00ea2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $33f52ea63eb00ea2$var$load("5EqMw").then(()=>parcelRequire('2EsuB'));

});

parcelRegister("9XDd9", function(module, exports) {

let $74080a3d69fd32f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $74080a3d69fd32f2$var$load("18eMn").then(()=>parcelRequire('jy2NA'));

});

parcelRegister("gx10p", function(module, exports) {

let $c090821939b5fe78$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c090821939b5fe78$var$load("9yF73").then(()=>parcelRequire('cMOoZ'));

});

parcelRegister("kiqhP", function(module, exports) {

let $ec69e10ecbe9df07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ec69e10ecbe9df07$var$load("7n0BP").then(()=>parcelRequire('8iZ79'));

});

parcelRegister("9APxG", function(module, exports) {

let $6fbf75151ad7f75e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6fbf75151ad7f75e$var$load("hyqM1").then(()=>parcelRequire('35wYa'));

});

parcelRegister("k5ES4", function(module, exports) {

let $ea03fa7340a60b18$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ea03fa7340a60b18$var$load("YxfNT").then(()=>parcelRequire('fuRMK'));

});

parcelRegister("1FVE8", function(module, exports) {

let $1386562285117e84$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1386562285117e84$var$load("9eAO5").then(()=>parcelRequire('3eJc8'));

});

parcelRegister("bIIAX", function(module, exports) {

let $88866573880029f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88866573880029f7$var$load("32vaB").then(()=>parcelRequire('il84e'));

});

parcelRegister("4gV7R", function(module, exports) {

let $31c4f80400c27ac9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31c4f80400c27ac9$var$load("leYa9").then(()=>parcelRequire('5ymPj'));

});

parcelRegister("2HZe0", function(module, exports) {

let $1f8f16eb06b4aeee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1f8f16eb06b4aeee$var$load("hzekf").then(()=>parcelRequire('4fX4g'));

});

parcelRegister("4bhkm", function(module, exports) {

let $30b5a1583ad26914$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30b5a1583ad26914$var$load("3hppq").then(()=>parcelRequire('4Wl86'));

});

parcelRegister("9Pn8d", function(module, exports) {

let $727ad1edcb0c7b02$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $727ad1edcb0c7b02$var$load("71qoR").then(()=>parcelRequire('2HdNw'));

});

parcelRegister("4Kxe3", function(module, exports) {

let $37553b3d9a1870d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37553b3d9a1870d2$var$load("kZ9Jj").then(()=>parcelRequire('cvwB6'));

});

parcelRegister("iC4yX", function(module, exports) {

let $d8cf50ad44d9b333$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d8cf50ad44d9b333$var$load("01BCB").then(()=>parcelRequire('5aO99'));

});

parcelRegister("4jPuq", function(module, exports) {

let $3250e095fb630129$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3250e095fb630129$var$load("9n2u9").then(()=>parcelRequire('4vSeO'));

});

parcelRegister("7PtEj", function(module, exports) {

let $5b344b83cdcbdcc4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5b344b83cdcbdcc4$var$load("aVj0b").then(()=>parcelRequire('42yuB'));

});

parcelRegister("kRcpS", function(module, exports) {

let $f2f263843d4b9006$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2f263843d4b9006$var$load("4OI9P").then(()=>parcelRequire('8uMOi'));

});

parcelRegister("cWfxa", function(module, exports) {

let $96b6f38b6f93ad0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96b6f38b6f93ad0a$var$load("9J4QP").then(()=>parcelRequire('9VAR9'));

});

parcelRegister("kAXic", function(module, exports) {

let $efe529aef976fd1b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $efe529aef976fd1b$var$load("lF2XI").then(()=>parcelRequire('12Lpf'));

});

parcelRegister("6SNM9", function(module, exports) {

let $502e659c51433f7f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $502e659c51433f7f$var$load("1HsGI").then(()=>parcelRequire('jedO8'));

});

parcelRegister("g7WOD", function(module, exports) {

let $bbdaec5f1e41c332$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bbdaec5f1e41c332$var$load("lXnsR").then(()=>parcelRequire('fr01P'));

});

parcelRegister("ixd7L", function(module, exports) {

let $d7e57d44b60ad313$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7e57d44b60ad313$var$load("8qZjs").then(()=>parcelRequire('471XU'));

});

parcelRegister("js02x", function(module, exports) {

let $e290a9c43457bbfa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e290a9c43457bbfa$var$load("e9lyC").then(()=>parcelRequire('alq7p'));

});

parcelRegister("o2tWm", function(module, exports) {

let $04842adc54830709$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04842adc54830709$var$load("31jpa").then(()=>parcelRequire('gLqyT'));

});

parcelRegister("kLzEb", function(module, exports) {

let $f1e3d93145a1904d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1e3d93145a1904d$var$load("3phC6").then(()=>parcelRequire('cxEzV'));

});

parcelRegister("aWxcl", function(module, exports) {

let $7f79129e486d4127$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f79129e486d4127$var$load("gQN5G").then(()=>parcelRequire('i4k66'));

});

parcelRegister("1nmV8", function(module, exports) {

let $1009b7f5e99c4d0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1009b7f5e99c4d0f$var$load("eYOjB").then(()=>parcelRequire('6zdul'));

});

parcelRegister("gb2xf", function(module, exports) {

let $bc6fa3e5809d48f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc6fa3e5809d48f7$var$load("jaR1c").then(()=>parcelRequire('llxNs'));

});

parcelRegister("7IMPm", function(module, exports) {

let $59f2849821bd0f61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $59f2849821bd0f61$var$load("a5Ksd").then(()=>parcelRequire('fc11e'));

});

parcelRegister("3yZRX", function(module, exports) {

let $29848a0500f15cfc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29848a0500f15cfc$var$load("jUx2Z").then(()=>parcelRequire('4raZH'));

});



parcelRegister("a9LCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d6272fa0b467372$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $49R7i = parcelRequire("49R7i");

var $eJOHy = parcelRequire("eJOHy");
const $2d6272fa0b467372$var$mentionStyle = {
    [(0, $49R7i.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`
    },
    [(0, $49R7i.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $49R7i.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    }
};
const $2d6272fa0b467372$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $2d6272fa0b467372$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $2d6272fa0b467372$var$PrimitiveMention = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)("display:inline;border:1px solid ", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $2d6272fa0b467372$export$2e2bcd8739ae039 = $2d6272fa0b467372$var$PrimitiveMention;

});

parcelRegister("21z29", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a684ea7707ceeb8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $8a684ea7707ceeb8$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("1a81O")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $8a684ea7707ceeb8$export$2e2bcd8739ae039 = $8a684ea7707ceeb8$var$AsyncNoAccessTooltip;

});
parcelRegister("1a81O", function(module, exports) {

let $0d8cf3e1bb9884e2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d8cf3e1bb9884e2$var$load("kCPaP").then(()=>parcelRequire('4aHpv'));

});


parcelRegister("fRHzw", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $94df87fd4b0cb8b6$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $94df87fd4b0cb8b6$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $94df87fd4b0cb8b6$export$1d011e4240507c78 = new (0, $9iIu4.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
class $94df87fd4b0cb8b6$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        $94df87fd4b0cb8b6$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("2C7bh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d131d6e38f6c2191$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dNi7s = parcelRequire("dNi7s");

var $caeqU = parcelRequire("caeqU");
function $d131d6e38f6c2191$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $eJOHy.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caeqU.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        ariaLabel: text.replace(/^@/, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dNi7s.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        })
    });
}

});
parcelRegister("caeqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ly6c")));

});
parcelRegister("2ly6c", function(module, exports) {

let $1b57fe43f319ccc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b57fe43f319ccc2$var$load("ffQaD"),
    $1b57fe43f319ccc2$var$load("kvRbA"),
    $1b57fe43f319ccc2$var$load("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("7m76n", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lWqKn")));

});
parcelRegister("lWqKn", function(module, exports) {

let $ff93c327b9f5ea83$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ff93c327b9f5ea83$var$load("76n7a"),
    $ff93c327b9f5ea83$var$load("l253H"),
    $ff93c327b9f5ea83$var$load("ffQaD"),
    $ff93c327b9f5ea83$var$load("kvRbA"),
    $ff93c327b9f5ea83$var$load("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("gh6xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("8WJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

parcelRegister("2EPX4", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("bQmsU", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("j19W0", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("fvpPO", function(module, exports) {

$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("0FujR", function(module, exports) {

$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.split('/').pop() || '';
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});



parcelRegister("46Rs7", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2XXEr")));

});
parcelRegister("2XXEr", function(module, exports) {

let $228f5cf7f6ecd638$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $228f5cf7f6ecd638$var$load("76n7a"),
    $228f5cf7f6ecd638$var$load("l253H"),
    $228f5cf7f6ecd638$var$load("ffQaD"),
    $228f5cf7f6ecd638$var$load("kvRbA"),
    $228f5cf7f6ecd638$var$load("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});







parcelRegister("7naaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d39984529f5e148$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $5WAQt = parcelRequire("5WAQt");

var $ePdnq = parcelRequire("ePdnq");

var $7kf0Z = parcelRequire("7kf0Z");

var $kZPQ0 = parcelRequire("kZPQ0");

var $lhPrb = parcelRequire("lhPrb");

var $6L7mA = parcelRequire("6L7mA");

var $dkTgd = parcelRequire("dkTgd");
var $35vki = parcelRequire("35vki");
var $cH4bN = parcelRequire("cH4bN");
var $2r7GW = parcelRequire("2r7GW");
var $clzOA = parcelRequire("clzOA");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
function $4d39984529f5e148$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7yBx7.akEditorCustomIconSize)) / 2;
const $4d39984529f5e148$var$panelEmojiImageVerticalAlignment = $4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment - 1;
const $4d39984529f5e148$var$blockNodesVerticalMargin = '0.75rem';
const $4d39984529f5e148$var$akEditorTableCellMinWidth = 48;
const $4d39984529f5e148$var$panelBaseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${$4d39984529f5e148$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$4d39984529f5e148$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #DEEBFF)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #1D7AFC)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$4d39984529f5e148$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            /*
      https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
      The default value for min-width is auto, which is computed to zero. When an element is a flex item, the value of min-width doesn’t compute to zero. The minimum size of a flex item is equal to the size of its contents.
      */ minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #EAE6FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #8270DB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E56910)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFEBE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        }
    }
});
const $4d39984529f5e148$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $4d39984529f5e148$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $4d39984529f5e148$var$nestedPanelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content .ak-editor-panel': {
        border: `1px solid ${"var(--ds-border, #091E42)"}`
    }
});
const $4d39984529f5e148$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $4d39984529f5e148$var$PanelStyled = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $kZPQ0.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $4d39984529f5e148$var$panelBaseStyles,
            !hasIcon && $4d39984529f5e148$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $ePdnq.PanelType).CUSTOM && backgroundColor && $4d39984529f5e148$var$panelCustomBackground,
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && $4d39984529f5e148$var$panelNestedIconStyles,
            (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') && $4d39984529f5e148$var$nestedPanelStyles
        ],
        ...props
    }, props.children);
};
$4d39984529f5e148$var$PanelStyled.displayName = 'PanelStyled';
const $4d39984529f5e148$var$panelIcons = {
    info: (0, $35vki.PanelInfoIcon),
    success: (0, $2r7GW.PanelSuccessIcon),
    note: (0, $cH4bN.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($5WAQt))),
    warning: (0, $clzOA.PanelWarningIcon),
    error: (0, $dkTgd.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($lhPrb)))
};
const $4d39984529f5e148$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $ePdnq.PanelType).CUSTOM ? (0, $ePdnq.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $ePdnq.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6L7mA.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $4d39984529f5e148$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, $1NIU8.jsx)(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            className: (0, $7kf0Z.PanelSharedCssClassName).icon
        }, icon);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4d39984529f5e148$var$PanelStyled, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7kf0Z.PanelSharedCssClassName).prefix,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon)
    }, renderIcon(), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $7kf0Z.PanelSharedCssClassName).content
    }, children));
};
var $4d39984529f5e148$export$2e2bcd8739ae039 = $4d39984529f5e148$var$Panel;

});
parcelRegister("5WAQt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2d7d7d35471a6e12918268c6980291>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $453ef33abfecf01e$var$_react = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $453ef33abfecf01e$var$_lightbulb = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("cfSUy")));

var $453ef33abfecf01e$var$_hint = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("bqzz1")));
function $453ef33abfecf01e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EditorHintIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $453ef33abfecf01e$var$LightbulbIcon = (props)=>/*#__PURE__*/ $453ef33abfecf01e$var$_react.default.createElement($453ef33abfecf01e$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $453ef33abfecf01e$var$_hint.default
    }, props));
$453ef33abfecf01e$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $453ef33abfecf01e$var$_default = module.exports.default = $453ef33abfecf01e$var$LightbulbIcon;

});
parcelRegister("bqzz1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $851db5a925fd71ea$var$_react = $851db5a925fd71ea$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $851db5a925fd71ea$var$_lightbulb = $851db5a925fd71ea$var$_interopRequireDefault((parcelRequire("cfSUy")));
function $851db5a925fd71ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $851db5a925fd71ea$var$EditorHintIcon = (props)=>/*#__PURE__*/ $851db5a925fd71ea$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props, {
        newIcon: $851db5a925fd71ea$var$_lightbulb.default
    }));
$851db5a925fd71ea$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $851db5a925fd71ea$var$_default = module.exports.default = $851db5a925fd71ea$var$EditorHintIcon;

});


parcelRegister("7kf0Z", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $8f40ff547e3f0696$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $8f40ff547e3f0696$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $8f40ff547e3f0696$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $8f40ff547e3f0696$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $ePdnq = parcelRequire("ePdnq");

var $kZPQ0 = parcelRequire("kZPQ0");

var $7yBx7 = parcelRequire("7yBx7");

var $7yBx7 = parcelRequire("7yBx7");


var $eGOwo = parcelRequire("eGOwo");
const $8f40ff547e3f0696$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $8f40ff547e3f0696$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $8f40ff547e3f0696$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7yBx7.akEditorCustomIconSize)) / 2;
const $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment = $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment - 1;
function $8f40ff547e3f0696$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$8f40ff547e3f0696$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $8f40ff547e3f0696$var$prefix = 'ak-editor-panel';
const $8f40ff547e3f0696$export$6dd740b6c888e050 = {
    prefix: $8f40ff547e3f0696$var$prefix,
    content: `${$8f40ff547e3f0696$var$prefix}__content`,
    icon: `${$8f40ff547e3f0696$var$prefix}__icon`,
    noIcon: `${$8f40ff547e3f0696$var$prefix}__no-icon`
};
const $8f40ff547e3f0696$export$b0ee08fae091706a = {
    infoPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).INFO}]`,
    notePanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).NOTE}]`,
    warningPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).WARNING}]`,
    errorPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).ERROR}]`,
    successPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $8f40ff547e3f0696$var$getIconStyles = (panelType)=>{
    return `
		.${$8f40ff547e3f0696$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
			color: ${$8f40ff547e3f0696$var$lightIconColor[panelType]};
		}
	`;
};
const $8f40ff547e3f0696$export$8099afddf1b1be78 = (panelType)=>$8f40ff547e3f0696$var$lightPanelColors[panelType] || 'none';
const $8f40ff547e3f0696$export$dd3f0fd482ae7ccc = (panelType)=>(0, $kZPQ0.hexToEditorBackgroundPaletteColor)($8f40ff547e3f0696$var$lightPanelColors[panelType]) || 'none';
const $8f40ff547e3f0696$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$8f40ff547e3f0696$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $8f40ff547e3f0696$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $1NIU8.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $7yBx7.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).INFO), " .", $8f40ff547e3f0696$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}", (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') ? `.${$8f40ff547e3f0696$export$6dd740b6c888e050.content} .${$8f40ff547e3f0696$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : '', " &[data-panel-type='", (0, $ePdnq.PanelType).INFO, "']{", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).INFO), ";}&[data-panel-type='", (0, $ePdnq.PanelType).NOTE, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).NOTE), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).NOTE), ";}&[data-panel-type='", (0, $ePdnq.PanelType).TIP, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).TIP), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).TIP), ";}&[data-panel-type='", (0, $ePdnq.PanelType).WARNING, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).WARNING), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).WARNING), ";}&[data-panel-type='", (0, $ePdnq.PanelType).ERROR, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).ERROR), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).ERROR), ";}&[data-panel-type='", (0, $ePdnq.PanelType).SUCCESS, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).SUCCESS), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).SUCCESS), ";}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$8f40ff547e3f0696$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $8f40ff547e3f0696$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$8f40ff547e3f0696$export$6dd740b6c888e050.prefix}`]: $8f40ff547e3f0696$export$d707b378cb63679a()
    });

});

parcelRegister("lhPrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2db0d473b67ee2b7dfc80ce4f694c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f315edef134345$var$_react = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7f315edef134345$var$_emoji = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("euu4D")));

var $f7f315edef134345$var$_emoji2 = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("gF0HQ")));
function $f7f315edef134345$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f315edef134345$var$EmojiIcon = (props)=>/*#__PURE__*/ $f7f315edef134345$var$_react.default.createElement($f7f315edef134345$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $f7f315edef134345$var$_emoji2.default
    }, props));
$f7f315edef134345$var$EmojiIcon.Name = 'EmojiIconMigration';
var $f7f315edef134345$var$_default = module.exports.default = $f7f315edef134345$var$EmojiIcon;

});
parcelRegister("euu4D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8cb3213f8552b4b$var$_react = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a8cb3213f8552b4b$var$_baseNew = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a8cb3213f8552b4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8cb3213f8552b4b$var$EmojiIcon = (props)=>/*#__PURE__*/ $a8cb3213f8552b4b$var$_react.default.createElement($a8cb3213f8552b4b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$a8cb3213f8552b4b$var$EmojiIcon.displayName = 'EmojiIcon';
var $a8cb3213f8552b4b$var$_default = module.exports.default = $a8cb3213f8552b4b$var$EmojiIcon;

});

parcelRegister("gF0HQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21105e2bf1e9d5b$var$_react = $c21105e2bf1e9d5b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c21105e2bf1e9d5b$var$_emoji = $c21105e2bf1e9d5b$var$_interopRequireDefault((parcelRequire("euu4D")));
function $c21105e2bf1e9d5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c21105e2bf1e9d5b$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $c21105e2bf1e9d5b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props, {
        newIcon: $c21105e2bf1e9d5b$var$_emoji.default
    }));
$c21105e2bf1e9d5b$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $c21105e2bf1e9d5b$var$_default = module.exports.default = $c21105e2bf1e9d5b$var$EditorEmojiIcon;

});


parcelRegister("dkTgd", function(module, exports) {

$parcel$export(module.exports, "PanelErrorIcon", () => $b3ff119bcd5893cd$export$76fa6c311f4e2871);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $b3ff119bcd5893cd$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $b3ff119bcd5893cd$export$76fa6c311f4e2871 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $b3ff119bcd5893cd$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("35vki", function(module, exports) {

$parcel$export(module.exports, "PanelInfoIcon", () => $cc40bb8be77074e6$export$2187dc2d495c3efc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $cc40bb8be77074e6$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $cc40bb8be77074e6$export$2187dc2d495c3efc = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $cc40bb8be77074e6$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("cH4bN", function(module, exports) {

$parcel$export(module.exports, "PanelNoteIcon", () => $5c8972d1e5b87c27$export$d4f894f0c3f0db6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5c8972d1e5b87c27$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $5c8972d1e5b87c27$export$d4f894f0c3f0db6 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $5c8972d1e5b87c27$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("2r7GW", function(module, exports) {

$parcel$export(module.exports, "PanelSuccessIcon", () => $1afdcee6e1f3b6cc$export$a5a5162e21242c3c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $1afdcee6e1f3b6cc$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $1afdcee6e1f3b6cc$export$a5a5162e21242c3c = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $1afdcee6e1f3b6cc$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("clzOA", function(module, exports) {

$parcel$export(module.exports, "PanelWarningIcon", () => $772f3f472f7c2a19$export$246c5468186717b7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $772f3f472f7c2a19$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $772f3f472f7c2a19$export$246c5468186717b7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $772f3f472f7c2a19$var$PanelWarningGlyph,
        ...props
    });
};

});


parcelRegister("LiaMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff1bb9ffafc4e03c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghHlh = parcelRequire("ghHlh");

var $eUaD0 = parcelRequire("eUaD0");

var $eGOwo = parcelRequire("eGOwo");

var $8KqmO = parcelRequire("8KqmO");
var $ff1bb9ffafc4e03c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)(function Status(props) {
    const { text: text, color: color, localId: localId } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...inlineAnnotationProps,
        role: 'emphasis',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghHlh.Status), {
                text: text,
                color: color,
                localId: localId,
                role: undefined,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh')
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
        data: {
            userContext: 'document'
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghHlh.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh')
            })
        })
    });
});

});
parcelRegister("ghHlh", function(module, exports) {

$parcel$export(module.exports, "Status", () => $0768993856a47129$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $4J0ad = parcelRequire("4J0ad");

var $l9Hbg = parcelRequire("l9Hbg");

const $0768993856a47129$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $0768993856a47129$var$DEFAULT_APPEARANCE = 'default';
const $0768993856a47129$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $0768993856a47129$var$inlineBlockStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $0768993856a47129$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $0768993856a47129$var$StatusInternal extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'StatusInternal';
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $0768993856a47129$var$colorToLozengeAppearanceMap[color] || $0768993856a47129$var$DEFAULT_APPEARANCE;
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hcewu.default)([
                $0768993856a47129$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                maxWidth: $0768993856a47129$var$MAX_WIDTH,
                isBold: isBold,
                children: text
            })
        });
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $234b7ac352310435$export$7452d7062a4d0634) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $0768993856a47129$export$96e9906d6d93a972 = (0, $4J0ad.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $l9Hbg.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $l9Hbg.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($0768993856a47129$var$StatusInternal);

});
parcelRegister("l9Hbg", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $4a06859375ef2dec$export$aa98853957f9f5aa);
const $4a06859375ef2dec$export$d821aa4c8afb384e = 'fabric-elements';
const $4a06859375ef2dec$var$packageName = "platform-pkg";
const $4a06859375ef2dec$var$packageVersion = "0.0.0-use.local";
const $4a06859375ef2dec$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $4a06859375ef2dec$var$packageName;
        statusPayload.attributes.packageVersion = $4a06859375ef2dec$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($4a06859375ef2dec$export$d821aa4c8afb384e);
        return event;
    };

});

const $234b7ac352310435$export$7452d7062a4d0634 = 1000;



parcelRegister("MUFrj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5694c83ed8520b5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $33824 = parcelRequire("33824");

var $eUaD0 = parcelRequire("eUaD0");

var $51MtK = parcelRequire("51MtK");
class $f5694c83ed8520b5$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51MtK.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51MtK.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $33824.default), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("33824", function(module, exports) {

$parcel$export(module.exports, "default", () => $373a7a89ce56c03e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7VA4p = parcelRequire("7VA4p");
function $373a7a89ce56c03e$export$2e2bcd8739ae039(props) {
    const { contextIdentifierProvider: contextIdentifierProvider, objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch (err) {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7VA4p.default), {
        ...otherProps,
        objectAri: resolvedObjectId,
        isRenderer: isRenderer
    });
}

});
parcelRegister("7VA4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $f384e712381868c5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kJy0l = parcelRequire("kJy0l");

var $eUaD0 = parcelRequire("eUaD0");
class $f384e712381868c5$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    constructor(props){
        super(props), this.mounted = false, this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        }, this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        }, this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJy0l.default), {
                isDone: isDone,
                isRenderer: isRenderer,
                isFocused: isFocused,
                taskId: taskId,
                onChange: this.handleOnChange,
                onClick: this.handleOnClick,
                appearance: appearance,
                contentRef: contentRef,
                showPlaceholder: showPlaceholder,
                placeholder: placeholder,
                disabled: disabled,
                dataAttributes: dataAttributes,
                inputRef: inputRef,
                children: children
            })
        });
    }
}

});
parcelRegister("kJy0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c1a691111a34ce$export$2e2bcd8739ae039);
/* TaskItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5EfQi = parcelRequire("5EfQi");

var $hagIH = parcelRequire("hagIH");

var $7h0lN = parcelRequire("7h0lN");

var $6BQTj = parcelRequire("6BQTj");

var $4J0ad = parcelRequire("4J0ad");

var $7pdp2 = parcelRequire("7pdp2");

var $82KGI = parcelRequire("82KGI");
const $f5c1a691111a34ce$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5EfQi.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        type: 'core',
        ...props
    });
/**
 * References packages/design-system/checkbox/src/checkbox.tsx
 * To be used until mobile editor does not require legacy themed() API anymore,
 * which will allow migration to use @atlaskit/checkbox instead
 */ const $f5c1a691111a34ce$var$checkboxStyles = null;
let $f5c1a691111a34ce$var$taskCount = 0;
const $f5c1a691111a34ce$var$getCheckBoxId = (localId)=>`${localId}-${$f5c1a691111a34ce$var$taskCount++}`;
const $f5c1a691111a34ce$var$TaskItem = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const checkBoxId = (0, $eJOHy.useMemo)(()=>$f5c1a691111a34ce$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $eJOHy.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $7pdp2.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $eJOHy.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $eJOHy.useRef)(null);
    const inputRef = (0, $82KGI.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        contentEditable: false,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1tcg _1bsb1tcg _4t3i1tcg _kqswh2mm _1wpzv2br _1snx1r31 _1746glyw _dx3f1o36 _1h5xidpf _sqizidpf _fs2cidpf _1smcidpf _oezm15vq _1l0615vq _1abj1mn3 _18a711so _16np1elr _a27kkb7n _q3p7usvi _qhqx1nu9 _10cr1ssb _zfav1ssb _m7eu1ooe _l9o0n7od _1efjn7od _1u2istnw _32ro1j9a _1wn015vq _den5ugt7 _zh8l1b66 _g5w3stnw _whhepxbi _1stbpxbi _18tob3bt _1awt1ule _haf81ssb _ra781ssb _cr751ooe _1q8r7vkz _9l2s7vkz _1mh7kb7n _s3uktlke _1davidpf _8bo8stnw _psnc1ssb _4k421ssb _1rvv1ooe _13vl73ad _1t711tcg _1nuz1tcg _cs4qstnw _9j2j1ssb _1mwj1ssb _19l51ooe _12yy1d5g _1miy1elr _1umo18hz _tpz25w2r _k6dg18hz _1qduewfl _q8ft1fvw _1y9t5w2r _ut031fvw _gi9hr01l _1qp6muej _wxkgr01l _wo245w2r _c8dpmuej _d2dcsyzs _1eulsyzs _1bc7syzs _16fmsyzs _bhkusyzs _czfesyzs _1gxgsyzs _19w0syzs _1x1y1lg7"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                id: checkBoxId,
                "aria-label": formatMessage(isDone ? (0, $7h0lN.messages).markTaskAsNotCompleted : (0, $7h0lN.messages).markTaskAsCompleted),
                name: checkBoxId,
                type: "checkbox",
                onChange: handleOnChange,
                onClick: onClick,
                checked: !!isDone,
                disabled: !!disabled,
                suppressHydrationWarning: true,
                onKeyPress: handleOnKeyPress,
                ref: inputRef
            }),
            isDone ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hagIH))), {
                label: ""
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)($f5c1a691111a34ce$var$CheckboxUncheckedIcon, {
                label: ""
            })
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BQTj.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId,
        children: children
    });
};
var $f5c1a691111a34ce$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($f5c1a691111a34ce$var$TaskItem);

});
parcelRegister("hagIH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7f057169373f605$var$_react = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c7f057169373f605$var$_baseNew = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c7f057169373f605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7f057169373f605$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $c7f057169373f605$var$_react.default.createElement($c7f057169373f605$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$c7f057169373f605$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $c7f057169373f605$var$_default = module.exports.default = $c7f057169373f605$var$CheckboxCheckedIcon;

});

parcelRegister("7h0lN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e47ea32d041ea095$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e47ea32d041ea095$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fieldsetLabel: {
        id: 'fabric.editor.fieldsetLabel',
        defaultMessage: 'Action Item List',
        description: 'Label for a list of tasks/ action items'
    },
    markTaskAsCompleted: {
        id: 'platform.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'platform.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    }
});

});

parcelRegister("7pdp2", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $9dde8a4521254c42$export$53eef0dcd9611650);

var $5fWw9 = parcelRequire("5fWw9");
const $9dde8a4521254c42$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $9dde8a4521254c42$export$53eef0dcd9611650 = (0, $5fWw9.default)($9dde8a4521254c42$export$7ba5d2eed2cf9f14);

});





parcelRegister("lu3aG", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ad49ccc2cb2822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kiT34 = parcelRequire("kiT34");
class $67ad49ccc2cb2822$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $eJOHy.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kiT34.default), {
            listId: localId,
            children: children
        });
    }
}

});
parcelRegister("kiT34", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ac385d690279893$export$2e2bcd8739ae039);
/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $7h0lN = parcelRequire("7h0lN");

var $lRq8t = parcelRequire("lRq8t");
const $9ac385d690279893$var$listStyles = null;
const $9ac385d690279893$var$taskListStyles = null;
const $9ac385d690279893$var$TaskList = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!children) return null;
    // Data attributes are required for copy and paste from rendered content
    // to the editor to preserve the task.
    // This allows the editor to differentiate between numbered and ordered lists,
    // and action items, which all share the common '‹li›' element.
    // The value of 'data-task-local-id' should be discarded upon paste, with a
    // a new uuid generated by the editor for the cloned content.
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $7h0lN.messages).fieldsetLabel),
        className: (0, $hcewu.default)([
            "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $hcewu.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
var $9ac385d690279893$export$2e2bcd8739ae039 = $9ac385d690279893$var$TaskList;

});


parcelRegister("dF4iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d18e2bd4aa58df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $8DkU8 = parcelRequire("8DkU8");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $fRBiY = parcelRequire("fRBiY");

var $cQxBL = parcelRequire("cQxBL");

var $k71qx = parcelRequire("k71qx");

var $9UJzd = parcelRequire("9UJzd");

var $6YFG2 = parcelRequire("6YFG2");

var $7ueoK = parcelRequire("7ueoK");

var $jzI2h = parcelRequire("jzI2h");
function $03d18e2bd4aa58df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $03d18e2bd4aa58df$var$titleStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $7yBx7.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $03d18e2bd4aa58df$var$containerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, transparent)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 0.25rem)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $03d18e2bd4aa58df$var$containerStylesExpanded = {
    name: "1ynzp6s",
    styles: "background:var(--ds-surface, rgba(255, 255, 255, 0.6));padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #091E4224)"
};
const $03d18e2bd4aa58df$var$containerStylesFocused = {
    name: "12e71wc",
    styles: "border-color:var(--ds-border-focused, #388BFF)"
};
const $03d18e2bd4aa58df$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $7yBx7.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $7yBx7.akLayoutGutterOffset)}px`
});
const $03d18e2bd4aa58df$var$titleContainerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #44546F)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $03d18e2bd4aa58df$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
const $03d18e2bd4aa58df$var$contentContainerStyles = {
    name: "288te1",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);display:flow-root;visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
const $03d18e2bd4aa58df$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $03d18e2bd4aa58df$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
const $03d18e2bd4aa58df$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $03d18e2bd4aa58df$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $03d18e2bd4aa58df$var$containerStyles,
            props['data-node-type'] === 'expand' && $03d18e2bd4aa58df$var$containerStylesDataNodeTypeExpand,
            props.expanded && $03d18e2bd4aa58df$var$containerStylesExpanded,
            props.focused && $03d18e2bd4aa58df$var$containerStylesFocused
        ],
        ...props
    }, props.children);
};
const $03d18e2bd4aa58df$var$TitleContainer = (props)=>{
    const { expanded: expanded, ...buttonProps } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        type: "button",
        css: [
            $03d18e2bd4aa58df$var$titleContainerStyles,
            expanded && $03d18e2bd4aa58df$var$titleContainerStylesExpanded
        ],
        ...buttonProps
    }, props.children));
};
$03d18e2bd4aa58df$var$TitleContainer.displayName = 'TitleContainerButton';
const $03d18e2bd4aa58df$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $03d18e2bd4aa58df$var$contentContainerStyles,
            props.expanded && $03d18e2bd4aa58df$var$contentContainerStylesExpanded,
            !props.expanded && $03d18e2bd4aa58df$var$contentContainerStylesNotExpanded
        ],
        ...props
    }, props.children);
};
function $03d18e2bd4aa58df$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $bMFKb.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $bMFKb.ACTION_SUBJECT).EXPAND : (0, $bMFKb.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $7ueoK.PLATFORM).WEB,
            mode: (0, $7ueoK.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    });
}
function $03d18e2bd4aa58df$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, nestedHeaderIds: nestedHeaderIds, rendererAppearance: rendererAppearance }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $8DkU8.messages).collapseNode : (0, $8DkU8.messages).expandNode);
    const { current: id } = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))('expand-title-'));
    const handleFocus = (0, $eJOHy.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $eJOHy.useCallback)(()=>setFocused(false), []);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jzI2h.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>setExpanded(true)
    }) : null, /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$TitleContainer, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $03d18e2bd4aa58df$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            setExpanded(!expanded);
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8DkU8.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fRBiY))),
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $8DkU8.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8DkU8.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fRBiY))),
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $03d18e2bd4aa58df$var$titleStyles,
        id: id
    }, title || intl.formatMessage((0, $8DkU8.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$ContentContainer, {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: `${nodeType}-content-wrapper`
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $03d18e2bd4aa58df$var$clearNextSiblingMarginTopStyle
    }), children))));
}
var $03d18e2bd4aa58df$export$2e2bcd8739ae039 = (0, $6YFG2.default)($03d18e2bd4aa58df$var$Expand);

});
parcelRegister("8DkU8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1e29c793325cc73a$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $1e29c793325cc73a$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $1e29c793325cc73a$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $1e29c793325cc73a$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7qGN1 = parcelRequire("7qGN1");

var $7yBx7 = parcelRequire("7yBx7");
function $1e29c793325cc73a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e29c793325cc73a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'Collapse the node'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text for an expand node'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'Expand the node'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    }
});
const $1e29c793325cc73a$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: ()=>expanded ? [
                $1e29c793325cc73a$var$expandIconWrapperStyle(),
                $1e29c793325cc73a$var$expandIconWrapperExpandedStyle
            ] : $1e29c793325cc73a$var$expandIconWrapperStyle()
    }, children);
};
const $1e29c793325cc73a$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7yBx7.akEditorSwoopCubicBezier)}`
        }
    });
const $1e29c793325cc73a$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $1e29c793325cc73a$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $1e29c793325cc73a$export$c67faf67c1185cba = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $1e29c793325cc73a$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});

});

parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});






$parcel$global.rlb("2tXQt")
//# sourceMappingURL=view-old.1fcb5ef9.js.map
